
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6070"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6070"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6rwPB", function(module, exports) {
module.exports = import("./de.f90995f2.js").then(()=>parcelRequire('5X8QQ'));

});

parcelRegister("iviQo", function(module, exports) {
module.exports = import("./en.e0d657c8.js").then(()=>parcelRequire('jlK6H'));

});

parcelRegister("4fdAD", function(module, exports) {
module.exports = import("./es.bd4f83ff.js").then(()=>parcelRequire('3olJO'));

});

parcelRegister("2bXCi", function(module, exports) {
module.exports = import("./fi.b3aca115.js").then(()=>parcelRequire('b2bZT'));

});

parcelRegister("3S6d7", function(module, exports) {
module.exports = import("./zh.609e4396.js").then(()=>parcelRequire('fz81j'));

});

/**
 * Enhanced Internationalization module
 * 
 * Features:
 * - Lazy loading of translations
 * - Translation memory (localStorage)
 * - Translation testing
 */ /**
 * Language index
 * 
 * This file is dynamically generated by 'manage_translations.py'.
 * Do not edit this file manually, as your changes will be overwritten.
 */ // Lightweight logging utility for techno_punks Terminal
// Allows enabling/disabling of debug-level logs globally via CONFIG.debug flag or window.__DEBUG__
// Usage:
//   import logger from './logger.js';
//   logger.debug('Only shows when debug enabled');
//   logger.info('Always visible');
//   logger.error('Always visible, alias of console.error');
/**
 * Terminal Configuration
 * 
 * Central configuration object for the techno_punks Terminal application.
 * Contains version information, user settings, and available commands.
 */ // Default configuration
const $b1294981df4c9a64$var$CONFIG = {
    version: 'v0.8.1',
    username: 'anonymous',
    hostname: 'techno_punks',
    availableCommands: [
        'about',
        'project',
        'minting',
        'roadmap',
        'team',
        'links',
        'legal',
        'language',
        'cursor'
    ],
    cursorStyle: 'underscore',
    debug: false // Global debug flag; set to true to enable verbose logging
};
// --- Prompt Formatting ---
const $b1294981df4c9a64$var$formatPrompt = (username)=>`> ${username}: `;
const $b1294981df4c9a64$export$1613a8bb42ebacf3 = {
    DEFAULT: $b1294981df4c9a64$var$formatPrompt($b1294981df4c9a64$var$CONFIG.username),
    ANONYMOUS: $b1294981df4c9a64$var$formatPrompt('anonymous'),
    PASSWORD: 'Password: '
};
var $b1294981df4c9a64$export$2e2bcd8739ae039 = $b1294981df4c9a64$var$CONFIG;


// Determine if debug logging is enabled
function $9bb4c1574855072f$var$isDebugEnabled() {
    // Priority: explicit global override > config flag > environment variable
    if (typeof window !== 'undefined' && typeof window.__DEBUG__ === 'boolean') return window.__DEBUG__;
    if (typeof (0, $b1294981df4c9a64$export$2e2bcd8739ae039) !== 'undefined' && typeof (0, $b1294981df4c9a64$export$2e2bcd8739ae039).debug === 'boolean') return (0, $b1294981df4c9a64$export$2e2bcd8739ae039).debug;
    // Fallback: check NODE_ENV (when bundled with rollup/webpack this may get inlined)
    if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV) return process.env.NODE_ENV !== 'production';
    return false;
}
// Basic formatter to keep logs consistent
function $9bb4c1574855072f$var$format(prefix, args) {
    // eslint-disable-next-line prefer-spread
    return [
        `[%c${prefix}%c]`,
        'color: #03A9F4; font-weight:bold;',
        'color:inherit;',
        ...args
    ];
}
const $9bb4c1574855072f$var$logger = {
    debug: (...args)=>{
        if ($9bb4c1574855072f$var$isDebugEnabled()) // eslint-disable-next-line no-console
        console.debug.apply(console, $9bb4c1574855072f$var$format('DEBUG', args));
    },
    info: (...args)=>{
        // eslint-disable-next-line no-console
        console.info.apply(console, $9bb4c1574855072f$var$format('INFO', args));
    },
    warn: (...args)=>{
        // eslint-disable-next-line no-console
        console.warn.apply(console, $9bb4c1574855072f$var$format('WARN', args));
    },
    error: (...args)=>{
        // eslint-disable-next-line no-console
        console.error.apply(console, $9bb4c1574855072f$var$format('ERROR', args));
    }
};
var $9bb4c1574855072f$export$2e2bcd8739ae039 = $9bb4c1574855072f$var$logger;


const $4cb801fed3390ba3$export$4981bf31807628a3 = {
    de: {
        name: 'German',
        nativeName: 'Deutsch'
    },
    en: {
        name: 'English',
        nativeName: 'English',
        isDefault: true
    },
    es: {
        name: 'Spanish',
        nativeName: "Espa\xf1ol"
    },
    fi: {
        name: 'fi',
        nativeName: 'fi'
    },
    zh: {
        name: 'Chinese',
        nativeName: "\u4E2D\u6587"
    }
};
// Cache for loaded language modules
const $4cb801fed3390ba3$var$loadedLanguages = {};






async function $4cb801fed3390ba3$export$f02cbd868e2f57cf(lang) {
    if ($4cb801fed3390ba3$var$loadedLanguages[lang]) return $4cb801fed3390ba3$var$loadedLanguages[lang];
    let module;
    try {
        switch(lang){
            case 'de':
                module = await (parcelRequire("6rwPB"));
                break;
            case 'en':
                module = await (parcelRequire("iviQo"));
                break;
            case 'es':
                module = await (parcelRequire("4fdAD"));
                break;
            case 'fi':
                module = await (parcelRequire("2bXCi"));
                break;
            case 'zh':
                module = await (parcelRequire("3S6d7"));
                break;
            default:
                // Fallback to English for any language not explicitly handled
                (0, $9bb4c1574855072f$export$2e2bcd8739ae039).warn(`Language '${lang}' not found, falling back to 'en'.`);
                module = await (parcelRequire("iviQo"));
                lang = 'en'; // Ensure we cache under the correct key
                break;
        }
        // Handle cases where a bundler might not put the JSON behind a .default
        const translations = module.default || module;
        $4cb801fed3390ba3$var$loadedLanguages[lang] = translations;
        return translations;
    } catch (error) {
        (0, $9bb4c1574855072f$export$2e2bcd8739ae039).error(`Failed to load language module for: ${lang}`, error);
        // Final fallback in case of a critical import error
        if (lang !== 'en') {
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).warn(`Falling back to English due to error.`);
            return $4cb801fed3390ba3$export$f02cbd868e2f57cf('en');
        }
        return {};
    }
}
function $4cb801fed3390ba3$export$55ad08b0fe72e380() {
    for (const [code, meta] of Object.entries($4cb801fed3390ba3$export$4981bf31807628a3)){
        if (meta.isDefault) return code;
    }
    return 'en'; // Fallback to English if no default is specified
}
function $4cb801fed3390ba3$export$1b0630378b791f98(lang) {
    return !!$4cb801fed3390ba3$export$4981bf31807628a3[lang];
}


/**
 * Event bus system for component communication
 * 
 * Provides a centralized event system with debugging capabilities
 */ 
class $71235d8e4bbe5195$export$5087227eb54526 {
    constructor(){
        this.events = {};
        this.history = [];
        this.maxHistoryLength = 100;
        this.debugMode = false;
    }
    /**
   * Subscribe to an event
   * @param {string} event - Event name
   * @param {Function} callback - Function to call when event is emitted
   * @returns {Function} Unsubscribe function
   */ on(event, callback) {
        if (!this.events[event]) this.events[event] = [];
        (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug(`[EventBus] Subscribed to '${event}', current listeners: ${this.events[event].length + 1}`);
        this.events[event].push(callback);
        // Return unsubscribe function
        return ()=>this.off(event, callback);
    }
    /**
   * Subscribe to an event, but only trigger once
   * @param {string} event - Event name
   * @param {Function} callback - Function to call when event is emitted
   * @returns {Function} Unsubscribe function
   */ once(event, callback) {
        const onceWrapper = (data)=>{
            callback(data);
            this.off(event, onceWrapper);
        };
        return this.on(event, onceWrapper);
    }
    /**
   * Unsubscribe from an event
   * @param {string} event - Event name
   * @param {Function} callback - Function to remove
   */ off(event, callback) {
        if (!this.events[event]) return;
        const initialLength = this.events[event].length;
        this.events[event] = this.events[event].filter((cb)=>cb !== callback);
        if (initialLength !== this.events[event].length) (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug(`[EventBus] Unsubscribed from '${event}', remaining listeners: ${this.events[event].length}`);
    }
    /**
   * Emit an event with data
   * @param {string} event - Event name
   * @param {any} data - Data to pass to event handlers
   */ emit(event, data) {
        (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug(`[EventBus] Event '${event}' emitted:`, data);
        // Record in history
        this.recordEvent(event, data);
        if (!this.events[event]) {
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug(`[EventBus] Event '${event}' emitted but no listeners registered`);
            return;
        }
        // Create a copy of listeners array in case handlers modify it during iteration
        const listeners = [
            ...this.events[event]
        ];
        listeners.forEach((callback)=>{
            try {
                callback(data);
            } catch (error) {
                (0, $9bb4c1574855072f$export$2e2bcd8739ae039).error(`[EventBus] Error in event handler for '${event}':`, error);
            }
        });
    }
    /**
   * Record event in history
   * @private
   * @param {string} event - Event name
   * @param {any} data - Event data
   */ recordEvent(event, data) {
        // Only record if in debug mode
        if (!this.debugMode) return;
        this.history.push({
            event: event,
            data: data,
            timestamp: new Date().toISOString()
        });
        // Keep history at reasonable size
        if (this.history.length > this.maxHistoryLength) this.history.shift();
    }
    /**
   * Get event history
   * @returns {Array} Event history
   */ getEventHistory() {
        return [
            ...this.history
        ];
    }
    /**
   * Clear event history
   */ clearEventHistory() {
        this.history = [];
    }
    /**
   * Get count of listeners for an event
   * @param {string} event - Event name
   * @returns {number} Number of listeners
   */ listenerCount(event) {
        return this.events[event]?.length || 0;
    }
    /**
   * Enable or disable debug mode
   * @param {boolean} enabled - Whether debug mode should be enabled
   */ setDebugMode(enabled) {
        this.debugMode = !!enabled;
        (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug(`[EventBus] Debug mode ${this.debugMode ? 'enabled' : 'disabled'}`);
    }
}
// Create a global event bus
let $71235d8e4bbe5195$var$globalEventBus;
if (window.__globalEventBus) $71235d8e4bbe5195$var$globalEventBus = window.__globalEventBus;
else {
    $71235d8e4bbe5195$var$globalEventBus = new $71235d8e4bbe5195$export$5087227eb54526();
    $71235d8e4bbe5195$var$globalEventBus._debugId = Math.floor(Math.random() * 1000000);
    window.eventBus = $71235d8e4bbe5195$var$globalEventBus;
    window.__globalEventBus = $71235d8e4bbe5195$var$globalEventBus;
}
const $71235d8e4bbe5195$export$f6644f0f2c90144b = $71235d8e4bbe5195$var$globalEventBus;



// No legacy translations import needed anymore
class $7949ccdcb80a1a11$var$I18n {
    constructor(){
        // Initialize properties
        this.currentLanguage = (0, $4cb801fed3390ba3$export$55ad08b0fe72e380)();
        this.translations = {};
        this.loadedLanguages = new Set();
        this.isReady = false;
    }
    /**
   * Initialize language based on stored preference or browser settings
   */ async init() {
        // Try to load from localStorage first
        let storedLang = null;
        try {
            storedLang = localStorage.getItem('techno_punks_language');
        } catch (e) {
            // private mode or blocked storage
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).warn('localStorage unavailable while reading language preference:', e);
        }
        if (storedLang && (0, $4cb801fed3390ba3$export$1b0630378b791f98)(storedLang)) this.currentLanguage = storedLang;
        else {
            // Fall back to browser language if available
            const browserLang = navigator.language.split('-')[0];
            if ((0, $4cb801fed3390ba3$export$1b0630378b791f98)(browserLang)) this.currentLanguage = browserLang;
        }
        // Set global variable for access in templates (guard window)
        if (typeof window !== 'undefined') window.currentLanguage = this.currentLanguage;
        // Load the current language
        await this.loadTranslationsForLanguage(this.currentLanguage);
        // Also preload English as fallback
        if (this.currentLanguage !== 'en') this.loadTranslationsForLanguage('en', false); // Load in background
        // Set ready flag and emit event
        this.isReady = true;
        (0, $71235d8e4bbe5195$export$f6644f0f2c90144b).emit('i18n:ready', {
            language: this.currentLanguage
        });
    }
    /**
   * Load translations for a specific language
   * @param {string} lang - Language code to load
   * @param {boolean} setAsCurrent - Whether to set as current language
   * @returns {Promise<Object>} - The loaded translations
   */ async loadTranslationsForLanguage(lang, setAsCurrent = true) {
        if (!(0, $4cb801fed3390ba3$export$1b0630378b791f98)(lang)) {
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).warn(`Language ${lang} is not available, falling back to default`);
            lang = (0, $4cb801fed3390ba3$export$55ad08b0fe72e380)();
        }
        // If already loaded, return immediately
        if (this.loadedLanguages.has(lang)) {
            if (setAsCurrent) {
                this.currentLanguage = lang;
                if (typeof window !== 'undefined') window.currentLanguage = lang;
            }
            return this.translations[lang];
        }
        try {
            // Load the language module
            const translations = await (0, $4cb801fed3390ba3$export$f02cbd868e2f57cf)(lang);
            // Store the translations
            this.translations[lang] = translations;
            this.loadedLanguages.add(lang);
            if (setAsCurrent) {
                this.currentLanguage = lang;
                if (typeof window !== 'undefined') window.currentLanguage = lang;
            }
            return translations;
        } catch (error) {
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).warn(`Failed to load language file: ${lang}`, error);
            // If the language couldn't be loaded, try to fall back to English
            if (lang !== 'en') {
                (0, $9bb4c1574855072f$export$2e2bcd8739ae039).info(`Falling back to English`);
                return this.loadTranslationsForLanguage('en', false);
            }
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).error(`No translations available for ${lang}`);
            return null;
        }
    }
    /**
   * Get translation for a key
   * @param {string} key - Translation key (dot notation for nested keys)
   * @param {Object} params - Parameters to replace in the translation
   * @returns {string} - Translated text
   */ t(key, params = {}) {
        if (!this.isReady) {
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).warn(`[t] Attempted to translate '${key}' before i18n is ready. Returning key.`);
            return key;
        }
        const lang = this.currentLanguage;
        const fallbackLang = 'en';
        const langData = this.translations[lang] || this.translations[fallbackLang];
        if (!langData) {
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).warn(`[t] No translation data found for current language '${lang}' or fallback '${fallbackLang}'. Full translations object:`, this.translations);
            return key;
        }
        let translation = key.split('.').reduce((obj, k)=>obj && obj[k] !== undefined ? obj[k] : undefined, langData);
        if (translation === undefined && lang !== fallbackLang && this.loadedLanguages.has(fallbackLang)) translation = key.split('.').reduce((obj, k)=>obj && obj[k] !== undefined ? obj[k] : undefined, this.translations[fallbackLang]);
        if (translation === undefined) {
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).warn(`[t] Missing translation for key: '${key}' in language: '${lang}'.`);
            return key;
        }
        if (params && typeof translation === 'string') Object.keys(params).forEach((param)=>{
            // Replace both single-brace `{param}` and double-brace `{{param}}` placeholders.
            translation = translation.replace(new RegExp(`\\{\\{\\s*${param}\\s*\\}\\}`, 'g'), params[param]).replace(new RegExp(`\\{${param}\\}`, 'g'), params[param]);
        });
        return translation;
    }
    /**
   * Set the current language
   * @param {string} lang - Language code
   * @returns {Promise<boolean>} - Success status
   */ async setLanguage(lang) {
        if (!(0, $4cb801fed3390ba3$export$1b0630378b791f98)(lang)) return false;
        try {
            // Load the language if not already loaded
            await this.loadTranslationsForLanguage(lang);
            // Store the preference in localStorage
            try {
                localStorage.setItem('techno_punks_language', lang);
            } catch (e) {
                (0, $9bb4c1574855072f$export$2e2bcd8739ae039).warn('localStorage unavailable while saving language preference:', e);
            }
            // Emit event for language change
            (0, $71235d8e4bbe5195$export$f6644f0f2c90144b).emit('language:changed', {
                language: lang
            });
            return true;
        } catch (error) {
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).error(`Failed to set language to ${lang}`, error);
            return false;
        }
    }
    /**
   * Get the current language
   * @returns {string} Current language code
   */ getLanguage() {
        return this.currentLanguage;
    }
    /**
   * Get list of available languages
   * @returns {Array<Object>} List of language objects with code and name
   */ getAvailableLanguages() {
        return Object.entries((0, $4cb801fed3390ba3$export$4981bf31807628a3)).map(([code, meta])=>({
                code: code,
                name: meta.name,
                nativeName: meta.nativeName,
                isDefault: !!meta.isDefault
            }));
    }
    /**
   * Test translations for completeness
   * @param {string} targetLang - Language to test
   * @param {string} baseLang - Base language to compare against (default: 'en')
   * @returns {Promise<Object>} - Test results
   */ async testTranslations(targetLang, baseLang = 'en') {
        // Make sure both languages are loaded
        await Promise.all([
            this.loadTranslationsForLanguage(targetLang, false),
            this.loadTranslationsForLanguage(baseLang, false)
        ]);
        const baseTranslations = this.translations[baseLang];
        const targetTranslations = this.translations[targetLang];
        if (!baseTranslations || !targetTranslations) throw new Error(`Could not load translations for testing`);
        const missingKeys = [];
        const extraKeys = [];
        // Check for missing keys
        function checkKeys(baseObj, targetObj, path = '') {
            for(const key in baseObj){
                const currentPath = path ? `${path}.${key}` : key;
                if (typeof baseObj[key] === 'object' && baseObj[key] !== null && !Array.isArray(baseObj[key])) {
                    // It's a nested object, recurse
                    if (!targetObj[key] || typeof targetObj[key] !== 'object') missingKeys.push(currentPath);
                    else checkKeys(baseObj[key], targetObj[key], currentPath);
                } else // It's a leaf value
                if (targetObj[key] === undefined) missingKeys.push(currentPath);
            }
        }
        // Check for extra keys
        function checkExtraKeys(targetObj, baseObj, path = '') {
            for(const key in targetObj){
                const currentPath = path ? `${path}.${key}` : key;
                if (typeof targetObj[key] === 'object' && targetObj[key] !== null && !Array.isArray(targetObj[key])) {
                    // It's a nested object, recurse
                    if (!baseObj[key] || typeof baseObj[key] !== 'object') extraKeys.push(currentPath);
                    else checkExtraKeys(targetObj[key], baseObj[key], currentPath);
                } else // It's a leaf value
                if (baseObj[key] === undefined) extraKeys.push(currentPath);
            }
        }
        checkKeys(baseTranslations, targetTranslations);
        checkExtraKeys(targetTranslations, baseTranslations);
        return {
            language: targetLang,
            baseLang: baseLang,
            missingKeys: missingKeys,
            extraKeys: extraKeys,
            isComplete: missingKeys.length === 0,
            completionPercentage: baseTranslations ? (100 - missingKeys.length / Object.keys(baseTranslations).length * 100).toFixed(2) : 0
        };
    }
}
// Create a global translation function for convenience
window.getTranslation = (key, params)=>$7949ccdcb80a1a11$var$i18n.t(key, params);
const $7949ccdcb80a1a11$var$i18n = new $7949ccdcb80a1a11$var$I18n();
var $7949ccdcb80a1a11$export$2e2bcd8739ae039 = $7949ccdcb80a1a11$var$i18n;


/**
 * Command Loader
 * 
 * This module imports all command files and registers them with the command registry.
 * It serves as the central point for command management, ensuring all commands are
 * loaded and available when the application starts.
 */ /**
 * Command Registry
 * 
 * Centralized registry for all terminal commands with enhanced error handling
 * and organization capabilities.
 */ // Import TextFormatter early to avoid circular dependencies
/**
 * Text formatting utilities
 * 
 * Standardizes text formatting for command output from any source
 */ /**
 * Process command output text to standardize format
 * @param {string|Array} input - Raw command output (string from i18n or array)
 * @returns {Array} Standardized array of text lines
 */ function $e13c069528ab01a6$export$271455c1c18a6a86(input) {
    if (!input) return [];
    // If already an array, return it directly
    if (Array.isArray(input)) return input;
    // Handle string input (from i18n or direct returns)
    // Clean up HTML
    const tempDiv = document.createElement('div');
    const contentWithNewlines = input.replace(/<br\s*\/?\s*>/gi, '\n');
    tempDiv.innerHTML = contentWithNewlines;
    const plainText = tempDiv.textContent || tempDiv.innerText || "";
    // Split into lines and process
    const lines = plainText.split('\n');
    // Clean up lines
    const processedLines = [];
    let emptyLineAdded = false;
    lines.forEach((line)=>{
        const trimmedLine = line.trim();
        // Handle empty lines
        if (trimmedLine === '') {
            // Only add one empty line if multiple empty lines are found in sequence
            if (!emptyLineAdded) {
                processedLines.push('');
                emptyLineAdded = true;
            }
            return;
        }
        // Reset empty line flag
        emptyLineAdded = false;
        // Add the processed line
        processedLines.push(trimmedLine);
    });
    return processedLines;
}
var $e13c069528ab01a6$export$2e2bcd8739ae039 = {
    standardizeCommandOutput: $e13c069528ab01a6$export$271455c1c18a6a86
};



class $d12c20e2463c3ec8$var$CommandRegistry {
    constructor(){
        this.commands = {};
        this.commandCategories = {
            'core': [],
            'info': [],
            'tools': [],
            'web3': [],
            'media': [],
            'other': []
        };
    }
    /**
   * Register a new command from a command object.
   * @param {object} command - The command object to register.
   */ register(command) {
        const { name: name, handler: handler, help: help, category: category = 'other', hidden: hidden = false } = command;
        if (!name || typeof name !== 'string' || !handler || typeof handler !== 'function') {
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).error('[CommandRegistry] Invalid command object:', command);
            return;
        }
        const normalizedName = name.toLowerCase().trim();
        this.commands[normalizedName] = command;
        if (!hidden) {
            if (!this.commandCategories[category]) this.commandCategories[category] = [];
            this.commandCategories[category].push(normalizedName);
        }
    }
    /**
   * Get a command handler by name
   * @param {string} name - Command name
   * @returns {Function|null} Command handler or null if not found
   */ getCommand(name) {
        if (!name) return null;
        const normalizedName = name.toLowerCase().trim();
        return this.commands[normalizedName] || null;
    }
    /**
   * Match a hidden command
   * @param {string} input - Command input
   * @returns {Object|null} { handler, input } or null if no match
   */ matchHiddenCommand(input) {
        if (!input) return null;
        const normalizedInput = input.toLowerCase().trim();
        for(const key in this.hiddenCommands){
            if (normalizedInput.startsWith(key)) return {
                handler: this.hiddenCommands[key],
                input: input
            };
        }
        return null;
    }
    /**
   * Get all registered command names
   * @returns {string[]} Array of command names
   */ getAllCommandNames() {
        return Object.keys(this.commands).sort();
    }
    /**
   * Get commands by category
   * @param {string} category - Category name
   * @returns {string[]} Array of command names in that category
   */ getCommandsByCategory(category) {
        return this.commandCategories[category] || [];
    }
    /**
   * Get all categories
   * @returns {string[]} Array of category names
   */ getAllCategories() {
        return Object.keys(this.commandCategories);
    }
    /**
   * Get help text for a command
   * @param {string} command - Command name
   * @returns {Object|null} Help text object or null if not found
   */ getHelpText(commandName) {
        const command = this.getCommand(commandName);
        if (!command) return null;
        // Handle both direct help objects and getter-based help
        if (typeof command.help === 'function') // It's a getter, call it to get the help object
        return command.help();
        else if (typeof command.help === 'object' && command.help !== null) // It's a plain object
        return command.help;
        return null; // No help available
    }
    /**
   * Unregister a command
   * @param {string} name - Command name to unregister
   */ unregister(name) {
        if (!name) return;
        const normalizedName = name.toLowerCase().trim();
        // Remove from commands
        delete this.commands[normalizedName];
        // Remove from hidden commands
        delete this.hiddenCommands[normalizedName];
        // Remove from categories
        Object.keys(this.commandCategories).forEach((category)=>{
            const index = this.commandCategories[category].indexOf(normalizedName);
            if (index !== -1) this.commandCategories[category].splice(index, 1);
        });
        // Remove help text
        delete this.helpTexts[normalizedName];
    }
}
// Create singleton instance
const $d12c20e2463c3ec8$var$instance = new $d12c20e2463c3ec8$var$CommandRegistry();
var // Export singleton instance
$d12c20e2463c3ec8$export$2e2bcd8739ae039 = $d12c20e2463c3ec8$var$instance;




function $fed0e6595511e144$export$9349fa50e00cf228(key, type = 'text') {
    const content = (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t(key);
    if (Array.isArray(content)) return content.map((item)=>({
            type: type,
            content: item
        }));
    // If content is not an array, wrap it in one for consistent output.
    return [
        {
            type: type,
            content: content
        }
    ];
}


var $2966cd2d0f830ca4$export$2e2bcd8739ae039 = {
    name: 'about',
    category: 'info',
    /**
   * Handler for the 'about' command.
   * Returns a Promise that resolves with the command output.
   */ async handler () {
        return (0, $fed0e6595511e144$export$9349fa50e00cf228)('commands.about');
    },
    /**
   * The help text is now a getter to defer i18n calls.
   */ get help () {
        return {
            summary: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('help.about.summary'),
            detailed: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('help.about.detailed', {
                returnObjects: true
            })
        };
    }
};




const $c7b194d1b1a58078$var$handler = async ()=>{
    (0, $71235d8e4bbe5195$export$f6644f0f2c90144b).emit('terminal:clear');
    (0, $71235d8e4bbe5195$export$f6644f0f2c90144b).emit('terminal:showWelcome');
    return []; // Return an empty array for commands with no text output
};
const $c7b194d1b1a58078$var$clearCommand = {
    name: 'clear',
    handler: $c7b194d1b1a58078$var$handler,
    category: 'core',
    get help () {
        return {
            summary: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('help.clear.summary'),
            detailed: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('help.clear.detailed', {
                returnObjects: true
            })
        };
    }
};
const $c7b194d1b1a58078$var$clsCommand = {
    name: 'cls',
    handler: $c7b194d1b1a58078$var$handler,
    category: 'core',
    get help () {
        return {
            summary: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('help.cls.summary'),
            detailed: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('help.cls.detailed', {
                returnObjects: true
            })
        };
    }
};
var $c7b194d1b1a58078$export$2e2bcd8739ae039 = [
    $c7b194d1b1a58078$var$clearCommand,
    $c7b194d1b1a58078$var$clsCommand
];


/**
 * SVG utility functions
 * Simplified to use CSS variables for theming
 */ const $64b3bad3a7873ae0$var$SVGUtils = {
    /**
   * Character set for random character generation
   * @private
   */ _characterSet: [
        'a',
        'b',
        'c',
        'd',
        'e',
        'f',
        'g',
        'h',
        'i',
        'j',
        'k',
        'l',
        'm',
        'n',
        'o',
        'p',
        'q',
        'r',
        's',
        't',
        'u',
        'v',
        'w',
        'x',
        'y',
        'z',
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z',
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '#',
        '$',
        '%',
        '-',
        '*',
        '^',
        '~',
        '+'
    ],
    /**
   * Generate a random character pair
   * @returns {Array<string>} A pair of random characters
   */ getRandomCharPair () {
        const chars = this._characterSet;
        const idx1 = Math.floor(Math.random() * chars.length);
        let idx2;
        do idx2 = Math.floor(Math.random() * chars.length);
        while (idx2 === idx1);
        return [
            chars[idx1],
            chars[idx2]
        ];
    },
    /**
   * Generate an SVG circle with characters using three-column grid layout.
   * This ensures perfect centering of the underscore with no character overlap.
   *
   * @param {Array<string>} chars - Two characters to display in the circle.
   * @param {object} [options] - Optional color overrides.
   * @param {string} [options.bgColor] - Background color hex code.
   * @param {string} [options.textColor] - Text color hex code.
   * @returns {string} SVG markup.
   */ generateCircleSVG (chars) {
        if (!Array.isArray(chars) || chars.length !== 2) chars = this.getRandomCharPair();
        // Always use CSS variables for colors to ensure theme consistency
        const finalBgColor = 'var(--color-svg-background)';
        const finalTextColor = 'var(--color-svg-text)';
        const finalBorderColor = 'var(--color-svg-border)';
        // Fixed spacing from underscore edges: accounting for underscore width (~25px at 70px font) + 2px gap
        return `
      <svg width="180" height="180" viewBox="0 0 180 180" xmlns="http://www.w3.org/2000/svg">
        <style>
          .char-text { font-family: Arial, sans-serif; font-size: 60px; font-weight: normal; }
        </style>
        <circle cx="90" cy="90" r="88" fill="${finalBgColor}" stroke="${finalBorderColor}" stroke-width="2" />
        
        <text x="70" y="95" 
              fill="${finalTextColor}" 
              text-anchor="end" 
              dominant-baseline="middle"
              class="char-text">
          ${chars[0]}
        </text>
        
        <text x="90" y="95" 
              fill="${finalTextColor}" 
              text-anchor="middle" 
              dominant-baseline="middle"
              class="char-text">
          _
        </text>
        
        <text x="110" y="95" 
              fill="${finalTextColor}" 
              text-anchor="start" 
              dominant-baseline="middle"
              class="char-text">
          ${chars[1]}
        </text>
      </svg>`;
    }
};
var $64b3bad3a7873ae0$export$2e2bcd8739ae039 = $64b3bad3a7873ae0$var$SVGUtils;






// All JavaScript color management has been removed. The SVGs are now styled
// directly by the browser using CSS variables from `variables.css`.
function $7ad47922de20c1c7$var$cleanupPreviousCollectionElements() {
    (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug('[COLLECTION] Cleaning up previous collection elements');
    setTimeout(()=>{
        try {
            const orphanedContainers = document.querySelectorAll('.collection-svg-container[style*="position: absolute"]');
            if (orphanedContainers.length > 0) orphanedContainers.forEach((container)=>container.remove());
        } catch (error) {
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).error('Error during collection cleanup:', error);
        }
    }, 0);
}
// Listen for SVG regeneration requests from shortcut
// Global listener to regenerate all SVGs (shortcut)
(0, $71235d8e4bbe5195$export$f6644f0f2c90144b).on('terminal:regenerate-svg', ()=>{
    // Select both legacy and new SVG wrapper classes
    const svgWrappers = document.querySelectorAll('.project-svg-wrapper, .collection-card');
    if (svgWrappers.length > 0) svgWrappers.forEach((wrapper)=>{
        try {
            const newCharPair = (0, $64b3bad3a7873ae0$export$2e2bcd8739ae039).getRandomCharPair();
            // Regenerate the SVG; colors are handled by CSS.
            const newSvg = (0, $64b3bad3a7873ae0$export$2e2bcd8739ae039).generateCircleSVG(newCharPair);
            wrapper.innerHTML = newSvg;
        } catch (error) {
            console.error('Error regenerating SVG on shortcut:', error);
        }
    });
});
// One-time click listener for per-SVG regeneration within the collection command.
if (!window.__collectionClickListenerAdded) {
    document.addEventListener('click', (event)=>{
        // Look for the nearest SVG wrapper/card within the collection output
        const card = event.target.closest('.collection-card, .project-svg-wrapper');
        if (!card) return; // Ignore clicks outside our cards
        try {
            const newChars = (0, $64b3bad3a7873ae0$export$2e2bcd8739ae039).getRandomCharPair();
            const newSvg = (0, $64b3bad3a7873ae0$export$2e2bcd8739ae039).generateCircleSVG(newChars);
            card.innerHTML = newSvg; // Swap only the clicked SVG
        } catch (err) {
            console.error('[COLLECTION] Error regenerating clicked SVG:', err);
        }
    });
    window.__collectionClickListenerAdded = true;
}
var $7ad47922de20c1c7$export$2e2bcd8739ae039 = {
    name: 'collection',
    category: 'info',
    async handler () {
        $7ad47922de20c1c7$var$cleanupPreviousCollectionElements();
        // Generate two SVGs upfront that will replace placeholders in the translation block.
        const charPair1 = (0, $64b3bad3a7873ae0$export$2e2bcd8739ae039).getRandomCharPair();
        const charPair2 = (0, $64b3bad3a7873ae0$export$2e2bcd8739ae039).getRandomCharPair();
        const svg1 = (0, $64b3bad3a7873ae0$export$2e2bcd8739ae039).generateCircleSVG(charPair1);
        const svg2 = (0, $64b3bad3a7873ae0$export$2e2bcd8739ae039).generateCircleSVG(charPair2);
        // Get raw translation array (strings + potential objects)
        const rawContent = (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('commands.collection');
        // Build final output array, respecting ordering from translation.
        const finalOutput = rawContent.map((item)=>{
            if (typeof item === 'string') // Plain text line
            return {
                type: 'text',
                content: item
            };
            // Handle special SVG block object
            if (item && item.type === 'svg_block') {
                const htmlWithSvgs = item.html.replace('{{SVG_PLACEHOLDER_1}}', svg1).replace('{{SVG_PLACEHOLDER_2}}', svg2);
                return {
                    type: 'html',
                    content: htmlWithSvgs
                };
            }
            // Fallback: stringify any unknown object safely
            return {
                type: 'text',
                content: String(item)
            };
        });
        return finalOutput;
    },
    get help () {
        return {
            summary: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('help.collection.summary'),
            detailed: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('help.collection.detailed', {
                returnObjects: true
            })
        };
    }
};





/**
 * Messaging Utilities
 * 
 * Provides helper functions for creating standardized terminal output objects.
 * This centralizes message formatting, making the codebase cleaner and easier to maintain.
 */ 
function $f88579f0fbda1b2c$export$a10e5d9502088fe8(key, vars) {
    return [
        {
            type: 'text',
            content: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t(key, vars)
        }
    ];
}
function $f88579f0fbda1b2c$export$d1b5f35845094891(message) {
    return [
        {
            type: 'error',
            content: message
        }
    ];
}
function $f88579f0fbda1b2c$export$4bd700f3a55acd36(key, vars) {
    return [
        {
            type: 'error',
            content: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t(key, vars)
        }
    ];
}


var $99cb74956199a5ee$export$2e2bcd8739ae039 = {
    name: 'help',
    category: 'core',
    /**
   * Main handler for the 'help' command.
   * Dispatches to specific or general help generators.
   * @param {string[]} args - The arguments for the command.
   */ async handler (args) {
        const commandName = args[0];
        if (commandName) return this._generateSpecificHelp(commandName);
        return this._generateGeneralHelp();
    },
    /**
   * Generates the help output for a specific command.
   * @param {string} commandName - The name of the command.
   * @returns {Array<Object>} The output for the terminal.
   * @private
   */ _generateSpecificHelp (commandName) {
        const command = (0, $d12c20e2463c3ec8$export$2e2bcd8739ae039).getCommand(commandName);
        const helpInfo = command?.help?.detailed;
        if (helpInfo) {
            if (Array.isArray(helpInfo)) {
                const output = helpInfo.map((line)=>({
                        type: 'html',
                        content: line
                    }));
                return output;
            }
            const { description: description, usage: usage, examples: examples, footer: footer } = helpInfo;
            const output = [
                {
                    type: 'html',
                    content: ''
                },
                {
                    type: 'html',
                    content: `<strong>${command.name}</strong>: ${description || (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('help.specific.noDescription')}`
                },
                {
                    type: 'html',
                    content: `${(0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('help.specific.usagePrefix')} ${usage || (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('help.specific.noUsage')}`
                }
            ];
            if (examples && Array.isArray(examples) && examples.length > 0) {
                output.push({
                    type: 'html',
                    content: ''
                });
                output.push({
                    type: 'html',
                    content: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('help.specific.examplesTitle')
                });
                examples.forEach((example)=>{
                    output.push({
                        type: 'html',
                        content: `  - ${example}`
                    });
                });
            }
            if (footer) output.push({
                type: 'html',
                content: footer.replace(/\n/g, '<br>')
            });
            output.push({
                type: 'html',
                content: ''
            });
            return output;
        }
        return (0, $f88579f0fbda1b2c$export$4bd700f3a55acd36)('terminal.error.noHelp', {
            commandName: commandName
        });
    },
    /**
   * Generates the general help output listing all commands.
   * @returns {Array<Object>} The output for the terminal.
   * @private
   */ _generateGeneralHelp () {
        const output = [];
        output.push({
            type: 'html',
            content: ''
        });
        output.push({
            type: 'html',
            content: `<strong>${(0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('help.title')}</strong>`
        });
        output.push({
            type: 'html',
            content: ''
        });
        const categories = (0, $d12c20e2463c3ec8$export$2e2bcd8739ae039).commandCategories;
        const categoryOrder = [
            'core',
            'info',
            'web3',
            'tools',
            'other'
        ];
        for (const categoryName of categoryOrder){
            const commandList = categories[categoryName];
            if (commandList && commandList.length > 0) {
                const categoryKey = `help.categories.${categoryName}`;
                let categoryDisplayName = (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t(categoryKey);
                // Remove the word "commands" (case-insensitive) from the end of the category label
                categoryDisplayName = categoryDisplayName.replace(/\s*commands?\s*$/i, '').trim();
                output.push({
                    type: 'html',
                    content: `<strong>${categoryDisplayName}</strong>`
                });
                commandList.forEach((commandName)=>{
                    const command = (0, $d12c20e2463c3ec8$export$2e2bcd8739ae039).getCommand(commandName);
                    if (command) {
                        const summary = command.help?.summary || (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t(`help.${commandName}.summary`);
                        output.push({
                            type: 'html',
                            content: `  <span class="help-command" style="display:inline-block; min-width: 12ch; color: var(--color-accent); white-space:pre;">${commandName}</span> - ${summary}`
                        });
                    }
                });
                output.push({
                    type: 'html',
                    content: ''
                });
            }
        }
        output.push({
            type: 'html',
            content: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('help.general.footer')
        });
        output.push({
            type: 'html',
            content: ''
        });
        return output;
    },
    /**
   * The help text is now a getter to defer i18n calls.
   */ get help () {
        return {
            summary: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('help.help.summary'),
            detailed: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('help.help.detailed', {
                returnObjects: true
            })
        };
    }
};






var $2416c3000702f1af$export$2e2bcd8739ae039 = {
    name: 'lang',
    category: 'core',
    async handler (args) {
        const langCode = args[0];
        if (!langCode) {
            const currentLanguage = localStorage.getItem('techno_punks_language') || 'en';
            const message = `${(0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('currentLanguage')} ${currentLanguage}`;
            return [
                {
                    type: 'text',
                    content: message
                }
            ];
        }
        return this._setLanguage(langCode);
    },
    async _setLanguage (langCode) {
        try {
            const success = await (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).setLanguage(langCode);
            if (success) {
                window.currentLanguage = langCode;
                localStorage.setItem('techno_punks_language', langCode);
                (0, $71235d8e4bbe5195$export$f6644f0f2c90144b).emit('language:changed', {
                    language: langCode
                });
                return [
                    {
                        type: 'text',
                        content: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('languageChanged', {
                            langCode: langCode
                        })
                    }
                ];
            }
            const errorMessage = `${(0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('help.lang.error.invalidCode')} ${(0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('help.lang.error.suggestion')}`;
            return (0, $f88579f0fbda1b2c$export$d1b5f35845094891)(errorMessage);
        } catch (error) {
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).error('Error setting language', error);
            const errorMessage = `${(0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('help.lang.error.invalidCode')} ${(0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('help.lang.error.suggestion')}`;
            return (0, $f88579f0fbda1b2c$export$d1b5f35845094891)(errorMessage);
        }
    },
    get help () {
        return {
            summary: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('help.lang.summary'),
            detailed: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('help.lang.detailed'),
            error: {
                invalidCode: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('help.lang.error.invalidCode'),
                suggestion: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('help.lang.error.suggestion')
            }
        };
    }
};




var $253a6eee8a7cc8a4$export$2e2bcd8739ae039 = {
    name: 'legal',
    category: 'info',
    /**
   * Handler for the 'legal' command.
   * Returns a Promise that resolves with the command output.
   */ async handler () {
        return (0, $fed0e6595511e144$export$9349fa50e00cf228)('commands.legal');
    },
    /**
   * The help text is now a getter to defer i18n calls.
   */ get help () {
        return {
            summary: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('help.legal.summary'),
            detailed: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('help.legal.detailed', {
                returnObjects: true
            })
        };
    }
};





var $03e758ae5663d963$export$2e2bcd8739ae039 = {
    name: 'links',
    category: 'info',
    /**
   * Handler for the 'links' command.
   * It's async to implicitly return a Promise.
   */ async handler () {
        return (0, $fed0e6595511e144$export$9349fa50e00cf228)('commands.links');
    },
    /**
   * The help text is now a getter to defer i18n calls.
   */ get help () {
        return {
            summary: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('help.links.summary'),
            detailed: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('help.links.detailed', {
                returnObjects: true
            })
        };
    }
};



const $ca45a9cbaad4288c$var$loadedScripts = new Map();
function $ca45a9cbaad4288c$export$2cb99e4be0dc4646(src) {
    if ($ca45a9cbaad4288c$var$loadedScripts.has(src)) return $ca45a9cbaad4288c$var$loadedScripts.get(src);
    const promise = new Promise((resolve, reject)=>{
        const script = document.createElement('script');
        script.src = src;
        script.onload = ()=>resolve();
        script.onerror = ()=>reject(new Error(i18n.t('terminal.error.failedToLoadScript', {
                src: src
            })));
        document.head.appendChild(script);
    });
    $ca45a9cbaad4288c$var$loadedScripts.set(src, promise);
    return promise;
}




// --- WEB3 CONFIGURATION ---
var $14ae128f6f167e1e$exports = {};
$14ae128f6f167e1e$exports = JSON.parse("{\"address\":\"0x9dd792903888eb8F0E16c7427420c84D5BBDB243\"}");


var $5e8c321c334b5148$exports = {};
$5e8c321c334b5148$exports = JSON.parse("[{\"inputs\":[{\"internalType\":\"address\",\"name\":\"initialOwner\",\"type\":\"address\"},{\"internalType\":\"address\",\"name\":\"_squadManager\",\"type\":\"address\"}],\"stateMutability\":\"nonpayable\",\"type\":\"constructor\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":true,\"internalType\":\"address\",\"name\":\"owner\",\"type\":\"address\"},{\"indexed\":true,\"internalType\":\"address\",\"name\":\"approved\",\"type\":\"address\"},{\"indexed\":true,\"internalType\":\"uint256\",\"name\":\"tokenId\",\"type\":\"uint256\"}],\"name\":\"Approval\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":true,\"internalType\":\"address\",\"name\":\"owner\",\"type\":\"address\"},{\"indexed\":true,\"internalType\":\"address\",\"name\":\"operator\",\"type\":\"address\"},{\"indexed\":false,\"internalType\":\"bool\",\"name\":\"approved\",\"type\":\"bool\"}],\"name\":\"ApprovalForAll\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":true,\"internalType\":\"uint256\",\"name\":\"tokenId\",\"type\":\"uint256\"},{\"indexed\":false,\"internalType\":\"string\",\"name\":\"backgroundColor\",\"type\":\"string\"},{\"indexed\":false,\"internalType\":\"string\",\"name\":\"textColor\",\"type\":\"string\"}],\"name\":\"ColorsUpdated\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":false,\"internalType\":\"uint256\",\"name\":\"_tokenId\",\"type\":\"uint256\"}],\"name\":\"MetadataUpdate\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":true,\"internalType\":\"address\",\"name\":\"minter\",\"type\":\"address\"},{\"indexed\":true,\"internalType\":\"uint256\",\"name\":\"tokenId\",\"type\":\"uint256\"},{\"indexed\":false,\"internalType\":\"string\",\"name\":\"pair\",\"type\":\"string\"}],\"name\":\"NFTMinted\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":true,\"internalType\":\"address\",\"name\":\"previousOwner\",\"type\":\"address\"},{\"indexed\":true,\"internalType\":\"address\",\"name\":\"newOwner\",\"type\":\"address\"}],\"name\":\"OwnershipTransferred\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":true,\"internalType\":\"address\",\"name\":\"from\",\"type\":\"address\"},{\"indexed\":true,\"internalType\":\"address\",\"name\":\"to\",\"type\":\"address\"},{\"indexed\":true,\"internalType\":\"uint256\",\"name\":\"tokenId\",\"type\":\"uint256\"}],\"name\":\"Transfer\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":false,\"internalType\":\"address\",\"name\":\"to\",\"type\":\"address\"},{\"indexed\":false,\"internalType\":\"uint256\",\"name\":\"amount\",\"type\":\"uint256\"}],\"name\":\"WithdrawalCompleted\",\"type\":\"event\"},{\"inputs\":[],\"name\":\"MAX_SUPPLY\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"MINT_PRICE\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"MIN_WITHDRAWAL\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"tokenId\",\"type\":\"uint256\"}],\"name\":\"_generatePair\",\"outputs\":[{\"internalType\":\"string\",\"name\":\"\",\"type\":\"string\"}],\"stateMutability\":\"pure\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"to\",\"type\":\"address\"},{\"internalType\":\"uint256\",\"name\":\"tokenId\",\"type\":\"uint256\"}],\"name\":\"approve\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"owner\",\"type\":\"address\"}],\"name\":\"balanceOf\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"tokenId\",\"type\":\"uint256\"}],\"name\":\"burn\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"contractURI\",\"outputs\":[{\"internalType\":\"string\",\"name\":\"\",\"type\":\"string\"}],\"stateMutability\":\"pure\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"name\":\"customTokenColors\",\"outputs\":[{\"internalType\":\"string\",\"name\":\"backgroundColor\",\"type\":\"string\"},{\"internalType\":\"string\",\"name\":\"textColor\",\"type\":\"string\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"tokenId\",\"type\":\"uint256\"},{\"internalType\":\"string\",\"name\":\"backgroundColor\",\"type\":\"string\"},{\"internalType\":\"string\",\"name\":\"textColor\",\"type\":\"string\"}],\"name\":\"customizeToken\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"tokenId\",\"type\":\"uint256\"}],\"name\":\"getApproved\",\"outputs\":[{\"internalType\":\"address\",\"name\":\"\",\"type\":\"address\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"getMintedCount\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"owner\",\"type\":\"address\"},{\"internalType\":\"address\",\"name\":\"operator\",\"type\":\"address\"}],\"name\":\"isApprovedForAll\",\"outputs\":[{\"internalType\":\"bool\",\"name\":\"\",\"type\":\"bool\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"quantity\",\"type\":\"uint256\"}],\"name\":\"mintBatch\",\"outputs\":[],\"stateMutability\":\"payable\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"mintNFT\",\"outputs\":[],\"stateMutability\":\"payable\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"name\",\"outputs\":[{\"internalType\":\"string\",\"name\":\"\",\"type\":\"string\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"tokenId\",\"type\":\"uint256\"}],\"name\":\"notifyMetadataUpdate\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"owner\",\"outputs\":[{\"internalType\":\"address\",\"name\":\"\",\"type\":\"address\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"tokenId\",\"type\":\"uint256\"}],\"name\":\"ownerOf\",\"outputs\":[{\"internalType\":\"address\",\"name\":\"\",\"type\":\"address\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"paymentAddress\",\"outputs\":[{\"internalType\":\"address\",\"name\":\"\",\"type\":\"address\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"renounceOwnership\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"from\",\"type\":\"address\"},{\"internalType\":\"address\",\"name\":\"to\",\"type\":\"address\"},{\"internalType\":\"uint256\",\"name\":\"tokenId\",\"type\":\"uint256\"}],\"name\":\"safeTransferFrom\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"from\",\"type\":\"address\"},{\"internalType\":\"address\",\"name\":\"to\",\"type\":\"address\"},{\"internalType\":\"uint256\",\"name\":\"tokenId\",\"type\":\"uint256\"},{\"internalType\":\"bytes\",\"name\":\"data\",\"type\":\"bytes\"}],\"name\":\"safeTransferFrom\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"operator\",\"type\":\"address\"},{\"internalType\":\"bool\",\"name\":\"approved\",\"type\":\"bool\"}],\"name\":\"setApprovalForAll\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"_squadManager\",\"type\":\"address\"}],\"name\":\"setSquadManager\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"squadManager\",\"outputs\":[{\"internalType\":\"address\",\"name\":\"\",\"type\":\"address\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"bytes4\",\"name\":\"interfaceId\",\"type\":\"bytes4\"}],\"name\":\"supportsInterface\",\"outputs\":[{\"internalType\":\"bool\",\"name\":\"\",\"type\":\"bool\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"symbol\",\"outputs\":[{\"internalType\":\"string\",\"name\":\"\",\"type\":\"string\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"tokenId\",\"type\":\"uint256\"}],\"name\":\"tokenURI\",\"outputs\":[{\"internalType\":\"string\",\"name\":\"\",\"type\":\"string\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"owner\",\"type\":\"address\"}],\"name\":\"tokensOfOwner\",\"outputs\":[{\"internalType\":\"uint256[]\",\"name\":\"\",\"type\":\"uint256[]\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"totalSupply\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"from\",\"type\":\"address\"},{\"internalType\":\"address\",\"name\":\"to\",\"type\":\"address\"},{\"internalType\":\"uint256\",\"name\":\"tokenId\",\"type\":\"uint256\"}],\"name\":\"transferFrom\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"newOwner\",\"type\":\"address\"}],\"name\":\"transferOwnership\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"withdraw\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"stateMutability\":\"payable\",\"type\":\"receive\"}]");


const $a408f50754b95311$export$dacc1116f5b84fce = {
    RPC_URL: 'https://rpc.hyperliquid.xyz/evm',
    CHAIN_ID: '0x3e7',
    CHAIN_NAME: 'Hyperliquid EVM Mainnet',
    CURRENCY_SYMBOL: 'ETH',
    CURRENCY_NAME: 'Ethereum',
    CURRENCY_DECIMALS: 18
};
const $a408f50754b95311$export$a211bdf287559207 = $a408f50754b95311$export$dacc1116f5b84fce.RPC_URL;
const $a408f50754b95311$export$ad5b2d2dcc6ff48c = (0, (/*@__PURE__*/$parcel$interopDefault($14ae128f6f167e1e$exports))).address;
const $a408f50754b95311$export$f5bffafd4161d5d1 = (0, (/*@__PURE__*/$parcel$interopDefault($5e8c321c334b5148$exports)));


const $e33331d7b228d1b4$var$WEB3_CDN_URL = 'https://cdn.jsdelivr.net/npm/web3@4.9.0/dist/web3.min.js';
let $e33331d7b228d1b4$var$Web3; // Will be assigned after loading the script
let $e33331d7b228d1b4$var$web3;
let $e33331d7b228d1b4$var$contract;
let $e33331d7b228d1b4$var$connectedAccount;
let $e33331d7b228d1b4$var$providers = [];
// Promise to ensure Web3.js is loaded only once.
let $e33331d7b228d1b4$var$web3LoadPromise = null;
/**
 * Ensures the Web3.js library is loaded, dynamically injecting it if needed.
 */ function $e33331d7b228d1b4$var$ensureWeb3Loaded() {
    if ($e33331d7b228d1b4$var$web3LoadPromise) return $e33331d7b228d1b4$var$web3LoadPromise;
    $e33331d7b228d1b4$var$web3LoadPromise = new Promise((resolve, reject)=>{
        if (window.Web3) {
            $e33331d7b228d1b4$var$Web3 = window.Web3;
            return resolve();
        }
        (0, $ca45a9cbaad4288c$export$2cb99e4be0dc4646)($e33331d7b228d1b4$var$WEB3_CDN_URL).then(()=>{
            $e33331d7b228d1b4$var$Web3 = window.Web3;
            resolve();
        }).catch((error)=>{
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).error("CRITICAL: Failed to load Web3.js from CDN.", error);
            reject(error);
        });
    });
    return $e33331d7b228d1b4$var$web3LoadPromise;
}
/**
 * Keeps providers unique by their info.uuid.
 */ function $e33331d7b228d1b4$var$addProviderUniquely(newProvider) {
    if (!$e33331d7b228d1b4$var$providers.find((p)=>p.info.uuid === newProvider.info.uuid)) $e33331d7b228d1b4$var$providers.push(newProvider);
}
/**
 * Uses MIPD to discover all available EIP-6963 wallet providers.
 */ function $e33331d7b228d1b4$var$discoverWallets() {
    // Listen for wallet announcements per EIP-6963.
    window.addEventListener('eip6963:announceProvider', (event)=>{
        $e33331d7b228d1b4$var$addProviderUniquely(event.detail);
    });
}
/**
 * Actively requests that injected wallets announce themselves (EIP-6963).
 * Call this right before you want the list – e.g. in the `connect` command.
 */ function $e33331d7b228d1b4$var$requestWalletAnnouncements() {
    window.dispatchEvent(new Event('eip6963:requestProvider'));
}
/**
 * Returns the list of discovered wallet providers.
 * @returns {Array} A list of wallet provider objects.
 */ function $e33331d7b228d1b4$var$getDiscoveredWallets() {
    return $e33331d7b228d1b4$var$providers;
}
/**
 * Initializes a default read-only provider using the public RPC URL.
 * This allows the app to perform read operations before a wallet is connected.
 */ async function $e33331d7b228d1b4$var$initializeDefaultProvider() {
    await $e33331d7b228d1b4$var$ensureWeb3Loaded();
    if (0, $a408f50754b95311$export$a211bdf287559207) try {
        const provider = new $e33331d7b228d1b4$var$Web3.providers.HttpProvider((0, $a408f50754b95311$export$a211bdf287559207));
        $e33331d7b228d1b4$var$web3 = new $e33331d7b228d1b4$var$Web3(provider);
        $e33331d7b228d1b4$var$contract = new $e33331d7b228d1b4$var$web3.eth.Contract((0, $a408f50754b95311$export$f5bffafd4161d5d1), (0, $a408f50754b95311$export$ad5b2d2dcc6ff48c));
        (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug('Default read-only provider initialized.');
    } catch (error) {
        (0, $9bb4c1574855072f$export$2e2bcd8739ae039).error('Failed to initialize default provider:', error);
    }
}
/**
 * Connects to the user's Ethereum wallet (e.g., MetaMask).
 * @returns {Promise<string>} The connected account address.
 */ async function $e33331d7b228d1b4$var$connectWallet() {
    await $e33331d7b228d1b4$var$ensureWeb3Loaded();
    let selectedProvider = null;
    // Helper to identify a genuine MetaMask provider, avoiding imposters.
    const isMetaMask = (p)=>{
        if (!p) return false;
        // EIP-6963 providers have an `info` object.
        const isMetaMaskByName = p.info && p.info.name && p.info.name.toLowerCase().includes('metamask');
        // The legacy `isMetaMask` flag check has been removed to avoid
        // triggering unwanted behavior in non-MetaMask wallets like Brave.
        return isMetaMaskByName;
    };
    // Actively request announcements to get the most up-to-date list of wallets.
    $e33331d7b228d1b4$var$requestWalletAnnouncements();
    await new Promise((r)=>setTimeout(r, 300)); // Give wallets time to announce.
    const wallets = $e33331d7b228d1b4$var$getDiscoveredWallets();
    const metaMaskWallet = wallets.find(isMetaMask);
    if (metaMaskWallet) selectedProvider = metaMaskWallet.provider;
    // If no MetaMask provider was found, throw an error.
    if (!selectedProvider) throw new Error((0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('web3.error.metaMaskRequired'));
    // Proceed with connection using the identified MetaMask provider.
    $e33331d7b228d1b4$var$web3 = new $e33331d7b228d1b4$var$Web3(selectedProvider);
    try {
        const accounts = await selectedProvider.request({
            method: 'eth_requestAccounts'
        });
        $e33331d7b228d1b4$var$connectedAccount = accounts[0];
        $e33331d7b228d1b4$var$contract = new $e33331d7b228d1b4$var$web3.eth.Contract((0, $a408f50754b95311$export$f5bffafd4161d5d1), (0, $a408f50754b95311$export$ad5b2d2dcc6ff48c));
        await $e33331d7b228d1b4$var$setupNetwork(selectedProvider);
        return $e33331d7b228d1b4$var$connectedAccount;
    } catch (error) {
        (0, $9bb4c1574855072f$export$2e2bcd8739ae039).error("MetaMask connection error:", error);
        if (error.code === 4001) throw new Error((0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('web3.error.connectionDenied'));
        throw new Error((0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('web3.error.connectionFailed', {
            message: error.message
        }));
    }
}
/**
 * Adds the configured network to MetaMask if not already present.
 */ async function $e33331d7b228d1b4$var$setupNetwork(provider) {
    const { CHAIN_ID: CHAIN_ID, CHAIN_NAME: CHAIN_NAME, RPC_URL: RPC_URL, CURRENCY_NAME: CURRENCY_NAME, CURRENCY_SYMBOL: CURRENCY_SYMBOL, CURRENCY_DECIMALS: CURRENCY_DECIMALS } = (0, $a408f50754b95311$export$dacc1116f5b84fce);
    try {
        await provider.request({
            method: 'wallet_switchEthereumChain',
            params: [
                {
                    chainId: CHAIN_ID
                }
            ]
        });
    } catch (switchError) {
        // This error code indicates that the chain has not been added to MetaMask.
        if (switchError.code === 4902) try {
            await provider.request({
                method: 'wallet_addEthereumChain',
                params: [
                    {
                        chainId: CHAIN_ID,
                        chainName: CHAIN_NAME,
                        rpcUrls: [
                            RPC_URL
                        ],
                        nativeCurrency: {
                            name: CURRENCY_NAME,
                            symbol: CURRENCY_SYMBOL,
                            decimals: CURRENCY_DECIMALS
                        }
                    }
                ]
            });
        } catch (addError) {
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).error(`Failed to add the ${CHAIN_NAME} network`, addError);
            throw new Error((0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('web3.error.addNetwork', {
                chainName: CHAIN_NAME
            }));
        }
    }
}
/**
 * Gets the currently connected account.
 * @returns {string|null} The connected account address or null.
 */ function $e33331d7b228d1b4$var$getConnectedAccount() {
    return $e33331d7b228d1b4$var$connectedAccount;
}
/**
 * Fetches NFT collection information from the smart contract.
 * @returns {Promise<object>} An object with collection info.
 */ async function $e33331d7b228d1b4$var$getCollectionInfo() {
    try {
        const localContract = $e33331d7b228d1b4$var$contract;
        const localWeb3 = $e33331d7b228d1b4$var$web3;
        if (!localContract) // If there's no contract instance, the default provider failed or wasn't available.
        throw new Error((0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('web3.error.notConnected'));
        const name = await localContract.methods.name().call();
        const symbol = await localContract.methods.symbol().call();
        const totalSupply = await localContract.methods.getMintedCount().call();
        const maxSupply = await localContract.methods.MAX_SUPPLY().call();
        const price = await localContract.methods.MINT_PRICE().call();
        return {
            name: name,
            symbol: symbol,
            contractAddress: (0, $a408f50754b95311$export$ad5b2d2dcc6ff48c),
            totalSupply: totalSupply.toString(),
            maxSupply: maxSupply.toString(),
            price: localWeb3.utils.fromWei(price, 'ether')
        };
    } catch (error) {
        (0, $9bb4c1574855072f$export$2e2bcd8739ae039).error("Error fetching collection info:", error);
        throw new Error((0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('web3.error.fetchInfo', {
            message: error.message
        }));
    }
}
/**
 * Polls for transaction receipt with extended timeout handling
 * @param {string} transactionHash - The transaction hash to poll for
 * @param {function} onProgress - Progress callback function
 * @returns {Promise<object|null>} The transaction receipt or null if timeout
 */ async function $e33331d7b228d1b4$var$pollForReceipt(transactionHash, onProgress) {
    const maxAttempts = 120; // 10 minutes with 5-second intervals
    const pollInterval = 5000; // 5 seconds
    for(let attempt = 0; attempt < maxAttempts; attempt++)try {
        const receipt = await $e33331d7b228d1b4$var$web3.eth.getTransactionReceipt(transactionHash);
        if (receipt) return receipt;
        // Show progress every 30 seconds
        if (attempt > 0 && attempt % 6 === 0) {
            const elapsed = Math.floor(attempt * pollInterval / 1000);
            if (onProgress) onProgress((0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('web3.progress.stillWaiting', {
                elapsed: elapsed,
                hash: transactionHash
            }));
        }
        await new Promise((resolve)=>setTimeout(resolve, pollInterval));
    } catch (error) {
        (0, $9bb4c1574855072f$export$2e2bcd8739ae039).warn(`Error polling for receipt (attempt ${attempt + 1}):`, error);
        await new Promise((resolve)=>setTimeout(resolve, pollInterval));
    }
    return null; // Timeout after max attempts
}
/**
 * Initiates the NFT minting process.
 * @returns {Promise<string>} The transaction hash.
 */ async function $e33331d7b228d1b4$var$mintNFT(quantity, onProgress) {
    if (!$e33331d7b228d1b4$var$contract || !$e33331d7b228d1b4$var$connectedAccount) throw new Error((0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('web3.error.notConnected'));
    const mintedTokens = [];
    let transactionHash = null;
    try {
        const unitPrice = await $e33331d7b228d1b4$var$contract.methods.MINT_PRICE().call();
        // --- Single Mint Path ---
        if (quantity === 1) {
            if (onProgress) onProgress((0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('web3.progress.preparingTx'));
            const txPromise = $e33331d7b228d1b4$var$contract.methods.mintNFT().send({
                from: $e33331d7b228d1b4$var$connectedAccount,
                value: BigInt(unitPrice)
            });
            txPromise.on('transactionHash', (hash)=>{
                transactionHash = hash;
                if (onProgress) onProgress((0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('web3.progress.txSubmitted', {
                    hash: hash
                }));
            });
            try {
                const txReceipt = await txPromise;
                if (onProgress) onProgress((0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('web3.progress.txConfirmed'));
                const mintedEvent = txReceipt.events.NFTMinted;
                if (mintedEvent) {
                    const { tokenId: tokenId, pair: pair } = mintedEvent.returnValues;
                    mintedTokens.push({
                        tokenId: tokenId.toString(),
                        pair: pair,
                        transactionHash: txReceipt.transactionHash
                    });
                } else mintedTokens.push({
                    tokenId: 'N/A',
                    pair: 'N/A',
                    transactionHash: txReceipt.transactionHash
                });
                return mintedTokens;
            } catch (timeoutError) {
                // Handle Web3.js timeout - transaction might still succeed
                if (transactionHash && timeoutError.message.includes('not mined within')) {
                    if (onProgress) onProgress((0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('web3.progress.txTimeout', {
                        hash: transactionHash
                    }));
                    // Try to get receipt manually with extended polling
                    const receipt = await $e33331d7b228d1b4$var$pollForReceipt(transactionHash, onProgress);
                    if (receipt) {
                        if (onProgress) onProgress((0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('web3.progress.txConfirmed'));
                        const mintedEvent = receipt.events && receipt.events.NFTMinted;
                        if (mintedEvent) {
                            const { tokenId: tokenId, pair: pair } = mintedEvent.returnValues;
                            mintedTokens.push({
                                tokenId: tokenId.toString(),
                                pair: pair,
                                transactionHash: receipt.transactionHash
                            });
                        } else mintedTokens.push({
                            tokenId: 'N/A',
                            pair: 'N/A',
                            transactionHash: receipt.transactionHash
                        });
                        return mintedTokens;
                    }
                }
                throw timeoutError;
            }
        }
        // --- Batch Mint Path ---
        if (onProgress) onProgress((0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('web3.progress.preparingBatchTx', {
            quantity: quantity
        }));
        // Record current minted count to derive token IDs later
        const preSupply = await $e33331d7b228d1b4$var$contract.methods.getMintedCount().call();
        // Compute totalPrice safely: use web3.utils.toBN if available, otherwise fallback to BigInt
        let totalPriceBN;
        if ($e33331d7b228d1b4$var$web3.utils && typeof $e33331d7b228d1b4$var$web3.utils.toBN === 'function') totalPriceBN = $e33331d7b228d1b4$var$web3.utils.toBN(unitPrice).mul($e33331d7b228d1b4$var$web3.utils.toBN(quantity)).toString();
        else // web3 v4.x removed toBN; use native BigInt instead
        totalPriceBN = BigInt(unitPrice) * BigInt(quantity);
        const txPromise = $e33331d7b228d1b4$var$contract.methods.mintBatch(quantity).send({
            from: $e33331d7b228d1b4$var$connectedAccount,
            value: totalPriceBN
        });
        txPromise.on('transactionHash', (hash)=>{
            transactionHash = hash;
            if (onProgress) onProgress((0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('web3.progress.batchTxSubmitted', {
                hash: hash,
                quantity: quantity
            }));
        });
        let txReceipt;
        try {
            txReceipt = await txPromise;
            if (onProgress) onProgress((0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('web3.progress.batchTxConfirmed', {
                quantity: quantity
            }));
        } catch (timeoutError) {
            // Handle Web3.js timeout for batch minting
            if (transactionHash && timeoutError.message.includes('not mined within')) {
                if (onProgress) onProgress((0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('web3.progress.batchTxTimeout', {
                    hash: transactionHash,
                    quantity: quantity
                }));
                // Try to get receipt manually with extended polling
                txReceipt = await $e33331d7b228d1b4$var$pollForReceipt(transactionHash, onProgress);
                if (txReceipt) {
                    if (onProgress) onProgress((0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('web3.progress.batchTxConfirmed', {
                        quantity: quantity
                    }));
                } else throw timeoutError;
            } else throw timeoutError;
        }
        // Extract all NFTMinted events from receipt, accounting for various Web3 shapes
        // Decode every NFTMinted log manually from raw logs to capture all occurrences
        const nftMintedAbi = (0, $a408f50754b95311$export$f5bffafd4161d5d1).find((item)=>item.name === 'NFTMinted' && item.type === 'event');
        const topicHash = $e33331d7b228d1b4$var$web3.utils.sha3('NFTMinted(address,uint256,string)');
        txReceipt.logs.forEach((log)=>{
            if (log.address.toLowerCase() === (0, $a408f50754b95311$export$ad5b2d2dcc6ff48c).toLowerCase() && log.topics[0] === topicHash) try {
                const decoded = $e33331d7b228d1b4$var$web3.eth.abi.decodeLog(nftMintedAbi.inputs, log.data, log.topics.slice(1));
                mintedTokens.push({
                    tokenId: decoded.tokenId.toString(),
                    pair: decoded.pair,
                    transactionHash: txReceipt.transactionHash
                });
            } catch (err) {
                (0, $9bb4c1574855072f$export$2e2bcd8739ae039).warn('Failed to decode NFTMinted log', err);
            }
        });
        // If some tokens still missing, extract from Transfer events
        if (mintedTokens.length < quantity) {
            const zeroAddress = '0x0000000000000000000000000000000000000000';
            const transferEvents = Object.values(txReceipt.events || {}).filter((ev)=>ev && ev.event === 'Transfer');
            transferEvents.forEach((ev)=>{
                if (ev.returnValues && ev.returnValues.from.toLowerCase() === zeroAddress && ev.returnValues.to.toLowerCase() === $e33331d7b228d1b4$var$connectedAccount.toLowerCase()) {
                    const tokenId = ev.returnValues.tokenId.toString();
                    const alreadyPresent = mintedTokens.some((t)=>t.tokenId === tokenId);
                    if (!alreadyPresent) mintedTokens.push({
                        tokenId: tokenId,
                        pair: 'N/A',
                        transactionHash: txReceipt.transactionHash
                    });
                }
            });
        }
        // Fetch pair for any tokens lacking it
        for (const token of mintedTokens){
            if (token.tokenId !== 'N/A' && token.pair === 'N/A') try {
                const tokenURI = await $e33331d7b228d1b4$var$contract.methods.tokenURI(token.tokenId).call();
                const jsonString = atob(tokenURI.substring(29));
                const metadata = JSON.parse(jsonString);
                // Assume name field contains pair in parentheses e.g. "Techno Punk (#id) ({pair})"
                const match = metadata.name && metadata.name.match(/\(([^)]+)\)$/);
                if (match) token.pair = match[1];
            } catch (err) {
            // Silently continue if pair fetch fails
            }
        }
        // If still missing, derive IDs sequentially from preSupply
        if (mintedTokens.length < quantity) {
            const startId = BigInt(preSupply) + 1n;
            for(let offset = 0; offset < quantity; offset++){
                const candidateId = (startId + BigInt(offset)).toString();
                const alreadyPresent = mintedTokens.some((t)=>t.tokenId === candidateId);
                if (!alreadyPresent) {
                    let pair = 'N/A';
                    try {
                        const tokenURI = await $e33331d7b228d1b4$var$contract.methods.tokenURI(candidateId).call();
                        const jsonStr = atob(tokenURI.substring(29));
                        const md = JSON.parse(jsonStr);
                        const m = md.name && md.name.match(/\(([^)]+)\)$/);
                        if (m) pair = m[1];
                    } catch  {}
                    mintedTokens.push({
                        tokenId: candidateId,
                        pair: pair,
                        transactionHash: txReceipt.transactionHash
                    });
                }
            }
        }
        return mintedTokens;
    } catch (error) {
        (0, $9bb4c1574855072f$export$2e2bcd8739ae039).error("Error minting NFT:", error);
        if (error.code === 4001) // Add context about which mint failed if possible
        throw new Error((0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('web3.error.mintRejected', {
            count: mintedTokens.length + 1,
            quantity: quantity
        }));
        throw new Error((0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('web3.error.mintFailed', {
            count: mintedTokens.length + 1
        }));
    }
}
async function $e33331d7b228d1b4$var$getTokenColors(tokenId) {
    if (!$e33331d7b228d1b4$var$contract) // If no public RPC, we can't get info without a wallet connection.
    throw new Error((0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('web3.error.notConnected'));
    try {
        const colors = await $e33331d7b228d1b4$var$contract.methods.customTokenColors(tokenId).call();
        return colors;
    } catch (error) {
        (0, $9bb4c1574855072f$export$2e2bcd8739ae039).error("Error fetching token colors:", error);
        throw new Error((0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('web3.error.fetchColors', {
            tokenId: tokenId
        }));
    }
}
async function $e33331d7b228d1b4$var$customizeToken(tokenId, backgroundColor, textColor, onTransactionSent) {
    if (!$e33331d7b228d1b4$var$contract || !$e33331d7b228d1b4$var$connectedAccount) throw new Error((0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('web3.error.notConnected'));
    try {
        const bgColor = backgroundColor || "";
        const txtColor = textColor || "";
        const txPromise = $e33331d7b228d1b4$var$contract.methods.customizeToken(tokenId, bgColor, txtColor).send({
            from: $e33331d7b228d1b4$var$connectedAccount
        });
        if (onTransactionSent) txPromise.on('transactionHash', onTransactionSent);
        const txReceipt = await txPromise;
        return txReceipt.transactionHash;
    } catch (error) {
        (0, $9bb4c1574855072f$export$2e2bcd8739ae039).error("Error customizing token:", error);
        if (error.code === 4001) throw new Error((0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('web3.error.customizationRejected'));
        throw new Error((0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('web3.error.customizationFailed'));
    }
}
/**
 * Disconnects the user's wallet from the app.
 * Resets the connection state and re-initializes the default provider.
 */ function $e33331d7b228d1b4$var$disconnectWallet() {
    if (!$e33331d7b228d1b4$var$connectedAccount) // If no account is connected, there's nothing to do.
    // We can throw an error to be caught by the command handler.
    throw new Error((0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('web3.error.notConnected'));
    $e33331d7b228d1b4$var$connectedAccount = null;
    // Re-initialize the default provider to restore read-only functionality
    $e33331d7b228d1b4$var$initializeDefaultProvider();
    (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug('Wallet disconnected. Switched back to default provider.');
// No return value needed, success is implied if no error is thrown.
}
async function $e33331d7b228d1b4$var$getOwnerOf(tokenId) {
    if (!$e33331d7b228d1b4$var$contract) {
        await $e33331d7b228d1b4$var$initializeDefaultProvider();
        if (!$e33331d7b228d1b4$var$contract) throw new Error((0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('web3.error.notConnected'));
    }
    try {
        const owner = await $e33331d7b228d1b4$var$contract.methods.ownerOf(tokenId).call();
        return owner;
    } catch (error) {
        (0, $9bb4c1574855072f$export$2e2bcd8739ae039).error(`Error fetching owner for token ${tokenId}:`, error);
        throw new Error((0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('web3.error.tokenNotFound', {
            tokenId: tokenId
        }));
    }
}
async function $e33331d7b228d1b4$var$getOwnedNFTs() {
    if (!$e33331d7b228d1b4$var$contract || !$e33331d7b228d1b4$var$connectedAccount) throw new Error((0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('web3.error.notConnected'));
    // Use ERC721Enumerable to get the token balance of the owner
    const balance = await $e33331d7b228d1b4$var$contract.methods.balanceOf($e33331d7b228d1b4$var$connectedAccount).call();
    if (balance == 0) return [];
    const nfts = [];
    // Fetch all owned tokenIds in one call
    const ownedTokenIds = await $e33331d7b228d1b4$var$contract.methods.tokensOfOwner($e33331d7b228d1b4$var$connectedAccount).call();
    for (const tokenId of ownedTokenIds)try {
        const tokenURI = await $e33331d7b228d1b4$var$contract.methods.tokenURI(tokenId).call();
        const jsonString = atob(tokenURI.substring(29));
        const metadata = JSON.parse(jsonString);
        const svgString = atob(metadata.image.substring(26));
        nfts.push({
            tokenId: tokenId.toString(),
            svgImage: svgString
        });
    } catch (error) {
        (0, $9bb4c1574855072f$export$2e2bcd8739ae039).error(`Could not query token ${tokenId}:`, error.message);
    }
    return nfts;
}
const $e33331d7b228d1b4$export$fbdf49c3d9d0256e = {
    discoverWallets: $e33331d7b228d1b4$var$discoverWallets,
    getDiscoveredWallets: $e33331d7b228d1b4$var$getDiscoveredWallets,
    requestWalletAnnouncements: $e33331d7b228d1b4$var$requestWalletAnnouncements,
    connectWallet: $e33331d7b228d1b4$var$connectWallet,
    disconnectWallet: $e33331d7b228d1b4$var$disconnectWallet,
    getConnectedAccount: $e33331d7b228d1b4$var$getConnectedAccount,
    getCollectionInfo: $e33331d7b228d1b4$var$getCollectionInfo,
    mintNFT: $e33331d7b228d1b4$var$mintNFT,
    customizeToken: $e33331d7b228d1b4$var$customizeToken,
    getTokenColors: $e33331d7b228d1b4$var$getTokenColors,
    getOwnerOf: $e33331d7b228d1b4$var$getOwnerOf,
    getOwnedNFTs: $e33331d7b228d1b4$var$getOwnedNFTs,
    getWeb3Instance: $e33331d7b228d1b4$var$getWeb3Instance
};
// Discover wallets when the module loads.
// The default provider will be initialized on-demand when a web3 function is called.
$e33331d7b228d1b4$var$discoverWallets();
function $e33331d7b228d1b4$var$getWeb3Instance() {
    return $e33331d7b228d1b4$var$web3;
}




/**
 * Terminal View
 * 
 * Handles rendering and display of the terminal interface.
 */ 
/**
 * Terminal Events
 * 
 * Defines standard event names and provides utilities for terminal event handling.
 * This ensures consistent event naming across all terminal components.
 */ // Terminal initialization events
const $021ae3ea6a11655c$export$afebfa007b96b397 = {
    CORE_INITIALIZED: 'terminal:core:initialized',
    VIEW_INITIALIZED: 'terminal:view:initialized',
    CONTROLLER_INITIALIZED: 'terminal:controller:initialized',
    INPUT_INITIALIZED: 'terminal:input:initialized',
    TERMINAL_INITIALIZED: 'terminal:initialized'
};
const $021ae3ea6a11655c$export$139328814e004ad8 = {
    EXECUTE: 'terminal:command:execute',
    PROCESS: 'terminal:command:process',
    COMPLETED: 'terminal:command:completed',
    FAILED: 'terminal:command:failed',
    REGISTER: 'command:register',
    REGISTRY_INITIALIZED: 'registry:initialized'
};
const $021ae3ea6a11655c$export$52340c5663c975ff = {
    SUBMIT: 'terminal:input:submit',
    CHANGED: 'terminal:input:changed',
    FOCUS: 'terminal:input:focus',
    BLUR: 'terminal:input:blur',
    CANCEL: 'terminal:input:cancel'
};
const $021ae3ea6a11655c$export$a682338b5ffca937 = {
    NAVIGATE: 'terminal:history:navigate',
    ENTRY: 'terminal:history:entry',
    ADDED: 'terminal:history:added'
};
const $021ae3ea6a11655c$export$c5fcfcdcebfa051a = {
    ADD: 'terminal:output:add',
    CLEAR: 'terminal:clear',
    PROMPT_CHANGED: 'terminal:prompt:changed'
};
const $021ae3ea6a11655c$export$5371ca7f27839b0a = {
    CHANGED: 'theme:changed',
    CURSOR_UPDATE: 'theme:cursor:update'
};
const $021ae3ea6a11655c$export$d11a8199cdc8c207 = {
    ACTIVE: 'terminal:menu:active',
    SELECTED: 'terminal:menu:selected',
    CANCELLED: 'terminal:menu:cancelled',
    CLOSED: 'terminal:menu:closed'
};
const $021ae3ea6a11655c$export$212b227673290756 = {
    ...$021ae3ea6a11655c$export$afebfa007b96b397,
    ...$021ae3ea6a11655c$export$139328814e004ad8,
    ...$021ae3ea6a11655c$export$52340c5663c975ff,
    ...$021ae3ea6a11655c$export$a682338b5ffca937,
    ...$021ae3ea6a11655c$export$c5fcfcdcebfa051a,
    ...$021ae3ea6a11655c$export$5371ca7f27839b0a,
    ...$021ae3ea6a11655c$export$d11a8199cdc8c207
};
var $021ae3ea6a11655c$export$2e2bcd8739ae039 = $021ae3ea6a11655c$export$212b227673290756;


/**
 * Simple Cursor Manager (underscore-insertion approach)
 * Ported from legacy project `kkk`.
 * Handles cursor display by inserting/removing an underscore character in the input value.
 */ 


class $3c9a4dced859611e$var$CursorManager {
    constructor(){
        this.inputElement = null;
        this.blinkInterval = null;
        this.cursorChar = '_';
        this.isVisible = true;
        this.originalValue = '';
        this.cursorPosition = 0;
        this.isBlinkingPaused = false;
    }
    /**
   * Initialize the cursor manager
   * @param {HTMLElement} inputLineElement - The input line container (unused but kept for API parity)
   * @param {HTMLInputElement} inputElement - The input element
   */ initialize(inputLineElement, inputElement) {
        if (!inputElement) {
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).error('[CursorManager] Missing required input element');
            return;
        }
        // Clean previous state
        if (this.blinkInterval) {
            clearInterval(this.blinkInterval);
            this.blinkInterval = null;
        }
        this.inputElement = inputElement;
        // Ensure we start with a clean value (no stray cursor chars)
        if (this.inputElement.value.includes(this.cursorChar)) this.inputElement.value = this.inputElement.value.replace(new RegExp(this.cursorChar, 'g'), '');
        this.originalValue = this.inputElement.value;
        this.setupEventListeners();
        this.inputElement.focus();
        // Delay startBlinking slightly to allow DOM ready
        setTimeout(()=>this.startBlinking(), 100);
    }
    /** Restore the original text without the cursor char */ restoreOriginalText() {
        if (!this.inputElement) return;
        const pos = this.cursorPosition;
        this.inputElement.value = this.originalValue;
        this.inputElement.selectionStart = pos;
        this.inputElement.selectionEnd = pos;
    }
    /** Update cursor display */ updateCursor() {
        if (!this.inputElement) return;
        this.restoreOriginalText();
        const selStart = this.inputElement.selectionStart;
        const selEnd = this.inputElement.selectionEnd;
        const value = this.inputElement.value;
        this.cursorPosition = selStart;
        if (selStart === selEnd) {
            this.originalValue = value;
            if (this.isVisible) {
                const newValue = value.substring(0, selStart) + this.cursorChar + value.substring(selStart);
                this.inputElement.value = newValue;
                this.inputElement.selectionStart = selStart;
                this.inputElement.selectionEnd = selStart;
            }
        }
    }
    /** Blink animation */ startBlinking() {
        if (this.blinkInterval) clearInterval(this.blinkInterval);
        this.isVisible = true;
        this.updateCursor();
        this.isBlinkingPaused = false;
        this.blinkInterval = setInterval(()=>{
            // Skip blink update if blinking is paused
            if (this.isBlinkingPaused) return;
            // If there's a selection, stop the blinking logic for this tick.
            if (this.inputElement && this.inputElement.selectionStart !== this.inputElement.selectionEnd) {
                // Ensure the cursor character is not visible when text is selected.
                this.restoreOriginalText();
                this.isVisible = false; // Prevents cursor from reappearing if selection is cleared.
                return;
            }
            // If no selection, proceed with normal blinking.
            this.isVisible = !this.isVisible;
            if (this.isVisible) this.updateCursor();
            else this.restoreOriginalText();
        }, 500);
    }
    pauseBlinking() {
        this.isBlinkingPaused = true;
        this.isVisible = true; // Keep cursor visible while paused
        this.updateCursor();
    }
    resumeBlinking() {
        if (this.isBlinkingPaused) {
            this.isBlinkingPaused = false;
            // Force immediate cursor update
            this.isVisible = true;
            this.updateCursor();
        }
    }
    stopBlinking() {
        if (this.blinkInterval) {
            clearInterval(this.blinkInterval);
            this.blinkInterval = null;
        }
        this.restoreOriginalText();
    }
    show() {
        if (this.inputElement) this.inputElement.focus();
        this.isVisible = true;
        this.updateCursor();
        this.startBlinking();
    }
    hide() {
        this.isVisible = false;
        this.restoreOriginalText();
        this.stopBlinking();
    }
    /** Synchronise when value set programmatically */ syncWithValue(newValue) {
        if (!this.inputElement) return;
        const wasBlinking = !!this.blinkInterval;
        if (wasBlinking) this.stopBlinking();
        this.inputElement.value = newValue;
        this.originalValue = newValue;
        if (this.inputElement.selectionStart > newValue.length) {
            this.inputElement.selectionStart = newValue.length;
            this.inputElement.selectionEnd = newValue.length;
        }
        this.cursorPosition = this.inputElement.selectionStart;
        this.updateCursor();
        if (wasBlinking) this.startBlinking();
    }
    setupEventListeners() {
        if (!this.inputElement) return;
        // input event
        this.inputElement.addEventListener('input', ()=>{
            this.originalValue = this.inputElement.value;
            this.cursorPosition = this.inputElement.selectionStart;
            this.updateCursor();
        });
        // keydown to allow browser to process key then redraw
        this.inputElement.addEventListener('keydown', (e)=>{
            if (e.key !== 'ArrowUp' && e.key !== 'ArrowDown') {
                this.restoreOriginalText();
                setTimeout(()=>this.updateCursor(), 0);
            }
        });
        // click
        this.inputElement.addEventListener('click', ()=>{
            // After a click, the browser will have placed the cursor or created a selection.
            // We only need to intervene to redraw our custom cursor if there's no selection.
            if (this.inputElement.selectionStart === this.inputElement.selectionEnd) {
                this.restoreOriginalText();
                setTimeout(()=>{
                    this.originalValue = this.inputElement.value;
                    this.cursorPosition = this.inputElement.selectionStart;
                    this.updateCursor();
                }, 0);
            }
        // If there is a selection, we do nothing and let the browser's native selection remain.
        });
        // focus/blur
        this.inputElement.addEventListener('focus', ()=>this.show());
        this.inputElement.addEventListener('blur', ()=>this.hide());
        // external cursor update event
        (0, $71235d8e4bbe5195$export$f6644f0f2c90144b).on((0, $021ae3ea6a11655c$export$212b227673290756).CURSOR_UPDATE, ()=>this.updateCursor());
    }
}
var $3c9a4dced859611e$export$2e2bcd8739ae039 = $3c9a4dced859611e$var$CursorManager;


/**
 * Terminal Core
 * 
 * Core functionality for the terminal, handling state management
 * and providing interfaces for other components.
 */ 





class $513ac137fd2efb00$var$TerminalCore {
    constructor(){
        // Core configuration
        this.config = {
            name: 'techno_punks_terminal',
            historySize: 100,
            greetings: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('terminal.welcome'),
            prompt: (0, $b1294981df4c9a64$export$1613a8bb42ebacf3).DEFAULT
        };
        // Terminal state
        this.commandHistory = [];
        this.historyIndex = -1;
        this.initialized = false;
        // Set up event listeners for core functionality
        this.setupEventListeners();
    }
    /**
   * Initialize the terminal core
   */ initialize() {
        if (this.initialized) {
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).info('Terminal core already initialized');
            return this;
        }
        (0, $9bb4c1574855072f$export$2e2bcd8739ae039).info('Initializing terminal core');
        this.initialized = true;
        // Emit initialization event
        (0, $71235d8e4bbe5195$export$f6644f0f2c90144b).emit((0, $021ae3ea6a11655c$export$212b227673290756).CORE_INITIALIZED, this);
        return this;
    }
    /**
   * Set up event listeners for core functionality
   */ setupEventListeners() {
        (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug('[TerminalCore] Setting up event listeners');
        try {
            // Check if eventBus is available
            if (!(0, $71235d8e4bbe5195$export$f6644f0f2c90144b)) {
                (0, $9bb4c1574855072f$export$2e2bcd8739ae039).error('[TerminalCore] ERROR: eventBus is undefined or null');
                return;
            }
            // Listen for command execution requests
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug('[TerminalCore] Registering listener for EXECUTE event:', (0, $021ae3ea6a11655c$export$212b227673290756).EXECUTE);
            (0, $71235d8e4bbe5195$export$f6644f0f2c90144b).on((0, $021ae3ea6a11655c$export$212b227673290756).EXECUTE, (command)=>{
                (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug('[TerminalCore] EXECUTE event received with command:', command);
                this.executeCommand(command);
            });
            // Listen for command history navigation
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug('[TerminalCore] Registering listener for NAVIGATE event:', (0, $021ae3ea6a11655c$export$212b227673290756).NAVIGATE);
            (0, $71235d8e4bbe5195$export$f6644f0f2c90144b).on((0, $021ae3ea6a11655c$export$212b227673290756).NAVIGATE, (direction)=>{
                (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug('[TerminalCore] NAVIGATE event received with direction:', direction);
                const historyEntry = this.navigateHistory(direction);
                (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug('[TerminalCore] Emitting ENTRY event with history entry:', historyEntry);
                (0, $71235d8e4bbe5195$export$f6644f0f2c90144b).emit((0, $021ae3ea6a11655c$export$212b227673290756).ENTRY, historyEntry);
            });
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug('[TerminalCore] Event listeners set up successfully');
        } catch (error) {
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).error('[TerminalCore] ERROR: Failed to set up event listeners:', error);
        }
    }
    /**
   * Execute a command
   * @param {string} command - Command to execute
   */ executeCommand(command) {
        if (!command) {
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).warn('[TerminalCore] Empty command received, ignoring');
            return;
        }
        (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug('[TerminalCore] Executing command:', command);
        try {
            // Add to history
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug('[TerminalCore] Adding command to history');
            this.addToHistory(command);
            // Check if eventBus is available
            if (!(0, $71235d8e4bbe5195$export$f6644f0f2c90144b)) {
                (0, $9bb4c1574855072f$export$2e2bcd8739ae039).error('[TerminalCore] ERROR: eventBus is undefined or null');
                return;
            }
            // Debug event listeners
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug('[TerminalCore] DEBUG: Current listeners for PROCESS event:', (0, $71235d8e4bbe5195$export$f6644f0f2c90144b)._getListeners ? (0, $71235d8e4bbe5195$export$f6644f0f2c90144b)._getListeners((0, $021ae3ea6a11655c$export$212b227673290756).PROCESS) : 'eventBus._getListeners not available');
            // Emit command processing event
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug('[TerminalCore] Emitting PROCESS event for command:', command, 'Event name:', (0, $021ae3ea6a11655c$export$212b227673290756).PROCESS);
            (0, $71235d8e4bbe5195$export$f6644f0f2c90144b).emit((0, $021ae3ea6a11655c$export$212b227673290756).PROCESS, command);
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug('[TerminalCore] PROCESS event emitted successfully');
        } catch (error) {
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).error('[TerminalCore] ERROR: Failed to execute command:', error);
        }
    }
    /**
   * Add a command to history
   * @param {string} command - Command to add
   */ addToHistory(command) {
        if (!command) {
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).warn('[TerminalCore] Empty command received for history, ignoring');
            return;
        }
        (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug('[TerminalCore] Adding command to history:', command);
        try {
            // Only add if it's not the same as the most recent command
            if (this.commandHistory.length === 0 || this.commandHistory[0] !== command) {
                (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug('[TerminalCore] Command is unique, adding to history');
                this.commandHistory.unshift(command);
                // Trim history if it exceeds the maximum size
                if (this.commandHistory.length > this.config.historySize) {
                    (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug('[TerminalCore] History exceeds max size, trimming');
                    this.commandHistory.pop();
                }
            } else (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug('[TerminalCore] Command is duplicate of most recent, not adding to history');
            // Reset history navigation index
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug('[TerminalCore] Resetting history navigation index');
            this.historyIndex = -1;
        } catch (error) {
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).error('[TerminalCore] ERROR: Failed to add command to history:', error);
        }
    }
    /**
   * Navigate command history
   * @param {string} direction - 'up' or 'down'
   * @returns {Object} History entry information
   */ navigateHistory(direction) {
        if (this.commandHistory.length === 0) return {
            command: '',
            index: -1
        };
        // Store current index before navigation
        const previousIndex = this.historyIndex;
        // Navigate up (older commands)
        if (direction === 'up') {
            if (this.historyIndex < this.commandHistory.length - 1) this.historyIndex++;
        } else if (direction === 'down') {
            if (this.historyIndex > -1) this.historyIndex--;
        }
        // Get the command at the current index
        let command = '';
        if (this.historyIndex === -1) command = '';
        else command = this.commandHistory[this.historyIndex];
        return {
            command: command,
            index: this.historyIndex,
            previousIndex: previousIndex
        };
    }
    /**
   * Get the current command history
   * @returns {string[]} Command history array
   */ getCommandHistory() {
        return [
            ...this.commandHistory
        ];
    }
    /**
   * Set the terminal prompt
   * @param {string} prompt - New prompt text
   */ setPrompt(prompt) {
        this.config.prompt = prompt;
        (0, $71235d8e4bbe5195$export$f6644f0f2c90144b).emit((0, $021ae3ea6a11655c$export$212b227673290756).PROMPT_CHANGED, prompt);
    }
    /**
   * Get the current terminal prompt
   * @returns {string} Current prompt
   */ getPrompt() {
        return this.config.prompt;
    }
    /**
   * Get terminal greeting message
   * @returns {string} Greeting message
   */ getGreeting() {
        return this.config.greetings;
    }
}
// Create singleton instance
const $513ac137fd2efb00$var$terminalCore = new $513ac137fd2efb00$var$TerminalCore();
var $513ac137fd2efb00$export$2e2bcd8739ae039 = $513ac137fd2efb00$var$terminalCore;




class $4c14fafc46b0fd8d$var$TerminalView {
    constructor(){
        // DOM elements
        this.terminalElement = null;
        this.outputElement = null;
        this.inputElement = null;
        this.promptElement = null;
        // Cursor manager
        this.cursorManager = null;
        // State
        this.initialized = false;
        this.isAttemptingSelection = false; // Flag to track if user is selecting text with mouse
        // Animation delays
        this.CHARACTER_ANIMATION_DELAY_MS = 0; // Set to 0 for instant line reveal
        this.LINE_ANIMATION_BASE_DELAY_MS = 4; // Drastically reduced for a faster, more authentic feel
        this.LINE_ANIMATION_VARIATION_MS = 2; // Minimal variation for a rapid cascade effect
        this.MINIMUM_LINE_DELAY_MS = 1; // Minimum delay to ensure it's not too fast
        // Dispatch table for rendering different output types
        this.outputRenderers = {
            html: (item)=>this._renderHtml(item),
            text: (item)=>this._renderText(item),
            command: (item)=>this.displayCommand(item.content),
            menu: (item)=>this.displayMenu(item.content),
            error: (item)=>this.displayError(item.content),
            success: (item)=>this.displaySuccess(item.content),
            warning: (item)=>this.displayWarning(item.content),
            svg_block: (item)=>this.displaySvg(item.content),
            clear: ()=>this.clear(),
            greeting: (item)=>this.showGreeting(item.content),
            prompt: (item)=>this.animatePrompt(item.content)
        };
    }
    // --- Helper methods for output ---
    /**
   * Display an interactive menu in the terminal.
   * @param {Object} menuData - The menu data containing title, options, and callback.
   */ async displayMenu(menuData) {
        if (menuData.title) this._addStaticOutputLine(menuData.title, 'terminal-menu-title');
        const menuContainer = document.createElement('div');
        menuContainer.className = 'terminal-menu';
        menuData.options.forEach((option)=>{
            const optionElement = document.createElement('a');
            optionElement.href = '#';
            optionElement.className = 'terminal-menu-option';
            optionElement.innerHTML = option.label; // Use innerHTML for emoji flags
            optionElement.addEventListener('click', (e)=>{
                e.preventDefault();
                if (menuContainer.classList.contains('disabled')) return;
                menuContainer.classList.add('disabled');
                optionElement.classList.add('selected');
                if (menuData.callback) menuData.callback(option.value);
            });
            menuContainer.appendChild(optionElement);
        });
        this.outputElement.appendChild(menuContainer);
        this.scrollToBottom();
    }
    /**
   * Appends a new line to the terminal output and returns the element.
   * This is useful for dynamic content that needs to be updated in place, like a spinner.
   * @param {string} initialContent - Optional initial content for the line.
   * @param {string} className - Optional CSS class for the line.
   * @returns {HTMLElement} The created line element.
   */ appendLine(initialContent = '', className = 'terminal-line') {
        const lineElement = document.createElement('div');
        lineElement.className = className;
        lineElement.innerHTML = initialContent; // Use innerHTML to allow simple tags
        this.outputElement.appendChild(lineElement);
        this.scrollToBottom();
        return lineElement;
    }
    /**
   * Updates the content of a specific line element in the terminal.
   * @param {HTMLElement} lineElement - The DOM element of the line to update.
   * @param {string} newContent - The new HTML content for the line.
   */ updateLine(lineElement, newContent) {
        if (lineElement) {
            lineElement.innerHTML = newContent;
            this.scrollToBottom();
        }
    }
    /**
   * Removes a specific line element from the terminal.
   * @param {HTMLElement} lineElement - The DOM element of the line to remove.
   */ removeLine(lineElement) {
        if (lineElement && lineElement.parentNode === this.outputElement) this.outputElement.removeChild(lineElement);
    }
    _addStaticOutputLine(content, className = '') {
        const lineContainer = document.createElement('div');
        if (className) lineContainer.className = className;
        if (content instanceof HTMLElement) lineContainer.appendChild(content);
        else // For strings or other types, use innerHTML to correctly render any HTML tags.
        // This also handles plain text correctly.
        lineContainer.innerHTML = String(content);
        this.outputElement.appendChild(lineContainer);
        this.scrollToBottom();
        return lineContainer;
    }
    async _animateTextOutput(text, baseClassName = '', targetContainer = null) {
        const effectiveCharDelay = this.CHARACTER_ANIMATION_DELAY_MS;
        const outputTarget = this.outputElement; // Always append new lines to the main output element
        if (!outputTarget) {
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).error("TerminalView: this.outputElement is not available in _animateTextOutput.");
            return;
        }
        const lines = String(text).split('\n');
        let currentLineElement = targetContainer; // Use targetContainer for the first line if provided
        for(let i = 0; i < lines.length; i++){
            let lineText = lines[i];
            if (!currentLineElement || i > 0) {
                currentLineElement = document.createElement('div');
                if (baseClassName) currentLineElement.className = baseClassName;
                outputTarget.appendChild(currentLineElement);
            }
            if (lineText.length === 0) {
                currentLineElement.innerHTML = '&nbsp;'; // Ensure empty lines take up space
                this.scrollToBottom();
            } else {
                if (currentLineElement.innerHTML === '&nbsp;') currentLineElement.innerHTML = '';
                // Check if line contains [[VPL]] and replace with a link
                if (lineText.includes('[[VPL]]')) {
                    const parts = lineText.split('[[VPL]]');
                    const link = document.createElement('a');
                    link.href = 'https://viralpubliclicense.org/VPL.txt';
                    link.target = '_blank';
                    link.rel = 'noopener noreferrer';
                    link.textContent = 'VPL';
                    link.style.textDecoration = 'none';
                    link.style.color = 'inherit';
                    link.style.cursor = 'pointer';
                    currentLineElement.textContent = '';
                    currentLineElement.appendChild(document.createTextNode(parts[0]));
                    currentLineElement.appendChild(link);
                    if (parts[1]) currentLineElement.appendChild(document.createTextNode(parts[1]));
                } else if (effectiveCharDelay > 0) for(let j = 0; j < lineText.length; j++){
                    await new Promise((resolve)=>setTimeout(resolve, effectiveCharDelay));
                    currentLineElement.textContent += lineText[j];
                    this.scrollToBottom(); // Scroll as text is added
                }
                else {
                    // If char delay is 0, set the whole line content at once
                    currentLineElement.textContent = lineText;
                    this.scrollToBottom(); // Scroll after line is added
                }
            }
            if (i < lines.length - 1) {
                const randomVariation = Math.random() * 2 * this.LINE_ANIMATION_VARIATION_MS - this.LINE_ANIMATION_VARIATION_MS;
                let currentLineDelay = this.LINE_ANIMATION_BASE_DELAY_MS + randomVariation;
                currentLineDelay = Math.max(this.MINIMUM_LINE_DELAY_MS, currentLineDelay); // Ensure minimum delay
                await new Promise((resolve)=>setTimeout(resolve, currentLineDelay));
            }
        }
    }
    // --- End Helper methods ---
    /**
   * Initialize the terminal view
   * @returns {Object} Terminal view instance
   */ async initialize() {
        if (this.initialized) {
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug('Terminal view already initialized');
            return this;
        }
        try {
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug('Initializing terminal view...');
            // Get the terminal container
            this.terminalElement = document.getElementById('terminal');
            if (!this.terminalElement) {
                (0, $9bb4c1574855072f$export$2e2bcd8739ae039).error('Terminal container not found');
                return this;
            }
            // Make sure the terminal is visible
            this.terminalElement.style.display = 'block';
            // Clear any existing content
            this.terminalElement.innerHTML = '';
            // Create terminal output container
            this.outputElement = document.createElement('div');
            this.outputElement.className = 'terminal-output';
            this.terminalElement.appendChild(this.outputElement);
            // Show static password prompt
            // Show the initial greeting using the i18n-powered message
            this.showGreeting((0, $513ac137fd2efb00$export$2e2bcd8739ae039).getGreeting());
            // Create input line for user
            this.createInputLine();
            // Focus the input
            this.inputElement.focus();
            // Set up event listeners
            this.setupEventListeners();
            // Mark as initialized
            this.initialized = true;
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug('Terminal view initialized successfully');
            // Emit initialization event
            (0, $71235d8e4bbe5195$export$f6644f0f2c90144b).emit((0, $021ae3ea6a11655c$export$212b227673290756).VIEW_INITIALIZED, this);
            // Listen for language changes to refresh the greeting
            (0, $71235d8e4bbe5195$export$f6644f0f2c90144b).on('language:changed', ()=>{
                const rawGreeting = (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('welcome');
                const greeting = rawGreeting.replace(/\[.*?]/, '[help]');
                // Animate transition to new language with rolling effect
                this.fancyUpdateGreeting(greeting);
            });
            return this;
        } catch (error) {
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).error('Error initializing terminal view:', error);
            alert('Error initializing terminal view: ' + error.message);
            return this;
        }
    }
    /**
   * Create the input line with prompt and input field
   * Only one input line should exist at a time.
   */ createInputLine() {
        // Remove any existing input line
        const oldInputLine = this.terminalElement.querySelector('.terminal-input-line');
        if (oldInputLine) oldInputLine.remove();
        // Create input line container
        const inputLine = document.createElement('div');
        inputLine.className = 'terminal-input-line';
        // Create prompt
        this.promptElement = document.createElement('span');
        this.promptElement.className = 'terminal-prompt';
        this.promptElement.textContent = (0, $513ac137fd2efb00$export$2e2bcd8739ae039).getPrompt();
        inputLine.appendChild(this.promptElement);
        // Create a wrapper for the input 
        const inputContainer = document.createElement('div');
        inputContainer.className = 'input-container';
        // Create input field
        this.inputElement = document.createElement('input');
        this.inputElement.className = 'terminal-input';
        this.inputElement.type = 'text';
        this.inputElement.autocomplete = 'off';
        this.inputElement.spellcheck = false;
        inputContainer.appendChild(this.inputElement);
        // Append container to line
        inputLine.appendChild(inputContainer);
        // Clear the input field's value
        this.inputElement.value = '';
        // Initialize the CursorManager (underscore insertion approach)
        this.cursorManager = new (0, $3c9a4dced859611e$export$2e2bcd8739ae039)();
        this.cursorManager.initialize(inputLine, this.inputElement);
        this.terminalElement.appendChild(inputLine);
        (0, $71235d8e4bbe5195$export$f6644f0f2c90144b).emit('terminal:input:element:ready', this.inputElement);
        if (this.inputElement) this.inputElement.focus();
    }
    /**
   * Get version information from the DOM
   * @returns {Object} Version information
   */ getVersionInfo() {
        try {
            const versionElement = document.getElementById('version-display');
            const version = versionElement ? versionElement.textContent.replace('Version: ', '') : 'unknown';
            return {
                text: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('terminal.version', {
                    version: version
                }),
                className: 'terminal-version'
            };
        } catch (error) {
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).error('Error getting version info:', error);
            return {
                text: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('terminal.version', {
                    version: 'unknown'
                }),
                className: 'terminal-version'
            };
        }
    }
    /**
   * Set up event listeners for the view
   */ setupEventListeners() {
        // Listen for prompt changes
        (0, $71235d8e4bbe5195$export$f6644f0f2c90144b).on((0, $021ae3ea6a11655c$export$212b227673290756).PROMPT_CHANGED, (prompt)=>{
            if (this.promptElement) this.promptElement.textContent = prompt;
        });
        // Listen for command output
        (0, $71235d8e4bbe5195$export$f6644f0f2c90144b).on((0, $021ae3ea6a11655c$export$212b227673290756).ADD, (output)=>{
            this.displayOutput(output);
        });
        // Listen for clear command
        (0, $71235d8e4bbe5195$export$f6644f0f2c90144b).on((0, $021ae3ea6a11655c$export$212b227673290756).CLEAR, ()=>{
            this.clear();
        });
        // Listen for history navigation start (up/down arrow pressed)
        (0, $71235d8e4bbe5195$export$f6644f0f2c90144b).on((0, $021ae3ea6a11655c$export$212b227673290756).NAVIGATE, ()=>{
            if (this.cursorManager && typeof this.cursorManager.pauseBlinking === 'function') this.cursorManager.pauseBlinking();
        });
        // Listen for history navigation results
        (0, $71235d8e4bbe5195$export$f6644f0f2c90144b).on((0, $021ae3ea6a11655c$export$212b227673290756).ENTRY, (entry)=>{
            if (this.inputElement && entry) {
                // Pause blinking before updating value
                if (this.cursorManager && typeof this.cursorManager.pauseBlinking === 'function') this.cursorManager.pauseBlinking();
                // Update the input value
                if (window.techno_punks && window.techno_punks.Terminal && window.techno_punks.Terminal.inputHandler && typeof window.techno_punks.Terminal.inputHandler.setValue === 'function') window.techno_punks.Terminal.inputHandler.setValue(entry.command);
                else {
                    (0, $9bb4c1574855072f$export$2e2bcd8739ae039).warn('[TerminalView] InputHandler.setValue not available. Setting input value directly.');
                    this.inputElement.value = entry.command;
                    if (this.cursorManager && typeof this.cursorManager.syncWithValue === 'function') this.cursorManager.syncWithValue(entry.command);
                }
                // Resume blinking after a short delay to ensure all updates are complete
                setTimeout(()=>{
                    if (this.cursorManager && typeof this.cursorManager.resumeBlinking === 'function') this.cursorManager.resumeBlinking();
                }, 50);
            }
        });
        // --- ROBUST CLICK vs. DRAG-SELECT HANDLING ---
        // This logic reliably distinguishes between a user clicking to focus the input
        // and dragging to select text, preventing the input from stealing focus during selection.
        let mouseDownPos = null;
        const CLICK_THRESHOLD = 5; // Max pixels moved to be considered a click.
        if (this.terminalElement) {
            // 1. On mousedown, record the starting position.
            this.terminalElement.addEventListener('mousedown', (event)=>{
                // We only care about the primary mouse button (usually left).
                if (event.button === 0) mouseDownPos = {
                    x: event.clientX,
                    y: event.clientY
                };
                else mouseDownPos = null; // Ignore other buttons (right-click, etc.)
            });
            // 2. On click, decide whether to focus based on mouse movement.
            this.terminalElement.addEventListener('click', (event)=>{
                // If the user clicked on an interactive element, do nothing.
                if (event.target.tagName === 'A' || event.target.tagName === 'INPUT' || event.target.tagName === 'BUTTON') return;
                // Check if the mouse moved significantly between mousedown and click.
                if (mouseDownPos) {
                    const dx = Math.abs(event.clientX - mouseDownPos.x);
                    const dy = Math.abs(event.clientY - mouseDownPos.y);
                    // If it's a 'true' click (not a drag)...
                    if (dx < CLICK_THRESHOLD && dy < CLICK_THRESHOLD) {
                        // ...only focus the input if no text selection is active.
                        // A double-click creates a selection, so this prevents focus-stealing.
                        const selection = window.getSelection();
                        if (selection && selection.isCollapsed) this.inputElement.focus({
                            preventScroll: true
                        });
                    }
                }
                // If the mouse moved more, it was a drag-select, so we do nothing.
                // Reset for the next click cycle.
                mouseDownPos = null;
            });
        }
    }
    /**
   * Animate the prompt text with overlapping random rolls.
   * @param {string} text - Prompt text to animate
   * @returns {Promise}
   */ async animatePrompt(text) {
        if (!this.promptElement) return;
        // clear current prompt
        this.promptElement.innerHTML = '';
        // create spans for each character
        const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const chars = text.split('');
        const spans = chars.map((ch)=>{
            const span = document.createElement('span');
            span.dataset.final = ch;
            span.textContent = '';
            this.promptElement.appendChild(span);
            return span;
        });
        // animation settings
        const stagger = 80;
        const rollCount = 6;
        const interval = 50;
        // roll each span
        const promises = spans.map((span, idx)=>new Promise((resolve)=>{
                setTimeout(()=>{
                    let rolls = 0;
                    const timer = setInterval(()=>{
                        if (rolls < rollCount) {
                            span.textContent = letters.charAt(Math.floor(Math.random() * letters.length));
                            rolls++;
                        } else {
                            clearInterval(timer);
                            span.textContent = span.dataset.final;
                            resolve();
                        }
                    }, interval);
                }, idx * stagger);
            }));
        return Promise.all(promises);
    }
    /**
   * Show greeting message
   * @param {string} greeting - Greeting message
   */ /**
   * Render the greeting message with rich formatting.
   * The message may contain placeholders like [help] that should be underlined / highlighted.
   * @param {string} greeting - The raw greeting string from i18n.
   */ showGreeting(greeting) {
        if (!greeting) return;
        // Find or create the greeting container
        let container = this.outputElement.querySelector('.welcome-message');
        if (!container) {
            container = document.createElement('div');
            container.className = 'welcome-message';
            this.outputElement.appendChild(container);
        }
        // Display greeting exactly as provided (including square brackets)
        container.textContent = greeting;
        // Ensure there is a spacer line after the greeting for proper spacing
        let spacer = this.outputElement.querySelector('.welcome-spacer');
        if (!spacer) {
            spacer = document.createElement('div');
            spacer.className = 'welcome-spacer';
            spacer.innerHTML = '&nbsp;';
            this.outputElement.appendChild(spacer);
        }
        this.scrollToBottom();
    }
    /**
   * Display command in the terminal as selectable text (prompt + user input)
   * @param {string} command - Command to display
   */ displayCommand(command) {
        const oldInputLine = this.terminalElement.querySelector('.terminal-input-line');
        if (oldInputLine) oldInputLine.remove();
        const fullCommandText = (0, $513ac137fd2efb00$export$2e2bcd8739ae039).getPrompt() + command;
        const loggedCommandSpan = document.createElement('span');
        loggedCommandSpan.className = 'terminal-command terminal-user-input';
        loggedCommandSpan.textContent = fullCommandText;
        // Use _addStaticOutputLine for instant display of the command echo.
        // The class 'command-output historical-prompt-line' applies to the line container.
        return this._addStaticOutputLine(loggedCommandSpan, 'command-output historical-prompt-line');
    }
    /**
   * Display output in the terminal.
   * Handles strings, HTML objects, and arrays of mixed content.
   * @param {*} output - The content to display.
   */ /**
   * Renders a single output item using the dispatch table.
   * @param {Object|string} item - The item to render.
   * @private
   */ async _renderOutputItem(item) {
        if (typeof item === 'string') // Handle plain strings by treating them as text output
        return this._renderText({
            content: item
        });
        const renderer = this.outputRenderers[item.type];
        if (renderer) await renderer(item);
        else if (item) // Default to object handler for complex or unknown data types
        this.handleResultObject(item);
    }
    // --- Private Render Helpers ---
    async _renderHtml(item) {
        // This function should NOT animate. It adds a static line of HTML.
        this._addStaticOutputLine(item.content);
    }
    async _renderText(item) {
        // Use the new animator for text to get the line-by-line effect.
        await this._animateLines(item.content, item.className || '');
    }
    /**
   * Pauses for a short, slightly randomized duration to simulate a typewriter effect.
   * @private
   */ async _animateLines(text, className = '') {
        const lines = String(text).split('\n');
        for (const line of lines){
            this._addStaticOutputLine(line, className);
            await this._pauseBetweenLines();
        }
    }
    /**
   * Pauses for a short, slightly randomized duration to simulate a typewriter effect.
   * @private
   */ _pauseBetweenLines() {
        const delay = this.LINE_ANIMATION_BASE_DELAY_MS + Math.random() * this.LINE_ANIMATION_VARIATION_MS - this.LINE_ANIMATION_VARIATION_MS / 2;
        const finalDelay = Math.max(this.MINIMUM_LINE_DELAY_MS, delay);
        return new Promise((resolve)=>setTimeout(resolve, finalDelay));
    }
    async displayOutput(output) {
        if (!output) {
            this.ensurePromptVisible();
            return;
        }
        try {
            if (Array.isArray(output)) // Handle mixed-content arrays
            for(let i = 0; i < output.length; i++){
                await this._renderOutputItem(output[i]);
                // Add a delay after each item for the line-by-line effect
                if (i < output.length - 1) {
                    const randomVariation = Math.random() * 2 * this.LINE_ANIMATION_VARIATION_MS - this.LINE_ANIMATION_VARIATION_MS;
                    let lineDelay = this.LINE_ANIMATION_BASE_DELAY_MS + randomVariation;
                    lineDelay = Math.max(this.MINIMUM_LINE_DELAY_MS, lineDelay);
                    await new Promise((resolve)=>setTimeout(resolve, lineDelay));
                }
            }
            else // Fallback for single, non-array results
            await this._renderOutputItem(output);
        } catch (error) {
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).error('Error displaying output:', error);
            this._addStaticOutputLine(String(output), 'command-output error');
        } finally{
            this.ensurePromptVisible();
        }
    }
    /**
   * Handle a result object in the display
   * @param {Object} item - The result object to handle
   */ async handleResultObject(item) {
        if (item.error) await this._animateTextOutput(item.error, 'terminal-error');
        else if (item.type === 'html' || item.type === 'html_block' || item.html || item.className === 'raw-html-output') {
            // Handle complex HTML content statically
            const htmlContentContainer = document.createElement('div');
            htmlContentContainer.className = item.className || ''; // Use provided class or default
            htmlContentContainer.innerHTML = item.html || item.message || item.content || ''; // Prefer .html or .content
            this.output.appendChild(htmlContentContainer);
            // Execute any scripts in the HTML (existing logic)
            const scripts = htmlContentContainer.getElementsByTagName('script');
            Array.from(scripts).forEach((script)=>{
                const newScript = document.createElement('script');
                if (script.src) newScript.src = script.src;
                else newScript.textContent = script.textContent;
                // Appending to body and removing might not always be ideal, but it's the existing logic.
                document.body.appendChild(newScript).parentNode.removeChild(newScript);
            });
            this._addStaticOutputLine(htmlContentContainer); // Add the fully formed HTML element statically
        } else if (item.text || item.message) await this._animateTextOutput(item.text || item.message, item.className || 'command-output');
        else if (item.type === 'success') await this._animateTextOutput(item.message || item.content || JSON.stringify(item), 'terminal-success');
        else if (item.type === 'warning') await this._animateTextOutput(item.message || item.content || JSON.stringify(item), 'terminal-warning');
        else if (item.type === 'svg') this.displaySvg(item.content || item.svg); // SVGs are complex, add statically via existing method
        else // Default for other objects: stringify and animate as plain text
        await this._animateTextOutput(JSON.stringify(item), 'command-output');
    }
    /**
   * Display SVG content
   * @param {string} svgContent - SVG content to display
   */ displaySvg(svgContent) {
        if (!svgContent) return;
        const container = document.createElement('div');
        container.className = 'terminal-svg-container';
        // Create a wrapper to control SVG colors through CSS
        const wrapper = document.createElement('div');
        wrapper.className = 'svg-theme-wrapper';
        wrapper.innerHTML = svgContent;
        // Add the wrapper to the container
        container.appendChild(wrapper);
        // Add the container to the output
        this.outputElement.appendChild(container);
        this.scrollToBottom();
    }
    /**
   * Ensure the prompt is visible and properly positioned
   */ ensurePromptVisible() {
        // Force a reflow to ensure the DOM is updated
        this.outputElement.offsetHeight;
        // Scroll to the bottom to ensure the prompt is visible
        this.scrollToBottom();
        // Focus the input for the next command
        this.inputElement.focus();
    }
    /**
   * Clear the terminal
   */ clear() {
        // Remove all output lines except greeting and spacer to lock layout
        const children = Array.from(this.outputElement.children);
        children.forEach((child)=>{
            if (!child.classList.contains('welcome-message') && !child.classList.contains('welcome-spacer')) this.outputElement.removeChild(child);
        });
        // Reset cursor and input line
        if (this.cursorManager) this.cursorManager.show();
        this.createInputLine();
        if (this.inputElement) this.inputElement.focus();
    }
    /**
   * Remove existing greeting and spacer
   */ removeGreeting() {
        if (this.outputElement) {
            const greetingEl = this.outputElement.querySelector('.welcome-message');
            if (greetingEl) // Hide greeting but preserve its space to avoid layout jump
            greetingEl.style.visibility = 'hidden';
            const spacer = this.outputElement.querySelector('.welcome-spacer');
            if (spacer) spacer.remove();
        }
    }
    /**
   * Update existing greeting in place with new text
   * @param {string} greeting - New greeting message
   */ updateGreeting(greeting) {
        const greetingEl = this.outputElement.querySelector('.welcome-message');
        if (!greetingEl) return;
        // clear prior text
        greetingEl.innerHTML = '';
        // animate into existing container and then add spacer
        this._animateTextOutput(greeting, '', greetingEl).then(()=>{
            const spacer = document.createElement('div');
            spacer.className = 'welcome-spacer';
            greetingEl.parentNode.insertBefore(spacer, greetingEl.nextSibling);
            this.outputElement.offsetHeight; // force reflow
            this.scrollToBottom();
        }).catch((error)=>(0, $9bb4c1574855072f$export$2e2bcd8739ae039).error('Error updating greeting:', error));
    }
    /**
   * Prepend a greeting message above all existing lines
   * @param {string} greeting - Greeting message
   * @returns {Promise} resolves after animation
   */ prependGreeting(greeting) {
        if (!this.outputElement) return Promise.resolve();
        // Create container at top
        const greetingContainer = document.createElement('div');
        greetingContainer.className = 'welcome-message';
        this.outputElement.insertBefore(greetingContainer, this.outputElement.firstChild);
        // Animate text into it and add spacer
        return this._animateTextOutput(greeting, '', greetingContainer).then(()=>{
            const spacer = document.createElement('div');
            spacer.className = 'welcome-spacer';
            this.outputElement.insertBefore(spacer, greetingContainer.nextSibling);
            this.outputElement.offsetHeight;
            this.scrollToBottom();
        }).catch((error)=>(0, $9bb4c1574855072f$export$2e2bcd8739ae039).error('Error prepending greeting:', error));
    }
    /**
   * Fancy animate a greeting with overlapping character rolls.
   * @param {string} text - Greeting text to animate
   * @returns {Promise} resolves when animation completes
   */ fancyAnimateGreeting(text) {
        if (!this.outputElement) return Promise.resolve();
        // Reuse or create greeting container at top
        let container = this.outputElement.querySelector('.welcome-message');
        const firstTimeFA = !container;
        if (firstTimeFA) {
            container = document.createElement('div');
            container.className = 'welcome-message';
            this.outputElement.insertBefore(container, this.outputElement.firstChild);
        } else container.innerHTML = '';
        // Make sure it's visible
        container.style.visibility = 'visible';
        const chars = text.split('');
        const spans = chars.map((ch)=>{
            const span = document.createElement('span');
            span.dataset.final = ch;
            span.textContent = '';
            container.appendChild(span);
            return span;
        });
        const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const stagger = 40; // ms between starts (50% faster)
        const rollCount = 6; // rolls per character
        const interval = 25; // ms per roll (50% faster)
        const promises = spans.map((span, idx)=>new Promise((resolve)=>{
                setTimeout(()=>{
                    let rolls = 0;
                    const timer = setInterval(()=>{
                        if (rolls < rollCount) {
                            span.textContent = letters.charAt(Math.floor(Math.random() * letters.length));
                            rolls++;
                        } else {
                            clearInterval(timer);
                            span.textContent = span.dataset.final;
                            resolve();
                        }
                    }, interval);
                }, idx * stagger);
            }));
        return Promise.all(promises).then(()=>{
            // Ensure spacer exists
            let spacer = this.outputElement.querySelector('.welcome-spacer');
            if (!spacer) {
                spacer = document.createElement('div');
                spacer.className = 'welcome-spacer';
                this.outputElement.appendChild(spacer);
            }
            // Make sure spacer is visible
            spacer.style.visibility = 'visible';
            this.scrollToBottom();
        }).catch((error)=>(0, $9bb4c1574855072f$export$2e2bcd8739ae039).error('Error in fancyAnimateGreeting:', error));
    }
    /**
   * Fancy animate an existing greeting message with overlapping character rolls.
   * @param {string} text - Greeting text to animate
   * @returns {Promise}
   */ async fancyUpdateGreeting(text) {
        const greetingEl = this.outputElement.querySelector('.welcome-message');
        if (!greetingEl) return;
        // clear existing text
        greetingEl.innerHTML = '';
        // create spans for each character
        const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const fullText = text || 'Welcome to the abyss. Type [help] to interact.';
        const helpStartIndex = fullText.indexOf('[help]') + 1; // start after '['
        const helpEndIndex = helpStartIndex + 4;
        const chars = fullText.split('');
        const spans = chars.map((ch, index)=>{
            const span = document.createElement('span');
            span.dataset.final = ch;
            span.textContent = '';
            if (index >= helpStartIndex && index < helpEndIndex) span.classList.add('bold-text');
            greetingEl.appendChild(span);
            return span;
        });
        const stagger = 26; // ms between starts (35% faster)
        const rollCount = 6;
        const interval = 16; // ms per roll (35% faster)
        const promises = spans.map((span, idx)=>new Promise((resolve)=>{
                setTimeout(()=>{
                    let rolls = 0;
                    const timer = setInterval(()=>{
                        if (rolls < rollCount) {
                            span.textContent = letters.charAt(Math.floor(Math.random() * letters.length));
                            rolls++;
                        } else {
                            clearInterval(timer);
                            span.textContent = span.dataset.final;
                            resolve();
                        }
                    }, interval);
                }, idx * stagger);
            }));
        await Promise.all(promises);
        // Ensure single spacer exists just once
        let spacer = this.outputElement.querySelector('.welcome-spacer');
        if (!spacer) {
            spacer = document.createElement('div');
            spacer.className = 'welcome-spacer';
            greetingEl.parentNode.insertBefore(spacer, greetingEl.nextSibling);
        }
        this.scrollToBottom();
    }
    /**
   * Scroll terminal to bottom
   */ scrollToBottom() {
        if (this.terminalElement) // Use requestAnimationFrame for smoother scrolling
        requestAnimationFrame(()=>{
            this.terminalElement.scrollTo({
                top: this.terminalElement.scrollHeight,
                behavior: 'auto' // Changed from 'smooth' for an instant, authentic terminal scroll
            });
        });
    }
    /**
   * Display error message
   * @param {string} message - Error message
   */ async displayError(message) {
        await this._animateTextOutput(message, 'terminal-error');
    // scrollToBottom is handled by _animateTextOutput
    }
    /**
   * Display success message
   * @param {string} message - Success message
   */ async displaySuccess(message) {
        await this._animateTextOutput(message, 'terminal-success');
    // scrollToBottom is handled by _animateTextOutput
    }
    /**
   * Display warning message
   * @param {string} message - Warning message
   */ async displayWarning(message) {
        await this._animateTextOutput(message, 'terminal-warning');
    // scrollToBottom is handled by _animateTextOutput
    }
}
// Create singleton instance
const $4c14fafc46b0fd8d$var$terminalView = new $4c14fafc46b0fd8d$var$TerminalView();
var $4c14fafc46b0fd8d$export$2e2bcd8739ae039 = $4c14fafc46b0fd8d$var$terminalView;


class $837ae274f7e5dde1$export$7f7cbe89f1eacd2 {
    constructor(terminal, message = 'Processing...'){
        this.terminal = terminal;
        this.frames = [
            "\u280B",
            "\u2819",
            "\u2839",
            "\u2838",
            "\u283C",
            "\u2834",
            "\u2826",
            "\u2827",
            "\u2807",
            "\u280F"
        ];
        this.message = message;
        this.interval = null;
        this.frameIndex = 0;
        // A DOM element will be created by the terminal, we just manage it.
        this.lineElement = null;
    }
    start() {
        // Ask the terminal to create a new line and give us the element
        this.lineElement = this.terminal.appendLine('');
        this.interval = setInterval(()=>{
            const frame = this.frames[this.frameIndex];
            this.frameIndex = (this.frameIndex + 1) % this.frames.length;
            // Update the content of the spinner line
            this.terminal.updateLine(this.lineElement, `${this.message} ${frame}`);
        }, 80);
    }
    stop() {
        if (this.interval) {
            clearInterval(this.interval);
            this.interval = null;
            // Update the line one last time to show just the message, removing the spinner.
            this.terminal.updateLine(this.lineElement, this.message);
        }
    }
}



var $a0e3c3d309077ea3$export$2e2bcd8739ae039 = {
    name: 'mint',
    category: 'web3',
    async handler (args, onMessage) {
        if (!(0, $e33331d7b228d1b4$export$fbdf49c3d9d0256e).getConnectedAccount()) return (0, $f88579f0fbda1b2c$export$4bd700f3a55acd36)('web3.error.notConnectedBeforeMint');
        // --- Argument Parsing ---
        if (!args.length) return (0, $f88579f0fbda1b2c$export$4bd700f3a55acd36)('help.mint.error.missingArgs');
        const collectionName = args[0];
        let quantity = 1; // Default to 1
        if (args[1]) quantity = parseInt(args[1], 10);
        const bgIndex = args.indexOf('--bg');
        const textIndex = args.indexOf('--text');
        const bgColor = bgIndex !== -1 && args[bgIndex + 1] ? args[bgIndex + 1] : null;
        const textColor = textIndex !== -1 && args[textIndex + 1] ? args[textIndex + 1] : null;
        // --- Input Validation ---
        if (!collectionName || collectionName.toLowerCase() !== 'techno_punks') return (0, $f88579f0fbda1b2c$export$4bd700f3a55acd36)('terminal.error.unknownCollection', {
            collectionName: collectionName || ''
        });
        if (isNaN(quantity) || quantity < 1 || quantity > 20) return (0, $f88579f0fbda1b2c$export$4bd700f3a55acd36)('help.mint.error.invalidQuantity');
        const hexColorRegex = /^#[0-9a-fA-F]{6}$/;
        if (bgColor && !hexColorRegex.test(bgColor)) return (0, $f88579f0fbda1b2c$export$4bd700f3a55acd36)('terminal.error.invalidBgColor', {
            bgColor: bgColor
        });
        if (textColor && !hexColorRegex.test(textColor)) return (0, $f88579f0fbda1b2c$export$4bd700f3a55acd36)('terminal.error.invalidTextColor', {
            textColor: textColor
        });
        // --- Execution ---
        const spinner = new (0, $837ae274f7e5dde1$export$7f7cbe89f1eacd2)((0, $4c14fafc46b0fd8d$export$2e2bcd8739ae039), (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('web3.info.contactingBlockchain'));
        spinner.start();
        // Set up 2-minute timeout warning
        const timeoutWarning = setTimeout(()=>{
            onMessage([
                {
                    type: 'text',
                    content: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('terminal.info.transactionTakingLong')
                }
            ]);
        }, 120000); // 2 minutes
        try {
            // --- Step 1: Mint the NFTs ---
            // Unified minting: use mintNFT for both single and multiple quantities with progress callback
            const mintResults = await (0, $e33331d7b228d1b4$export$fbdf49c3d9d0256e).mintNFT(quantity, (progressMessage)=>{
                // Check if message contains a transaction hash and make it clickable
                const hashRegex = /(0x[a-fA-F0-9]{64})/g;
                if (hashRegex.test(progressMessage)) {
                    const messageWithLinks = progressMessage.replace(hashRegex, (hash)=>{
                        return `<a href="https://explorer.hyperliquid-testnet.xyz/tx/${hash}" target="_blank" style="text-decoration: none; color: inherit;">${hash}</a>`;
                    });
                    onMessage([
                        {
                            type: 'html',
                            content: messageWithLinks
                        }
                    ]);
                } else onMessage([
                    {
                        type: 'text',
                        content: progressMessage
                    }
                ]);
            });
            clearTimeout(timeoutWarning);
            spinner.stop();
            const successMessage = (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('terminal.success.minted', {
                count: mintResults.length
            }).replace(/[{}]/g, '');
            // Build the full message array before sending
            const messages = [
                {
                    type: 'html',
                    content: `<b>${successMessage}</b>`
                },
                {
                    type: 'text',
                    content: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('terminal.success.mintedTokensList')
                }
            ];
            mintResults.forEach((result)=>{
                const pair = result.pair.replace(/[{}]/g, '');
                const hyperliquidUrl = `https://www.hyperscan.com/token/${(0, $a408f50754b95311$export$ad5b2d2dcc6ff48c)}/instance/${result.tokenId}`;
                messages.push({
                    type: 'html',
                    content: `&nbsp;&nbsp;- #${result.tokenId} <a href="${hyperliquidUrl}" target="_blank" style="text-decoration: none; color: inherit;">(${pair})</a>`
                });
            });
            onMessage(messages);
            // --- Step 2: Set Colors (if provided) ---
            if (bgColor && textColor) {
                onMessage([
                    {
                        type: 'text',
                        content: `\n${(0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('terminal.info.customizationStart', {
                            count: mintResults.length
                        })}`
                    },
                    {
                        type: 'text',
                        content: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('terminal.info.approveTransactions')
                    }
                ]);
                for(let i = 0; i < mintResults.length; i++){
                    const result = mintResults[i];
                    onMessage([
                        {
                            type: 'text',
                            content: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('terminal.info.customizingToken', {
                                tokenId: result.tokenId,
                                i: i + 1,
                                count: mintResults.length
                            })
                        }
                    ]);
                    const colorTxHash = await (0, $e33331d7b228d1b4$export$fbdf49c3d9d0256e).customizeToken(result.tokenId, {
                        backgroundColor: bgColor,
                        textColor: textColor
                    }, ()=>{
                        onMessage([
                            {
                                type: 'text',
                                content: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('web3.info.colorTxApproved', {
                                    tokenId: result.tokenId
                                })
                            }
                        ]);
                    });
                    onMessage([
                        {
                            type: 'html',
                            content: `&nbsp;&nbsp;- ${(0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('terminal.success.colorsUpdated', {
                                tokenId: result.tokenId
                            })} <a href="https://sepolia.etherscan.io/tx/${colorTxHash}" target="_blank">${(0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('web3.info.viewOnExplorer')}</a>`
                        }
                    ]);
                }
            }
            return []; // Return empty array on success
        } catch (error) {
            clearTimeout(timeoutWarning);
            spinner.stop();
            return (0, $f88579f0fbda1b2c$export$4bd700f3a55acd36)('web3.error.generic', {
                message: error.message
            });
        }
    },
    get help () {
        return {
            summary: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('help.mint.summary'),
            detailed: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('help.mint.detailed', {
                returnObjects: true
            }),
            error: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('help.mint.error', {
                returnObjects: true
            })
        };
    }
};








var $b299bf8fb35cff28$export$2e2bcd8739ae039 = {
    name: 'connect',
    category: 'web3',
    async handler (args, onMessage) {
        const spinner = new (0, $837ae274f7e5dde1$export$7f7cbe89f1eacd2)((0, $4c14fafc46b0fd8d$export$2e2bcd8739ae039), (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('web3.info.connecting'));
        try {
            const connectedAccount = (0, $e33331d7b228d1b4$export$fbdf49c3d9d0256e).getConnectedAccount();
            if (connectedAccount) return (0, $f88579f0fbda1b2c$export$a10e5d9502088fe8)('web3.info.walletAlreadyConnected', {
                account: connectedAccount
            });
            spinner.start();
            // Delegate connection logic entirely to the web3 handler.
            // It will find the best provider or throw a translated error if none is found.
            const newAccount = await (0, $e33331d7b228d1b4$export$fbdf49c3d9d0256e).connectWallet();
            spinner.stop();
            const message = (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('web3.success.walletConnected', {
                account: newAccount
            });
            return [
                {
                    type: 'text',
                    content: message
                }
            ];
        } catch (error) {
            spinner.stop();
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).error(`Connect command failed: ${error.message}`);
            // The error from web3-handler should already be translated.
            // Stop the spinner and then display the error message;
            return (0, $f88579f0fbda1b2c$export$d1b5f35845094891)(error.message);
        }
    },
    get help () {
        return {
            summary: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('help.connect.summary'),
            detailed: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('help.connect.detailed', {
                returnObjects: true
            })
        };
    }
};





var $32a7fe16d7830f9f$export$2e2bcd8739ae039 = {
    name: 'disconnect',
    category: 'web3',
    handler () {
        try {
            (0, $e33331d7b228d1b4$export$fbdf49c3d9d0256e).disconnectWallet();
            return (0, $f88579f0fbda1b2c$export$a10e5d9502088fe8)('web3.success.walletDisconnected');
        } catch (error) {
            return (0, $f88579f0fbda1b2c$export$4bd700f3a55acd36)('web3.error.notConnected');
        }
    },
    get help () {
        return {
            summary: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('help.disconnect.summary'),
            detailed: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('help.disconnect.detailed', {
                returnObjects: true
            })
        };
    }
};




var $532237a869c67ca4$export$2e2bcd8739ae039 = {
    name: 'roadmap',
    category: 'info',
    /**
   * Handler for the 'roadmap' command.
   * Returns a Promise that resolves with the command output.
   */ async handler () {
        return (0, $fed0e6595511e144$export$9349fa50e00cf228)('commands.roadmap');
    },
    /**
   * The help text is now a getter to defer i18n calls.
   */ get help () {
        return {
            summary: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('help.roadmap.summary'),
            detailed: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('help.roadmap.detailed', {
                returnObjects: true
            })
        };
    }
};








var $e0edd1c4712620ac$export$2e2bcd8739ae039 = {
    name: 'status',
    category: 'web3',
    async handler (args, onMessage) {
        onMessage([
            {
                type: 'html',
                content: ''
            }
        ]); // Add empty line before spinner
        const spinner = new (0, $837ae274f7e5dde1$export$7f7cbe89f1eacd2)((0, $4c14fafc46b0fd8d$export$2e2bcd8739ae039), (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('web3.info.fetchingCollectionInfo'));
        spinner.start();
        try {
            const info = await (0, $e33331d7b228d1b4$export$fbdf49c3d9d0256e).getCollectionInfo();
            spinner.stop();
            const output = [
                {
                    type: 'html',
                    content: ''
                },
                {
                    type: 'html',
                    content: `<strong class="command-title">${(0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('web3.status.title')}</strong>`
                },
                {
                    type: 'html',
                    content: `${(0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('web3.status.name')}: ${info.name} (${info.symbol})`
                },
                {
                    type: 'html',
                    content: `${(0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('web3.status.contractAddress')}: ${info.contractAddress}`
                },
                {
                    type: 'html',
                    content: `${(0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('web3.status.price')}: ${info.price} ETH`
                },
                {
                    type: 'html',
                    content: `${(0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('web3.status.minted')}: ${info.totalSupply} / ${info.maxSupply}`
                },
                {
                    type: 'html',
                    content: ''
                } // Add empty line after info
            ];
            onMessage(output);
            return [];
        } catch (error) {
            spinner.stop();
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).error(`Status error: ${error.message}`);
            return (0, $f88579f0fbda1b2c$export$4bd700f3a55acd36)(error.message);
        }
    },
    get help () {
        return {
            summary: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('help.status.summary'),
            detailed: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('help.status.detailed', {
                returnObjects: true
            })
        };
    }
};



var $42d9b47039374476$export$2e2bcd8739ae039 = {
    name: 'supply',
    category: 'info',
    async handler () {
        const content = (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('commands.supply');
        return content.map((line)=>({
                type: 'text',
                content: line
            }));
    },
    get help () {
        return {
            summary: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('help.supply.summary'),
            detailed: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('help.supply.detailed', {
                returnObjects: true
            })
        };
    }
};





var $212f796fa35c0654$export$2e2bcd8739ae039 = {
    name: 'team',
    category: 'info',
    /**
   * Handler for the 'team' command.
   * It's async to implicitly return a Promise.
   */ async handler () {
        return (0, $fed0e6595511e144$export$9349fa50e00cf228)('commands.team');
    },
    /**
   * The help text is now a getter to defer i18n calls.
   */ get help () {
        return {
            summary: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('help.team.summary'),
            detailed: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('help.team.detailed', {
                returnObjects: true
            })
        };
    }
};




var $c1b86db81d5366dc$export$2e2bcd8739ae039 = {
    name: 'winamp',
    category: 'other',
    /**
   * Toggles the music player's visibility.
   */ async handler () {
        const player = window.musicPlayer;
        if (player && typeof player.toggleVisibility === 'function') {
            player.toggleVisibility();
            // A command handler must return an array of output objects.
            return []; // No text output on success
        } else return (0, $f88579f0fbda1b2c$export$4bd700f3a55acd36)('terminal.error.noWinamp');
    },
    /**
   * The help text is now a getter to defer i18n calls.
   */ get help () {
        return {
            summary: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('help.winamp.summary'),
            detailed: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('help.winamp.detailed', {
                returnObjects: true
            })
        };
    }
};








var $752ad3282cf3ee56$export$2e2bcd8739ae039 = {
    name: 'list',
    category: 'web3',
    async handler () {
        if (!(0, $e33331d7b228d1b4$export$fbdf49c3d9d0256e).getConnectedAccount()) return (0, $f88579f0fbda1b2c$export$4bd700f3a55acd36)('web3.error.notConnected');
        const spinner = new (0, $837ae274f7e5dde1$export$7f7cbe89f1eacd2)((0, $4c14fafc46b0fd8d$export$2e2bcd8739ae039), (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('web3.info.contactingBlockchain'));
        spinner.start();
        try {
            const nfts = await (0, $e33331d7b228d1b4$export$fbdf49c3d9d0256e).getOwnedNFTs();
            spinner.stop();
            if (nfts.length === 0) return (0, $f88579f0fbda1b2c$export$a10e5d9502088fe8)('web3.info.noNFTsFound');
            const nftElements = nfts.map((nft)=>{
                const hyperliquidUrl = `https://www.hyperscan.com/token/${(0, $a408f50754b95311$export$ad5b2d2dcc6ff48c)}/instance/${nft.tokenId}`;
                // Use full SVG without cropping to preserve background colors
                // Scaling and centering will be handled by CSS
                let svgContent = nft.svgImage;
                // Sanitize the SVG content before rendering to prevent XSS attacks
                return `<a href="${hyperliquidUrl}" target="_blank" class="nft-card">${DOMPurify.sanitize(svgContent)}</a>`;
            }).join('');
            // Note the 'nfts-container' class for styling
            const htmlOutput = `
<br/>
<div class="nfts-container">
  ${nftElements}
</div>
<br/>
`;
            return [
                {
                    type: 'html',
                    content: htmlOutput
                }
            ];
        } catch (error) {
            spinner.stop();
            return (0, $f88579f0fbda1b2c$export$4bd700f3a55acd36)(error.message);
        }
    },
    get help () {
        return {
            summary: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('help.list.summary'),
            detailed: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('help.list.detailed', {
                returnObjects: true
            })
        };
    }
};





/**
 * Theme Manager
 * Handles theme switching and persistence
 */ 

const $9a59af7bf3cb6c08$var$ThemeManager = {
    // Available themes
    themes: [
        'dark',
        'light',
        'custom'
    ],
    /**
   * Initialize theme from localStorage or use dark theme as default
   */ init () {
        const savedTheme = localStorage.getItem('preferredTheme') || 'dark';
        this.setTheme(savedTheme);
        // Emit event that theme system is ready
        (0, $71235d8e4bbe5195$export$f6644f0f2c90144b).emit('theme:initialized');
        // Setup media query listener for system theme changes
        this.setupSystemThemeListener();
    },
    /**
   * Setup listener for system theme preference changes
   */ setupSystemThemeListener () {
        const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
        // Initial check
        const systemTheme = mediaQuery.matches ? 'dark' : 'light';
        // Don't overwrite user preference, but log the system preference
        (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug(`System theme preference: ${systemTheme}`);
        // Listen for changes
        const handleChange = (e)=>{
            const newSystemTheme = e.matches ? 'dark' : 'light';
            (0, $71235d8e4bbe5195$export$f6644f0f2c90144b).emit('theme:systemPreferenceChanged', newSystemTheme);
            // If the user hasn't set a preference, follow system
            if (!localStorage.getItem('preferredTheme')) this.setTheme(newSystemTheme);
        };
        // Add the listener using the appropriate method
        if (mediaQuery.addEventListener) mediaQuery.addEventListener('change', handleChange);
        else // Fallback for older browsers
        mediaQuery.addListener(handleChange);
    },
    /**
   * Set the current theme
   * @param {string} themeName - Name of the theme to set
   */ setTheme (themeName) {
        // Validate theme name
        if (!this.themes.includes(themeName)) {
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).warn(`Theme '${themeName}' not found. Using 'dark' as fallback.`);
            themeName = 'dark';
        }
        // Apply theme by adding the appropriate class to the body
        this.applyThemeStyles(themeName);
        // Save preference
        localStorage.setItem('preferredTheme', themeName);
        // Emit event for theme change
        (0, $71235d8e4bbe5195$export$f6644f0f2c90144b).emit('theme:changed', themeName);
        return themeName;
    },
    /**
   * Set a custom theme with specific colors
   * @param {string} backgroundColor - Hex color for background
   * @param {string} textColor - Hex color for text
   */ setCustomTheme (backgroundColor, textColor) {
        // Validate hex colors
        if (!this.isValidHexColor(backgroundColor) || !this.isValidHexColor(textColor)) throw new Error('Invalid hex color format. Use format: #ffffff');
        // Store custom theme data
        const customTheme = {
            backgroundColor: backgroundColor,
            textColor: textColor,
            timestamp: Date.now()
        };
        localStorage.setItem('customTheme', JSON.stringify(customTheme));
        // Apply custom theme
        this.applyCustomThemeStyles(customTheme);
        // Set current theme to custom
        localStorage.setItem('preferredTheme', 'custom');
        // Emit event for theme change
        (0, $71235d8e4bbe5195$export$f6644f0f2c90144b).emit('theme:changed', 'custom');
        return 'custom';
    },
    /**
   * Validate hex color format
   * @param {string} color - Color to validate
   * @returns {boolean} True if valid hex color
   */ isValidHexColor (color) {
        return /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(color);
    },
    /**
   * Apply custom theme styles to CSS variables
   * @param {Object} customTheme - Custom theme configuration
   */ applyCustomThemeStyles (customTheme) {
        const root = document.documentElement;
        // Apply custom colors to CSS variables
        root.style.setProperty('--color-background', customTheme.backgroundColor);
        root.style.setProperty('--color-text-primary', customTheme.textColor);
        root.style.setProperty('--color-svg-background', customTheme.backgroundColor);
        root.style.setProperty('--color-svg-text', customTheme.textColor);
        root.style.setProperty('--color-svg-border', customTheme.textColor);
        // Remove theme classes and add custom class
        const elements = [
            document.documentElement,
            document.body
        ];
        elements.forEach((el)=>{
            el.classList.remove('dark-theme', 'light-theme');
            el.classList.add('custom-theme');
        });
        (0, $9bb4c1574855072f$export$2e2bcd8739ae039).info(`Applied custom theme: bg=${customTheme.backgroundColor}, text=${customTheme.textColor}`);
    },
    /**
   * Get stored custom theme data
   * @returns {Object|null} Custom theme data or null if not set
   */ getCustomTheme () {
        const stored = localStorage.getItem('customTheme');
        return stored ? JSON.parse(stored) : null;
    },
    /**
   * Check if custom theme is available
   * @returns {boolean} True if custom theme exists
   */ hasCustomTheme () {
        return this.getCustomTheme() !== null;
    },
    /**
   * Apply theme styles to the document
   * @private
   * @param {string} themeName - Name of the theme to apply
   */ applyThemeStyles (themeName) {
        if (themeName === 'custom') {
            // Handle custom theme
            const customTheme = this.getCustomTheme();
            if (customTheme) this.applyCustomThemeStyles(customTheme);
            else {
                // Fallback to dark if no custom theme stored
                (0, $9bb4c1574855072f$export$2e2bcd8739ae039).warn('Custom theme requested but no custom theme data found. Falling back to dark.');
                this.applyThemeStyles('dark');
            }
            return;
        }
        // Remove any existing theme classes from document elements
        const elements = [
            document.documentElement,
            document.body
        ];
        elements.forEach((el)=>{
            // Remove all theme classes
            el.classList.remove('dark-theme', 'light-theme', 'custom-theme');
            // Add the new theme class
            el.classList.add(`${themeName}-theme`);
        });
        // Reset any custom CSS variables that might have been set
        const root = document.documentElement;
        root.style.removeProperty('--color-background');
        root.style.removeProperty('--color-text-primary');
        root.style.removeProperty('--color-svg-background');
        root.style.removeProperty('--color-svg-text');
        root.style.removeProperty('--color-svg-border');
        // Force a reflow to ensure styles are recalculated
        document.body.offsetHeight;
        (0, $9bb4c1574855072f$export$2e2bcd8739ae039).info(`Applied theme: ${themeName} to document elements`);
    },
    /**
   * Toggle between themes in cycle: dark → light → custom → dark (if custom exists)
   */ toggleTheme () {
        const currentTheme = this.getCurrentTheme();
        const hasCustom = this.hasCustomTheme();
        if (!hasCustom) {
            // No custom theme, just toggle between dark and light
            const newTheme = currentTheme === 'dark' ? 'light' : 'dark';
            return this.setTheme(newTheme);
        }
        // Three-way toggle: dark → light → custom → dark
        let newTheme;
        switch(currentTheme){
            case 'dark':
                newTheme = 'light';
                break;
            case 'light':
                newTheme = 'custom';
                break;
            case 'custom':
                newTheme = 'dark';
                break;
            default:
                newTheme = 'dark';
        }
        return this.setTheme(newTheme);
    },
    /**
   * Get the current theme name
   * @returns {string} Current theme name
   */ getCurrentTheme () {
        return localStorage.getItem('preferredTheme') || 'dark';
    },
    /**
   * Get the current theme configuration
   * @returns {Object} Current theme configuration
   */ getCurrentThemeData () {
        const themeName = this.getCurrentTheme();
        return this.themes[themeName] || this.themes.dark;
    }
};
var $9a59af7bf3cb6c08$export$2e2bcd8739ae039 = $9a59af7bf3cb6c08$var$ThemeManager;


const $79df29e09416baa9$var$command = {
    name: 'set',
    category: 'system',
    async handler (args, onMessage) {
        if (args.length < 1) return (0, $f88579f0fbda1b2c$export$4bd700f3a55acd36)('web3.error.setMissingArgs');
        const subcommand = args[0];
        // Handle theme subcommand
        if (subcommand === 'theme') return await this.handleThemeCommand(args.slice(1), onMessage);
        if (!(0, $e33331d7b228d1b4$export$fbdf49c3d9d0256e).getConnectedAccount()) return (0, $f88579f0fbda1b2c$export$4bd700f3a55acd36)('web3.error.notConnected');
        // Handle token customization (existing functionality)
        if (args.length < 2) return (0, $f88579f0fbda1b2c$export$4bd700f3a55acd36)('web3.error.setMissingArgs');
        const tokenId = args[0];
        const backgroundColor = $79df29e09416baa9$var$getArgValue(args, '--bg');
        const textColor = $79df29e09416baa9$var$getArgValue(args, '--text');
        if (!backgroundColor && !textColor) return (0, $f88579f0fbda1b2c$export$4bd700f3a55acd36)('web3.error.setInvalidArgs');
        try {
            const owner = await (0, $e33331d7b228d1b4$export$fbdf49c3d9d0256e).getOwnerOf(tokenId);
            const connectedAccount = (0, $e33331d7b228d1b4$export$fbdf49c3d9d0256e).getConnectedAccount();
            if (owner.toLowerCase() !== connectedAccount.toLowerCase()) return (0, $f88579f0fbda1b2c$export$4bd700f3a55acd36)('web3.error.notOwner', {
                tokenId: tokenId
            });
            onMessage({
                type: 'info',
                message: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('web3.info.sendingCustomization', {
                    tokenId: tokenId
                })
            });
            const txHash = await (0, $e33331d7b228d1b4$export$fbdf49c3d9d0256e).customizeToken(tokenId, backgroundColor, textColor, (hash)=>{
                onMessage({
                    type: 'info',
                    message: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('web3.info.txSent', {
                        hash: hash
                    })
                });
            });
            onMessage({
                type: 'success',
                message: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('web3.info.customizationSuccess', {
                    tokenId: tokenId,
                    txHash: txHash
                })
            });
        } catch (error) {
            return (0, $f88579f0fbda1b2c$export$4bd700f3a55acd36)(error.message);
        }
    },
    async handleThemeCommand (args, onMessage) {
        const backgroundColor = $79df29e09416baa9$var$getArgValue(args, '--bg');
        const textColor = $79df29e09416baa9$var$getArgValue(args, '--text');
        // Check for predefined theme names
        if (args.length === 1 && [
            'dark',
            'light'
        ].includes(args[0])) try {
            (0, $9a59af7bf3cb6c08$export$2e2bcd8739ae039).setTheme(args[0]);
            onMessage({
                type: 'success',
                message: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('theme.switched', {
                    themeName: args[0]
                })
            });
            return;
        } catch (error) {
            return (0, $f88579f0fbda1b2c$export$d1b5f35845094891)((0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('theme.setFailed', {
                message: error.message
            }));
        }
        // Handle custom theme
        if (!backgroundColor || !textColor) {
            const customThemeError = `${(0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('theme.customMissingParams')}\n${(0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('theme.customUsage')}\n${(0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('theme.customOr')}`;
            return (0, $f88579f0fbda1b2c$export$d1b5f35845094891)(customThemeError);
        }
        try {
            (0, $9a59af7bf3cb6c08$export$2e2bcd8739ae039).setCustomTheme(backgroundColor, textColor);
            const successMessage = `${(0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('theme.customApplied')}\n${(0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('theme.customBackground', {
                backgroundColor: backgroundColor
            })}\n${(0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('theme.customText', {
                textColor: textColor
            })}\n${(0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('theme.customUsageHint')}`;
            onMessage({
                type: 'success',
                message: successMessage
            });
        } catch (error) {
            throw new Error((0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('terminal.error.failedToSetCustomTheme', {
                message: error.message
            }));
        }
    },
    get help () {
        return {
            summary: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('help.set.summary'),
            detailed: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('help.set.detailed', {
                returnObjects: true
            })
        };
    }
};
function $79df29e09416baa9$var$getArgValue(args, argName) {
    const index = args.indexOf(argName);
    if (index !== -1 && args.length > index + 1) return args[index + 1];
    return null;
}
var $79df29e09416baa9$export$2e2bcd8739ae039 = $79df29e09416baa9$var$command;



// Accessibility helpers
let $bc85ba126ff65bb2$var$statusEl = null;
let $bc85ba126ff65bb2$var$previousFocus = null;
function $bc85ba126ff65bb2$var$ensureStatusEl() {
    if ($bc85ba126ff65bb2$var$statusEl) return;
    $bc85ba126ff65bb2$var$statusEl = document.createElement('div');
    $bc85ba126ff65bb2$var$statusEl.id = 'draw-mode-status';
    $bc85ba126ff65bb2$var$statusEl.setAttribute('role', 'status');
    $bc85ba126ff65bb2$var$statusEl.setAttribute('aria-live', 'polite');
    // Visually hidden but accessible to screen readers
    Object.assign($bc85ba126ff65bb2$var$statusEl.style, {
        position: 'absolute',
        width: '1px',
        height: '1px',
        overflow: 'hidden',
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(50%)',
        whiteSpace: 'nowrap'
    });
    document.body.appendChild($bc85ba126ff65bb2$var$statusEl);
}
function $bc85ba126ff65bb2$var$announce(message) {
    $bc85ba126ff65bb2$var$ensureStatusEl();
    $bc85ba126ff65bb2$var$statusEl.textContent = message;
}
let $bc85ba126ff65bb2$var$active = false;
function $bc85ba126ff65bb2$export$39e04e72f972b885() {
    return $bc85ba126ff65bb2$var$active;
}
function $bc85ba126ff65bb2$export$e668df1bcd81e4d2() {
    if ($bc85ba126ff65bb2$var$active) return;
    $bc85ba126ff65bb2$var$previousFocus = document.activeElement;
    document.body.classList.add('matrix-draw-fullscreen');
    $bc85ba126ff65bb2$var$announce('Draw mode on');
    $bc85ba126ff65bb2$var$active = true;
    document.addEventListener('keydown', $bc85ba126ff65bb2$var$handleKeyDown);
    // Notify other modules
    (0, $71235d8e4bbe5195$export$f6644f0f2c90144b).emit('draw:state', {
        active: true
    });
}
function $bc85ba126ff65bb2$export$5c525e238923a57d() {
    if (!$bc85ba126ff65bb2$var$active) return;
    $bc85ba126ff65bb2$var$active = false;
    document.removeEventListener('keydown', $bc85ba126ff65bb2$var$handleKeyDown);
    document.body.classList.remove('matrix-draw-fullscreen');
    $bc85ba126ff65bb2$var$announce('Draw mode off');
    if ($bc85ba126ff65bb2$var$previousFocus && typeof $bc85ba126ff65bb2$var$previousFocus.focus === 'function') $bc85ba126ff65bb2$var$previousFocus.focus();
    $bc85ba126ff65bb2$var$previousFocus = null;
    (0, $71235d8e4bbe5195$export$f6644f0f2c90144b).emit('draw:state', {
        active: false
    });
}
function $bc85ba126ff65bb2$export$e03c1c3201ee8bb7() {
    $bc85ba126ff65bb2$var$active ? $bc85ba126ff65bb2$export$5c525e238923a57d() : $bc85ba126ff65bb2$export$e668df1bcd81e4d2();
}
function $bc85ba126ff65bb2$var$handleKeyDown(event) {
    const { key: key } = event;
    if (key === 'Escape') {
        $bc85ba126ff65bb2$export$5c525e238923a57d();
        return;
    }
    // Accept single printable characters only
    if (key.length === 1) (0, $71235d8e4bbe5195$export$f6644f0f2c90144b).emit('draw:keyInput', {
        char: key,
        shift: event.shiftKey
    });
}



const $f675ad67b8aefe06$var$handler = async ()=>{
    (0, $bc85ba126ff65bb2$export$e668df1bcd81e4d2)();
    return [];
};
const $f675ad67b8aefe06$var$drawCommand = {
    name: 'draw',
    handler: $f675ad67b8aefe06$var$handler,
    category: 'other',
    get help () {
        return {
            summary: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('help.draw.summary'),
            detailed: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('help.draw.detailed', {
                returnObjects: true
            })
        };
    }
};
var $f675ad67b8aefe06$export$2e2bcd8739ae039 = [
    $f675ad67b8aefe06$var$drawCommand
];








// The API endpoint for the verification bot
const $9c28882e07a81ec5$var$API_ENDPOINT = 'https://verif-bot.sm-p.workers.dev/api';
async function $9c28882e07a81ec5$var$startVerification(terminal, discordId) {
    terminal.showSpinner((0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('verify.connecting'));
    await (0, $e33331d7b228d1b4$export$fbdf49c3d9d0256e).connectWallet();
    const walletAddress = (0, $e33331d7b228d1b4$export$fbdf49c3d9d0256e).getConnectedAccount();
    if (!walletAddress) {
        terminal.hideSpinner();
        terminal.display_output((0, $f88579f0fbda1b2c$export$4bd700f3a55acd36)((0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('verify.connectionFailed')));
        return;
    }
    const timestamp = Date.now();
    const nonce = Math.random().toString(36).substring(2, 10);
    const message = `Verify NFT ownership for Discord user ${discordId} at ${timestamp} nonce:${nonce}`;
    try {
        const web3 = (0, $e33331d7b228d1b4$export$fbdf49c3d9d0256e).getWeb3Instance();
        if (!web3) throw new Error((0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('web3.error.notConnected'));
        terminal.showSpinner((0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('verify.signMessage'));
        const signature = await web3.eth.personal.sign(message, walletAddress, '');
        terminal.showSpinner((0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('verify.sending'));
        const response = await fetch(`${$9c28882e07a81ec5$var$API_ENDPOINT}/verify`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                discord_user_id: discordId,
                wallet_address: walletAddress,
                signature: signature,
                message: message
            })
        });
        terminal.hideSpinner();
        const result = await response.json();
        if (response.ok) terminal.display_output((0, $f88579f0fbda1b2c$export$a10e5d9502088fe8)((0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('verify.success', {
            message: result.message
        })));
        else terminal.display_output((0, $f88579f0fbda1b2c$export$4bd700f3a55acd36)((0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('verify.failed', {
            error: result.error || 'Verification failed.'
        })));
    } catch (error) {
        terminal.hideSpinner();
        terminal.display_output((0, $f88579f0fbda1b2c$export$4bd700f3a55acd36)(error.message));
    }
}
async function $9c28882e07a81ec5$var$checkStatus(terminal) {
    terminal.showSpinner((0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('verify.connecting'));
    await (0, $e33331d7b228d1b4$export$fbdf49c3d9d0256e).connectWallet();
    const walletAddress = (0, $e33331d7b228d1b4$export$fbdf49c3d9d0256e).getConnectedAccount();
    if (!walletAddress) {
        terminal.hideSpinner();
        terminal.display_output((0, $f88579f0fbda1b2c$export$4bd700f3a55acd36)((0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('verify.connectionFailed')));
        return;
    }
    try {
        terminal.showSpinner((0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('verify.checkingStatus'));
        const response = await fetch(`${$9c28882e07a81ec5$var$API_ENDPOINT}/status/${walletAddress}`);
        const result = await response.json();
        terminal.hideSpinner();
        if (response.ok) {
            if (result.isVerified) {
                terminal.display_output((0, $f88579f0fbda1b2c$export$a10e5d9502088fe8)((0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('verify.statusVerified')));
                terminal.display_output((0, $f88579f0fbda1b2c$export$a10e5d9502088fe8)((0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('verify.discordUser', {
                    username: result.username,
                    discordId: result.discordId
                })));
                terminal.display_output((0, $f88579f0fbda1b2c$export$a10e5d9502088fe8)((0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('verify.walletAddress', {
                    walletAddress: result.walletAddress
                })));
                terminal.display_output((0, $f88579f0fbda1b2c$export$a10e5d9502088fe8)((0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('verify.verifiedOn', {
                    timestamp: new Date(result.timestamp).toLocaleString()
                })));
            } else {
                terminal.display_output((0, $f88579f0fbda1b2c$export$a10e5d9502088fe8)((0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('verify.statusNotVerified')));
                terminal.display_output((0, $f88579f0fbda1b2c$export$a10e5d9502088fe8)((0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('verify.startProcess')));
            }
        } else terminal.display_output((0, $f88579f0fbda1b2c$export$4bd700f3a55acd36)((0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('verify.failed', {
            error: result.error || (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('verify.statusCheckFailed')
        })));
    } catch (error) {
        terminal.hideSpinner();
        terminal.display_output((0, $f88579f0fbda1b2c$export$4bd700f3a55acd36)(error.message));
    }
}
function $9c28882e07a81ec5$var$showHelp(terminal) {
    const helpLines = (0, $99cb74956199a5ee$export$2e2bcd8739ae039)._generateSpecificHelp('verify');
    // `helpLines` is already an array of formatted output objects, so we can
    // forward it directly to the terminal without additional wrapping.
    terminal.display_output(helpLines);
}
const $9c28882e07a81ec5$var$command = {
    name: 'verify',
    description: 'Verify NFT ownership for Discord role.',
    handler: async (args, onMessage)=>{
        // Adapt legacy verify implementation to the new command API (args, onMessage)
        // by creating a lightweight adapter that bridges the old `terminal.*` calls
        // to the new `onMessage` mechanism.
        const terminal = {
            display_output: onMessage,
            showSpinner: (msg)=>onMessage({
                    type: 'progress',
                    payload: msg
                }),
            hideSpinner: ()=>onMessage({
                    type: 'progress',
                    payload: null
                }),
            get_input: async ()=>{
                // This is a placeholder. The new API doesn't support interactive input in the same way.
                return '';
            }
        };
        const subcommand = args[0];
        if (!subcommand || subcommand === 'help') {
            $9c28882e07a81ec5$var$showHelp(terminal);
            return;
        }
        if (subcommand === 'check') {
            await $9c28882e07a81ec5$var$checkStatus(terminal);
            return;
        } else if (subcommand.match(/^\d{17,19}$/)) {
            await $9c28882e07a81ec5$var$startVerification(terminal, subcommand);
            return;
        } else {
            terminal.display_output((0, $f88579f0fbda1b2c$export$4bd700f3a55acd36)((0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('verify.invalidSubcommand')));
            $9c28882e07a81ec5$var$showHelp(terminal);
            return;
        }
    },
    get help () {
        return {
            summary: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('help.verify.summary'),
            detailed: (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('help.verify.detailed', {
                returnObjects: true
            })
        };
    }
};
var $9c28882e07a81ec5$export$2e2bcd8739ae039 = $9c28882e07a81ec5$var$command;


const $0808c24ea45aa105$var$commandsToRegister = [
    // General & Info Commands
    (0, $2966cd2d0f830ca4$export$2e2bcd8739ae039),
    (0, $7ad47922de20c1c7$export$2e2bcd8739ae039),
    (0, $99cb74956199a5ee$export$2e2bcd8739ae039),
    (0, $2416c3000702f1af$export$2e2bcd8739ae039),
    (0, $253a6eee8a7cc8a4$export$2e2bcd8739ae039),
    (0, $03e758ae5663d963$export$2e2bcd8739ae039),
    (0, $532237a869c67ca4$export$2e2bcd8739ae039),
    (0, $e0edd1c4712620ac$export$2e2bcd8739ae039),
    (0, $42d9b47039374476$export$2e2bcd8739ae039),
    (0, $212f796fa35c0654$export$2e2bcd8739ae039),
    (0, $c1b86db81d5366dc$export$2e2bcd8739ae039),
    // Web3 Commands
    (0, $b299bf8fb35cff28$export$2e2bcd8739ae039),
    (0, $32a7fe16d7830f9f$export$2e2bcd8739ae039),
    (0, $a0e3c3d309077ea3$export$2e2bcd8739ae039),
    (0, $9c28882e07a81ec5$export$2e2bcd8739ae039),
    // System & Utility
    ...(0, $c7b194d1b1a58078$export$2e2bcd8739ae039),
    (0, $752ad3282cf3ee56$export$2e2bcd8739ae039),
    (0, $79df29e09416baa9$export$2e2bcd8739ae039),
    // Experimental
    ...(0, $f675ad67b8aefe06$export$2e2bcd8739ae039)
];
/**
 * Initializes the command system by registering all imported commands.
 */ function $0808c24ea45aa105$export$e221c030e056eb5e() {
    $0808c24ea45aa105$var$commandsToRegister.forEach((command)=>{
        // The commandsToRegister array is now a flat list of command objects.
        if (command) (0, $d12c20e2463c3ec8$export$2e2bcd8739ae039).register(command);
    });
}


/**
 * Terminal
 * 
 * Main terminal class that integrates core, view, and controller components.
 * This implements the facade pattern to provide a simple interface to the terminal.
 */ 



/**
 * Terminal Controller
 * 
 * Handles user input and command execution for the terminal.
 */ 








class $02c3c0481866b8e1$export$2e2bcd8739ae039 {
    constructor(controller){
        this.controller = controller;
        this.PASSWORD = 'unknown'; // hard-coded gimmick
    }
    /**
   * Authenticate the user
   * @param {string} password - Password to check
   */ async authenticate(password) {
        const trimmed = password.trim();
        const view = this.controller.terminal.view;
        const core = this.controller.terminal.core;
        if (trimmed === this.PASSWORD) {
            this.controller.isAuthenticated = true;
            const greetingEl = view.outputElement.querySelector('.welcome-message');
            if (greetingEl) greetingEl.style.visibility = 'hidden';
            const oldSpacer = view.outputElement.querySelector('.welcome-spacer');
            if (oldSpacer) oldSpacer.style.visibility = 'hidden';
            const rawGreeting = (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('welcome');
            core.config.greetings = rawGreeting.replace(/\[.*?]/, '[help]');
            await view.fancyAnimateGreeting(core.getGreeting());
            await view.displaySuccess('Terminal unlocked.');
            this.controller.terminal.inputHandler.setPasswordMode(false);
            core.setPrompt((0, $b1294981df4c9a64$export$1613a8bb42ebacf3).ANONYMOUS);
            view.createInputLine();
            return true;
        } else {
            await view.displayError('Incorrect password, try again.');
            this.controller.terminal.inputHandler.setPasswordMode(true);
            view.createInputLine();
            return false;
        }
    }
}


class $acb8da174982c98b$var$TerminalController {
    constructor(){
        this.commandRegistry = (0, $d12c20e2463c3ec8$export$2e2bcd8739ae039);
        this.authenticator = new (0, $02c3c0481866b8e1$export$2e2bcd8739ae039)(this);
        this.terminal = null;
        this.initialized = false;
        this.isAuthenticated = false;
        this.isProcessingCommand = false;
    }
    initialize(terminal) {
        if (this.initialized) {
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug('Terminal controller already initialized');
            return this;
        }
        this.terminal = terminal;
        (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug('Initializing terminal controller...');
        this.setupEventListeners();
        this.initialized = true;
        (0, $71235d8e4bbe5195$export$f6644f0f2c90144b).emit((0, $021ae3ea6a11655c$export$212b227673290756).CONTROLLER_INITIALIZED, this);
        return this;
    }
    setupEventListeners() {
        (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug('[TerminalController] Setting up event listeners');
        try {
            if (!(0, $71235d8e4bbe5195$export$f6644f0f2c90144b)) {
                (0, $9bb4c1574855072f$export$2e2bcd8739ae039).error('[TerminalController] ERROR: eventBus is undefined or null');
                return;
            }
            (0, $71235d8e4bbe5195$export$f6644f0f2c90144b).on('terminal:input:submit', (command)=>{
                this.handleCommandSubmission(command);
            });
            (0, $71235d8e4bbe5195$export$f6644f0f2c90144b).on((0, $021ae3ea6a11655c$export$212b227673290756).PROCESS, (command)=>{
                this.processCommand(command);
            });
            document.addEventListener('command:execute', (event)=>{
                if (event.detail && event.detail.command) this.handleCommandSubmission(event.detail.command);
            });
            document.addEventListener('keydown', (event)=>{
                this.handleKeyboardShortcuts(event);
            });
        } catch (error) {
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).error('[TerminalController] ERROR: Failed to set up event listeners:', error);
        }
    }
    async handleCommandSubmission(command) {
        if (!command) return;
        try {
            if (!this.isAuthenticated) {
                const commandToDisplay = '*'.repeat(command.length);
                (0, $4c14fafc46b0fd8d$export$2e2bcd8739ae039).displayCommand(commandToDisplay);
                await this.authenticator.authenticate(command);
                return;
            }
            (0, $4c14fafc46b0fd8d$export$2e2bcd8739ae039).displayCommand(command);
            (0, $513ac137fd2efb00$export$2e2bcd8739ae039).addToHistory(command);
            this.processCommand(command);
        } catch (error) {
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).error('[TerminalController] ERROR: Failed to handle command submission', error);
        }
    }
    async processCommand(command) {
        if (!command || this.isProcessingCommand) return;
        this.isProcessingCommand = true;
        try {
            const { commandName: commandName, args: args } = this.parseCommand(command);
            if (await this.handleBuiltInCommand(commandName, args)) return;
            const cmd = this.commandRegistry.getCommand(commandName);
            if (!cmd) {
                const errorText = (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).t('terminal.error.unknownCommand', {
                    commandName: commandName
                });
                await (0, $4c14fafc46b0fd8d$export$2e2bcd8739ae039).displayError(errorText);
                return;
            }
            const onMessage = (message)=>{
                (0, $4c14fafc46b0fd8d$export$2e2bcd8739ae039).displayOutput(message);
            };
            const result = await Promise.resolve(cmd.handler(args, onMessage));
            if (result) // The command handler returns a result. We pass it directly to the view's
            // displayOutput function, which is responsible for iterating over arrays
            // and calling the correct renderer for each item based on its type.
            // The controller's job is done.
            await (0, $4c14fafc46b0fd8d$export$2e2bcd8739ae039).displayOutput(result);
        } catch (error) {
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).error('Error processing command:', error);
            await (0, $4c14fafc46b0fd8d$export$2e2bcd8739ae039).displayError(`Error processing command: ${error.message}`);
        } finally{
            this.isProcessingCommand = false;
            if (0, $4c14fafc46b0fd8d$export$2e2bcd8739ae039) {
                const existingInput = (0, $4c14fafc46b0fd8d$export$2e2bcd8739ae039).terminalElement.querySelector('.terminal-input-line');
                if (!existingInput) (0, $4c14fafc46b0fd8d$export$2e2bcd8739ae039).createInputLine();
            }
        }
    }
    parseCommand(commandString) {
        if (!commandString) return {
            commandName: '',
            args: []
        };
        const parts = [];
        let current = '';
        let inQuotes = false;
        let quoteChar = '';
        for(let i = 0; i < commandString.length; i++){
            const char = commandString[i];
            if ((char === '"' || char === "'") && (i === 0 || commandString[i - 1] !== '\\')) {
                if (!inQuotes) {
                    inQuotes = true;
                    quoteChar = char;
                } else if (char === quoteChar) {
                    inQuotes = false;
                    quoteChar = '';
                } else current += char;
            } else if (char === ' ' && !inQuotes) {
                if (current) {
                    parts.push(current);
                    current = '';
                }
            } else current += char;
        }
        if (current) parts.push(current);
        const commandName = parts[0] || '';
        const args = parts.slice(1);
        return {
            commandName: commandName,
            args: args
        };
    }
    async handleBuiltInCommand(commandName, args) {
        switch(commandName.toLowerCase()){
            case 'clear':
                (0, $71235d8e4bbe5195$export$f6644f0f2c90144b).emit((0, $021ae3ea6a11655c$export$212b227673290756).CLEAR);
                return true;
            case 'version':
                const versionInfo = (0, $4c14fafc46b0fd8d$export$2e2bcd8739ae039).getVersionInfo();
                await (0, $4c14fafc46b0fd8d$export$2e2bcd8739ae039).displayOutput(versionInfo);
                return true;
            default:
                return false;
        }
    }
    handleKeyboardShortcuts(event) {
        if (event.ctrlKey && event.key === 'l') {
            event.preventDefault();
            (0, $71235d8e4bbe5195$export$f6644f0f2c90144b).emit('terminal:clear');
        }
    }
}
const $acb8da174982c98b$var$terminalController = new $acb8da174982c98b$var$TerminalController();
var $acb8da174982c98b$export$2e2bcd8739ae039 = $acb8da174982c98b$var$terminalController;


/**
 * Input Handler
 * 
 * Handles user input for the terminal, including keyboard events,
 * command submission, and history navigation.
 */ 


class $4ae33b577f215e15$var$InputHandler {
    constructor(){
        // DOM elements
        this.inputElement = null;
        // State
        this.initialized = false;
        this.isPasswordMode = false;
        this._actualValue = '';
        // Bound event handlers for proper removal
        this._boundKeyDown = null;
        this._boundInput = null;
        this._boundFocus = null;
        this._boundBlur = null;
        this._boundPaste = null;
    }
    /**
   * Sets the input mode to password or normal text.
   * @param {boolean} enabled - True to enable password mode, false for normal.
   */ setPasswordMode(enabled) {
        this.isPasswordMode = enabled;
        this._actualValue = ''; // Reset on mode change
        if (this.inputElement) this.inputElement.value = '';
    }
    /**
   * Initialize the input handler with an input element
   * @param {HTMLElement} inputElement - The input element to handle
   * @returns {Object} InputHandler instance
   */ initialize(inputElement) {
        (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug('[InputHandler] Initializing', {
            hasElement: !!inputElement
        });
        if (!inputElement) {
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).error('[InputHandler] No input element provided for initialization');
            return this;
        }
        // If already initialized with a different element, clean up old listeners
        if (this.inputElement && this.inputElement !== inputElement) this._removeEventListeners();
        // Store reference to input element
        this.inputElement = inputElement;
        (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug('[InputHandler] Input element set', {
            tag: this.inputElement.tagName,
            className: this.inputElement.className
        });
        // Bind event handlers if not already bound (e.g., first initialization)
        if (!this._boundKeyDown) {
            this._boundKeyDown = this.handleKeyDown.bind(this);
            this._boundInput = ()=>{
                if (this.inputElement) (0, $71235d8e4bbe5195$export$f6644f0f2c90144b).emit((0, $021ae3ea6a11655c$export$212b227673290756).CHANGED, this.inputElement.value);
            };
            this._boundFocus = ()=>(0, $71235d8e4bbe5195$export$f6644f0f2c90144b).emit((0, $021ae3ea6a11655c$export$212b227673290756).FOCUS);
            this._boundBlur = ()=>(0, $71235d8e4bbe5195$export$f6644f0f2c90144b).emit((0, $021ae3ea6a11655c$export$212b227673290756).BLUR);
            this._boundPaste = this.handlePaste.bind(this);
        }
        // Set up event listeners on the new/current element
        this.setupEventListeners();
        if (!this.initialized) {
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).info('[InputHandler] Initializing for the first time');
            this.initialized = true;
            // Emit general initialization event only once
            (0, $71235d8e4bbe5195$export$f6644f0f2c90144b).emit((0, $021ae3ea6a11655c$export$212b227673290756).INPUT_INITIALIZED, this);
        }
        return this;
    }
    /**
   * Set up event listeners for the input handler
   */ _removeEventListeners() {
        if (this.inputElement) {
            this.inputElement.removeEventListener('keydown', this._boundKeyDown);
            this.inputElement.removeEventListener('input', this._boundInput);
            this.inputElement.removeEventListener('focus', this._boundFocus);
            this.inputElement.removeEventListener('blur', this._boundBlur);
            this.inputElement.removeEventListener('paste', this._boundPaste);
        }
    }
    setupEventListeners() {
        (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug('[InputHandler] Setting up event listeners');
        if (!this.inputElement) {
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).error('[InputHandler] Cannot set up event listeners - no input element available');
            return;
        }
        // Event listener management:
        // - _removeEventListeners is called during initialize() when the element changes
        // - This ensures clean state before adding new listeners
        // - No need to call _removeEventListeners here as it's handled by initialize()
        try {
            this.inputElement.addEventListener('keydown', this._boundKeyDown);
            this.inputElement.addEventListener('input', this._boundInput);
            this.inputElement.addEventListener('focus', this._boundFocus);
            this.inputElement.addEventListener('blur', this._boundBlur);
            this.inputElement.addEventListener('paste', this._boundPaste);
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug('[InputHandler] Event listeners attached');
            // Test focus to verify event listeners are working
            setTimeout(()=>{
                try {
                    this.inputElement.focus();
                } catch (error) {
                    (0, $9bb4c1574855072f$export$2e2bcd8739ae039).error('[InputHandler] Failed to focus input element', error);
                }
            }, 100);
        } catch (error) {
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).error('[InputHandler] Failed to attach event listeners', error);
        }
    }
    /**
   * Handle keydown events
   * @param {KeyboardEvent} event - Keyboard event
   */ handleKeyDown(event) {
        if (event.key === 'Enter' && (event.metaKey || event.ctrlKey)) {
            event.preventDefault();
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug('SVG regeneration triggered by shortcut.');
            (0, $71235d8e4bbe5195$export$f6644f0f2c90144b).emit('terminal:regenerate-svg');
            return;
        }
        // If in password mode, intercept and mask input
        if (this.isPasswordMode) {
            // Only allow Enter to be processed by the switch statement below
            if (event.key !== 'Enter') event.preventDefault(); // Prevent default action for all other keys
            if (event.key === 'Backspace') this._actualValue = this._actualValue.slice(0, -1);
            else if (event.key.length === 1 && !event.ctrlKey && !event.metaKey) this._actualValue += event.key;
            this.inputElement.value = '*'.repeat(this._actualValue.length);
            // Dispatch an input event to make sure other components (like the cursor) react to the change
            this.inputElement.dispatchEvent(new Event('input'));
            // In password mode, only 'Enter' should fall through to the switch.
            // Other keys are handled above or ignored.
            if (event.key !== 'Enter') return;
        }
        switch(event.key){
            case 'Enter':
                this.submitCommand();
                event.preventDefault();
                break;
            case 'ArrowUp':
                // Navigate history up
                (0, $71235d8e4bbe5195$export$f6644f0f2c90144b).emit((0, $021ae3ea6a11655c$export$212b227673290756).NAVIGATE, 'up');
                event.preventDefault();
                break;
            case 'ArrowDown':
                // Navigate history down
                (0, $71235d8e4bbe5195$export$f6644f0f2c90144b).emit((0, $021ae3ea6a11655c$export$212b227673290756).NAVIGATE, 'down');
                event.preventDefault();
                break;
            case 'Tab':
                // Auto-complete (to be implemented)
                event.preventDefault();
                break;
            case 'c':
                // Handle Ctrl+C
                if (event.ctrlKey) {
                    this.handleCtrlC();
                    event.preventDefault();
                }
                break;
            case 'l':
                // Handle Ctrl+L (clear terminal)
                if (event.ctrlKey) {
                    (0, $71235d8e4bbe5195$export$f6644f0f2c90144b).emit((0, $021ae3ea6a11655c$export$212b227673290756).CLEAR);
                    event.preventDefault();
                }
                break;
        }
    }
    /**
   * Submit the current command
   */ submitCommand() {
        if (!this.inputElement) {
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).error('[InputHandler] No input element available for command submission');
            return;
        }
        const command = this.getValue().trim();
        // Only emit if there's a command
        if (command) {
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug('[InputHandler] Emitting terminal:input:submit event');
            (0, $71235d8e4bbe5195$export$f6644f0f2c90144b).emit('terminal:input:submit', command);
        }
        // After submitting, clear the internal state and the visible input.
        // This is important for both password mode and normal mode, especially on failed attempts.
        this._actualValue = '';
        this.inputElement.value = '';
        // Notify the view that the input has been cleared so the cursor updates.
        this.inputElement.dispatchEvent(new Event('input'));
    }
    /**
   * Handle Ctrl+C
   */ handleCtrlC() {
        // Clear the input field
        if (this.inputElement) this.inputElement.value = '';
        // Emit cancel event
        (0, $71235d8e4bbe5195$export$f6644f0f2c90144b).emit((0, $021ae3ea6a11655c$export$212b227673290756).CANCEL);
    }
    /**
   * Handle paste events
   * @param {ClipboardEvent} event - Clipboard event
   */ handlePaste(event) {
    // Allow default paste behavior for now
    // This can be customized if needed
    }
    /**
   * Set the input value
   * @param {string} value - Value to set
   */ setValue(value) {
        if (this.inputElement) {
            const newValue = value || '';
            this.inputElement.value = newValue;
            // Directly notify CursorManager to synchronize its state and visual display.
            // This is crucial for programmatic changes like history navigation to avoid race conditions
            // with the cursor's blink cycle and its internal 'originalValue'.
            if (window.techno_punks && window.techno_punks.Terminal && window.techno_punks.Terminal.view && window.techno_punks.Terminal.view.cursorManager && typeof window.techno_punks.Terminal.view.cursorManager.syncWithValue === 'function') window.techno_punks.Terminal.view.cursorManager.syncWithValue(newValue);
            else (0, $9bb4c1574855072f$export$2e2bcd8739ae039).warn('[InputHandler] CursorManager.syncWithValue not available. Cursor might not update correctly for programmatic changes.');
            // Emit general change event for other potential listeners.
            // Note: CursorManager also has its own 'input' event listener on the input element,
            // which will also fire due to 'this.inputElement.value = newValue'. 
            // The syncWithValue call ensures originalValue is correct before that listener might run or blink interval interferes.
            (0, $71235d8e4bbe5195$export$f6644f0f2c90144b).emit((0, $021ae3ea6a11655c$export$212b227673290756).CHANGED, newValue);
        }
    }
    /**
   * Get the current input value
   * @returns {string} Current input value
   */ getValue() {
        // In password mode, the real value is stored internally.
        // Otherwise, we can just read from the input element.
        if (this.isPasswordMode) return this._actualValue;
        return this.inputElement ? this.inputElement.value : '';
    }
    /**
   * Focus the input element
   */ focus() {
        if (this.inputElement) this.inputElement.focus();
    }
    /**
   * Clear the input element
   */ clear() {
        if (this.inputElement) {
            this.inputElement.value = '';
            // Emit change event
            (0, $71235d8e4bbe5195$export$f6644f0f2c90144b).emit((0, $021ae3ea6a11655c$export$212b227673290756).CHANGED, '');
        }
    }
    /**
   * Cleanup all event listeners and references
   * Call this when the InputHandler is no longer needed
   */ cleanup() {
        (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug('[InputHandler] Cleaning up event listeners and references');
        // Remove all event listeners
        this._removeEventListeners();
        // Clear references
        this.inputElement = null;
        this._boundKeyDown = null;
        this._boundInput = null;
        this._boundFocus = null;
        this._boundBlur = null;
        this._boundPaste = null;
        // Reset state
        this.initialized = false;
        this.isPasswordMode = false;
        this._actualValue = '';
    }
}
var $4ae33b577f215e15$export$2e2bcd8739ae039 = $4ae33b577f215e15$var$InputHandler;




class $ef86cbf648d80cf0$var$Terminal {
    constructor(){
        // Component references
        this.core = (0, $513ac137fd2efb00$export$2e2bcd8739ae039);
        this.view = (0, $4c14fafc46b0fd8d$export$2e2bcd8739ae039);
        this.controller = (0, $acb8da174982c98b$export$2e2bcd8739ae039);
        // Input handler
        this.inputHandler = null;
        // State
        this.initialized = false;
        // Event cleanup tracking
        this.eventCleanup = [];
    }
    /**
   * Initialize the terminal
   * @returns {Object} Terminal instance
   */ initialize() {
        if (this.initialized) {
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug('Terminal already initialized');
            return this;
        }
        (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug('Initializing terminal...');
        try {
            // Create input handler first so it's available when view needs it
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug('[Terminal] Creating input handler');
            this.inputHandler = new (0, $4ae33b577f215e15$export$2e2bcd8739ae039)();
            // Initialize terminal components
            this.core.initialize();
            // Show password prompt initially
            this.core.config.greetings = 'Please enter the password:';
            this.core.setPrompt((0, $b1294981df4c9a64$export$1613a8bb42ebacf3).PASSWORD);
            this.view.initialize();
            // After view init, wait for input element before finishing setup
            const finishInit = ()=>{
                this.controller.initialize(this);
                this.setupEventListeners();
                this.initialized = true;
                (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug('Terminal initialized successfully');
                (0, $71235d8e4bbe5195$export$f6644f0f2c90144b).emit((0, $021ae3ea6a11655c$export$212b227673290756).TERMINAL_INITIALIZED, this);
            };
            if (this.view.inputElement) {
                this.inputHandler.initialize(this.view.inputElement);
                this.inputHandler.setPasswordMode(true); // Enable password mode
                finishInit();
            } else (0, $71235d8e4bbe5195$export$f6644f0f2c90144b).once('terminal:input:element:ready', (inputEl)=>{
                this.inputHandler.initialize(inputEl);
                this.inputHandler.setPasswordMode(true); // Enable password mode
                finishInit();
            });
            return this;
        } catch (error) {
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).error('Error initializing terminal:', error);
            alert('Error initializing terminal: ' + error.message);
            return this;
        }
    }
    /**
   * Set up event listeners for the terminal
   */ setupEventListeners() {
        // Clean up any existing listeners first
        this.cleanupEventListeners();
        // Listen for terminal resize events
        const resizeHandler = ()=>this.handleResize();
        window.addEventListener('resize', resizeHandler);
        this.eventCleanup.push(()=>window.removeEventListener('resize', resizeHandler));
        // Listen for terminal events
        const clearCleanup = (0, $71235d8e4bbe5195$export$f6644f0f2c90144b).on((0, $021ae3ea6a11655c$export$212b227673290756).CLEAR, ()=>{
            this.view.clear();
        });
        this.eventCleanup.push(clearCleanup);
        // Listen for input element ready event
        (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug('[Terminal] Setting up listener for terminal:input:element:ready event');
        const inputReadyCleanup = (0, $71235d8e4bbe5195$export$f6644f0f2c90144b).on('terminal:input:element:ready', (inputElement)=>{
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug('[Terminal] Received terminal:input:element:ready event with input element');
            if (inputElement) {
                (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug('[Terminal] Initializing input handler with received input element');
                if (this.inputHandler) this.inputHandler.initialize(inputElement);
                else (0, $9bb4c1574855072f$export$2e2bcd8739ae039).error('[Terminal] ERROR: Input handler not available when input element is ready');
            } else (0, $9bb4c1574855072f$export$2e2bcd8739ae039).error('[Terminal] ERROR: Received terminal:input:element:ready event with null/undefined input element');
        });
        this.eventCleanup.push(inputReadyCleanup);
        // Listen for theme changes
        const themeCleanup = (0, $71235d8e4bbe5195$export$f6644f0f2c90144b).on('theme:changed', ()=>{
        // Cursor color is now handled by CSS text color. No manual update needed.
        // if (this.view.cursorManager) {
        //   this.view.cursorManager.updateCursorColor(); // This method no longer exists
        // }
        });
        this.eventCleanup.push(themeCleanup);
        // Handle command execution events from UI buttons
        const commandHandler = (event)=>{
            if (event.detail && event.detail.command) this.core.executeCommand(event.detail.command);
        };
        document.addEventListener('command:execute', commandHandler);
        this.eventCleanup.push(()=>document.removeEventListener('command:execute', commandHandler));
    }
    /**
   * Clean up all event listeners
   */ cleanupEventListeners() {
        this.eventCleanup.forEach((cleanup)=>{
            try {
                cleanup();
            } catch (error) {
                (0, $9bb4c1574855072f$export$2e2bcd8739ae039).warn('[Terminal] Error during event cleanup:', error);
            }
        });
        this.eventCleanup = [];
    }
    /**
   * Handle terminal resize
   */ handleResize() {
    // Cursor position is now handled by text flow. No manual update needed on resize.
    // if (this.view.cursorManager) {
    //   this.view.cursorManager.updateCursorPosition(); // This method no longer exists
    // }
    }
    /**
   * Update the terminal theme
   * @param {Object} themeOptions - Theme options (no longer needed with CSS variables)
   */ updateTheme(themeOptions) {
        // No need to manually set styles - CSS variables handle this now
        // Just update the cursor color which may need JavaScript handling
        if (this.view.cursorManager) this.view.cursorManager.updateCursorColor();
    }
    /**
   * Refresh the terminal display
   */ refresh() {
        // Update cursor position without forcing reflow
        if (this.view.cursorManager) this.view.cursorManager.updateCursorPosition();
    }
    /**
   * Clear the terminal
   */ clear() {
        (0, $71235d8e4bbe5195$export$f6644f0f2c90144b).emit((0, $021ae3ea6a11655c$export$212b227673290756).CLEAR);
    }
    /**
   * Write output to the terminal
   * @param {*} output - Output to write
   */ write(output) {
        this.view.displayOutput(output);
    }
    /**
   * Execute a command programmatically
   * @param {string} command - Command to execute
   */ executeCommand(command) {
        if (!command) return;
        // Emit command execution event
        (0, $71235d8e4bbe5195$export$f6644f0f2c90144b).emit((0, $021ae3ea6a11655c$export$212b227673290756).EXECUTE, command);
    }
    /**
   * Set the terminal prompt
   * @param {string} prompt - New prompt text
   */ setPrompt(prompt) {
        this.core.setPrompt(prompt);
    }
    /**
   * Get the command history
   * @returns {string[]} Command history array
   */ getCommandHistory() {
        return this.core.getCommandHistory();
    }
    /**
   * Updates the target input element for the InputHandler.
   * @param {HTMLElement} newInputElement - The new input element to target.
   */ updateInputHandlerTarget(newInputElement) {
        (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug('[Terminal] updateInputHandlerTarget called with element:', newInputElement ? 'valid element' : 'null');
        if (!newInputElement) {
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).error('[Terminal] ERROR: Attempted to update input handler with null/undefined element');
            return;
        }
        if (!this.inputHandler) {
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug('[Terminal] Input handler not yet created, creating now');
            this.inputHandler = new (0, $4ae33b577f215e15$export$2e2bcd8739ae039)();
        }
        if (typeof this.inputHandler.initialize === 'function') {
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug('[Terminal] Initializing input handler with input element');
            this.inputHandler.initialize(newInputElement);
        } else (0, $9bb4c1574855072f$export$2e2bcd8739ae039).error('[Terminal] ERROR: Input handler has no initialize method');
    }
    /**
   * Cleanup all resources and event listeners
   * Call this when the terminal is being destroyed or reinitialized
   */ cleanup() {
        (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug('[Terminal] Cleaning up terminal resources');
        // Clean up event listeners
        this.cleanupEventListeners();
        // Clean up input handler
        if (this.inputHandler && typeof this.inputHandler.cleanup === 'function') this.inputHandler.cleanup();
        // Reset state
        this.initialized = false;
        this.inputHandler = null;
        (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug('[Terminal] Terminal cleanup completed');
    }
}
// Create singleton instance
const $ef86cbf648d80cf0$var$terminal = new $ef86cbf648d80cf0$var$Terminal();
var $ef86cbf648d80cf0$export$2e2bcd8739ae039 = $ef86cbf648d80cf0$var$terminal;




/**
 * Simplified Matrix-style Text Animation
 * 
 * Features:
 * - Dynamic grid resizing.
 * - Globally triggered random character changes.
 * - Slow fade transitions for character changes.
 * - Chance for characters to become empty spaces.
 */ 

// Centralised configuration for Simple Matrix animation.
const $2093d872f7790fd3$var$CONFIG = {
    CELL_HEIGHT: 22,
    CHAR_WIDTH: 9.6,
    FONT_SIZE: 18,
    MATRIX_CHARS: [
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z',
        'a',
        'b',
        'c',
        'd',
        'e',
        'f',
        'g',
        'h',
        'i',
        'j',
        'k',
        'l',
        'm',
        'n',
        'o',
        'p',
        'q',
        'r',
        's',
        't',
        'u',
        'v',
        'w',
        'x',
        'y',
        'z',
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '+',
        '-',
        '*',
        '/',
        '=',
        '<',
        '>',
        '!',
        '?',
        '@',
        '#',
        '$',
        '%',
        '&'
    ],
    DEFAULT_WIDTH: 300,
    RESIZE_DEBOUNCE: 150,
    DEBOUNCE_DELAY: 350,
    EMPTY_CELL_PROBABILITY_INITIAL: 0.25,
    GLOBAL_CHANGE_INTERVAL_MIN: 3750,
    GLOBAL_CHANGE_INTERVAL_MAX: 7500,
    FADE_DURATION: 3000,
    BECOME_EMPTY_PROBABILITY_ON_CHANGE: 0.2,
    RIGHT_SIDE_COLUMNS: 2,
    CLICK_GRACE_PERIOD: 300,
    CLICK_TRANSITION_DURATION: 1
};
var $2093d872f7790fd3$export$2e2bcd8739ae039 = $2093d872f7790fd3$var$CONFIG;


// CONFIG moved to separate module
function $d5439305d9c28222$var$getRandomChar() {
    return (0, $2093d872f7790fd3$export$2e2bcd8739ae039).MATRIX_CHARS[Math.floor(Math.random() * (0, $2093d872f7790fd3$export$2e2bcd8739ae039).MATRIX_CHARS.length)];
}
class $d5439305d9c28222$var$Cell {
    constructor(){
        this.char = ' ';
        this.opacity = 0; // Start fully transparent, will be faded in
        // Transition properties
        this.targetChar = ' ';
        this.targetOpacity = 0;
        this.transitionStartTime = 0;
        this.transitionDuration = 0;
        this.isTransitioning = false;
        this.onTransitionComplete = null;
        this.isHovered = false; // New property for hover state
        this.lastClickTime = 0; // Timestamp of the last click affecting this cell
    }
    // Initializes the cell without a transition (e.g., on grid creation)
    setTo(char, opacity = 1) {
        this.char = char;
        this.opacity = char === ' ' ? 0 : opacity; // Spaces are effectively 0 opacity
        this.targetChar = char;
        this.targetOpacity = this.opacity;
        this.isTransitioning = false;
    }
    startTransition(newChar, newOpacity, duration, onComplete = null) {
        if (this.isTransitioning && newChar === this.targetChar) return; // Already transitioning to this
        this.previousChar = this.char;
        this.previousOpacity = this.opacity;
        this.targetChar = newChar;
        this.targetOpacity = newOpacity;
        this.transitionStartTime = performance.now();
        this.transitionDuration = duration;
        this.isTransitioning = true;
        this.onTransitionComplete = onComplete;
    // If not fading out to space, the current character immediately changes for multi-step morph,
    // but for simple fade, we let opacity handle it.
    // For this simple version, we'll manage char change at the end of fade.
    }
    update(currentTime) {
        if (!this.isTransitioning) return false; // Nothing to update
        const elapsed = currentTime - this.transitionStartTime;
        let progress = Math.min(1, elapsed / this.transitionDuration);
        // Simple linear fade for now
        // If fading out (current char is not space, target is space OR target is different char)
        if (this.targetOpacity < this.previousOpacity) this.opacity = this.previousOpacity * (1 - progress);
        else if (this.targetOpacity > this.previousOpacity) this.opacity = this.targetOpacity * progress; // Assumes previousOpacity was 0 if fully faded out
        else this.opacity = this.targetOpacity;
        this.opacity = Math.max(0, Math.min(1, this.opacity));
        if (progress >= 1) {
            const oldChar = this.char;
            this.char = this.targetChar;
            this.opacity = this.targetOpacity; // Ensure final state
            this.isTransitioning = false;
            if (this.onTransitionComplete) {
                this.onTransitionComplete();
                this.onTransitionComplete = null;
            }
            return oldChar !== this.char || this.opacity !== this.previousOpacity; // Return true if something visually changed
        }
        return true; // Still transitioning
    }
}
class $d5439305d9c28222$var$SimpleMatrixGrid {
    constructor(container, side){
        this.container = container;
        this.side = side;
        this.element = document.createElement('div');
        this.element.className = 'simple-matrix-grid'; // Use a new class name
        this.container.appendChild(this.element);
        this.cells = []; // 2D array of Cell objects
        this.rowElements = [];
        this.columnCount = 0;
        this.rowCount = 0;
        this.lastRenderedRowHtml = [];
        this.lastGlobalChangeTime = performance.now();
        this.nextGlobalChangeInterval = this.getRandomChangeInterval();
        this.animationFrameId = null;
        this.needsRender = true; // Flag to control rendering
        // Whether global random character changes are enabled
        this.randomEnabled = true;
        this.currentlyHoveredCell = null; // To track the cell under the mouse
        this.resizeObserver = null; // To handle resizing reliably
    }
    getRandomChangeInterval() {
        return (0, $2093d872f7790fd3$export$2e2bcd8739ae039).GLOBAL_CHANGE_INTERVAL_MIN + Math.random() * ((0, $2093d872f7790fd3$export$2e2bcd8739ae039).GLOBAL_CHANGE_INTERVAL_MAX - (0, $2093d872f7790fd3$export$2e2bcd8739ae039).GLOBAL_CHANGE_INTERVAL_MIN);
    }
    calculateDimensions() {
        const width = this.container.clientWidth;
        const height = this.container.clientHeight;
        let columnCount;
        if (this.side === 'right') columnCount = (0, $2093d872f7790fd3$export$2e2bcd8739ae039).RIGHT_SIDE_COLUMNS;
        else columnCount = Math.max(1, Math.floor(width / (0, $2093d872f7790fd3$export$2e2bcd8739ae039).CHAR_WIDTH));
        const rowCount = Math.max(1, Math.ceil(height / (0, $2093d872f7790fd3$export$2e2bcd8739ae039).CELL_HEIGHT));
        return {
            columnCount: columnCount,
            rowCount: rowCount,
            width: width,
            height: height
        };
    }
    resize() {
        const { columnCount: columnCount, rowCount: rowCount, width: width, height: height } = this.calculateDimensions();
        // Ensure the container element itself has the correct dimensions.
        this.element.style.width = `${width}px`;
        this.element.style.height = `${height}px`;
        if (this.columnCount === columnCount && this.rowCount === rowCount) return; // No change in grid size needed.
        // Adjust rows
        // Add new rows if needed
        for(let y = this.rowCount; y < rowCount; y++){
            const rowElement = document.createElement('div');
            rowElement.className = 'matrix-row';
            this.element.appendChild(rowElement);
            this.rowElements.push(rowElement);
            this.cells.push([]);
            this.lastRenderedRowHtml.push('');
        }
        // Remove excess rows if needed
        while(this.rowCount > rowCount){
            this.element.removeChild(this.rowElements.pop());
            this.cells.pop();
            this.lastRenderedRowHtml.pop();
            this.rowCount--;
        }
        this.rowCount = rowCount;
        // Adjust columns for every row
        for(let y = 0; y < this.rowCount; y++){
            const row = this.cells[y];
            // Add new cells if needed
            for(let x = row.length; x < columnCount; x++){
                const cell = new $d5439305d9c28222$var$Cell();
                const isInitiallyEmpty = Math.random() < (0, $2093d872f7790fd3$export$2e2bcd8739ae039).EMPTY_CELL_PROBABILITY_INITIAL;
                const initialChar = isInitiallyEmpty ? ' ' : $d5439305d9c28222$var$getRandomChar();
                cell.setTo(initialChar, 1.0);
                row.push(cell);
            }
            // Remove excess cells if needed
            if (row.length > columnCount) row.length = columnCount;
        }
        this.columnCount = columnCount;
        this.needsRender = true; // Force a full re-render to show changes
    }
    triggerRandomCellChange(currentTime) {
        if (this.rowCount === 0 || this.columnCount === 0) return;
        // Select a random cell that is not currently hovered
        let y, x, cell;
        let attempts = 0;
        const MAX_ATTEMPTS = this.rowCount * this.columnCount > 0 ? this.rowCount * this.columnCount : 10; // Avoid infinite loop if all cells are hovered
        do {
            y = Math.floor(Math.random() * this.rowCount);
            x = Math.floor(Math.random() * this.columnCount);
            cell = this.cells[y]?.[x];
            attempts++;
        }while (cell && cell.isHovered && attempts < MAX_ATTEMPTS);
        if (!cell || cell.isHovered) // No non-hovered cell found or max attempts reached.
        return;
        let newChar;
        let newOpacity;
        if (cell.char === ' ') {
            newChar = $d5439305d9c28222$var$getRandomChar();
            newOpacity = 1.0;
        } else {
            const becomesEmpty = Math.random() < (0, $2093d872f7790fd3$export$2e2bcd8739ae039).BECOME_EMPTY_PROBABILITY_ON_CHANGE;
            if (becomesEmpty) {
                newChar = ' ';
                newOpacity = 0.0;
            } else {
                newChar = $d5439305d9c28222$var$getRandomChar();
                if (newChar === cell.char) newChar = $d5439305d9c28222$var$getRandomChar();
                newOpacity = 1.0;
            }
        }
        // To make it a two-stage fade (current fades out, then new fades in)
        // 1. Fade out current char (if it's not already a space)
        if (cell.char !== ' ') cell.startTransition(' ', 0, (0, $2093d872f7790fd3$export$2e2bcd8739ae039).FADE_DURATION / 2, ()=>{
            // 2. Once faded out, fade in the new char
            cell.char = ' '; // Ensure it's internally a space before fading in new
            cell.startTransition(newChar, newOpacity, (0, $2093d872f7790fd3$export$2e2bcd8739ae039).FADE_DURATION / 2);
        });
        else cell.startTransition(newChar, newOpacity, (0, $2093d872f7790fd3$export$2e2bcd8739ae039).FADE_DURATION);
        this.needsRender = true;
    }
    update(currentTime) {
        let anythingChanged = false;
        for(let y = 0; y < this.rowCount; y++){
            for(let x = 0; x < this.columnCount; x++)if (this.cells[y]?.[x]?.update(currentTime)) anythingChanged = true;
        }
        if (anythingChanged) this.needsRender = true;
        // Global change trigger
        if (this.randomEnabled && currentTime - this.lastGlobalChangeTime > this.nextGlobalChangeInterval) {
            this.triggerRandomCellChange(currentTime);
            this.lastGlobalChangeTime = currentTime;
            this.nextGlobalChangeInterval = this.getRandomChangeInterval();
        }
    }
    render() {
        if (!this.needsRender) return;
        for(let y = 0; y < this.rowCount; y++){
            if (!this.rowElements[y] || !this.cells[y]) continue;
            const rowHtmlParts = [];
            for(let x = 0; x < this.columnCount; x++){
                const cell = this.cells[y][x];
                if (!cell) {
                    rowHtmlParts.push('<span>&nbsp;</span>'); // Should not happen if grid is consistent
                    continue;
                }
                const displayChar = cell.char === ' ' ? '&nbsp;' : cell.char;
                // Opacity directly on span style
                rowHtmlParts.push(`<span style="opacity: ${cell.opacity.toFixed(2)};">${displayChar}</span>`);
            }
            const newRowHtml = rowHtmlParts.join('');
            if (this.lastRenderedRowHtml[y] !== newRowHtml) {
                this.rowElements[y].innerHTML = newRowHtml;
                this.lastRenderedRowHtml[y] = newRowHtml;
            }
        }
        this.needsRender = false;
    }
    start() {
        const animate = (time)=>{
            this.update(time);
            this.render();
            this.animationFrameId = requestAnimationFrame(animate);
        };
        this.animationFrameId = requestAnimationFrame(animate);
        (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug(`Simple Matrix animation started for side: ${this.side}`);
    }
    stop() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.animationFrameId) cancelAnimationFrame(this.animationFrameId);
        if (this.container) {
            if (this.side === 'left') {
                this.container.removeEventListener('mousemove', this.handleMouseMove);
                this.container.removeEventListener('mouseleave', this.handleMouseLeave);
                this.container.removeEventListener('click', this.handleGridClick);
                (0, $71235d8e4bbe5195$export$f6644f0f2c90144b).off('rightSideCharacterClicked', this.handleRightSideClick); // Remove listener
            } else if (this.side === 'right') this.container.removeEventListener('click', this.handleRightSideCharEmitterClick);
        }
    }
    // Hover handling methods - to be bound and called by event listeners
    handleMouseMove = (event)=>{
        if (this.side !== 'left') return;
        const rect = this.container.getBoundingClientRect();
        const mouseX = event.clientX - rect.left;
        const mouseY = event.clientY - rect.top;
        const col = Math.floor(mouseX / (0, $2093d872f7790fd3$export$2e2bcd8739ae039).CHAR_WIDTH);
        const row = Math.floor(mouseY / (0, $2093d872f7790fd3$export$2e2bcd8739ae039).CELL_HEIGHT);
        let cellUnderMouse = null;
        if (row >= 0 && row < this.rowCount && col >= 0 && col < this.columnCount) cellUnderMouse = this.cells[row]?.[col];
        if (this.currentlyHoveredCell && this.currentlyHoveredCell !== cellUnderMouse) {
            this.currentlyHoveredCell.isHovered = false;
            // When mouse moves off, it stays '_' until global animation changes it or it gets re-hovered.
            // Or, we can trigger a fade back to its original char if we stored it.
            // For now, let it persist as per original request for the other animation.
            this.needsRender = true;
            this.currentlyHoveredCell = null;
        }
        if (cellUnderMouse && (!cellUnderMouse.isHovered || this.currentlyHoveredCell !== cellUnderMouse)) {
            if (this.currentlyHoveredCell && this.currentlyHoveredCell !== cellUnderMouse) {
                this.currentlyHoveredCell.isHovered = false; // Unhover previous one
                this.needsRender = true;
            }
            // If not recently clicked, apply hover effect
            if (performance.now() - cellUnderMouse.lastClickTime > (0, $2093d872f7790fd3$export$2e2bcd8739ae039).CLICK_GRACE_PERIOD) {
                if (!cellUnderMouse.isHovered) {
                    cellUnderMouse.isHovered = true;
                    cellUnderMouse.isTransitioning = false; // Stop any ongoing transition
                    cellUnderMouse.char = '_';
                    cellUnderMouse.opacity = 1.0;
                    this.needsRender = true;
                }
            } // If recently clicked, isHovered might be true, but we don't override char to '_'
            // We still mark it as the currently hovered cell for tracking purposes
            this.currentlyHoveredCell = cellUnderMouse;
            // Ensure isHovered is true if it is indeed under mouse, even if click grace period is active
            if (!cellUnderMouse.isHovered) cellUnderMouse.isHovered = true; // Mark as hovered for tracking, char change is conditional
        } else if (!cellUnderMouse && this.currentlyHoveredCell) {
            // Mouse moved to an empty area within the box, but not over a cell
            this.currentlyHoveredCell.isHovered = false;
            this.needsRender = true;
            this.currentlyHoveredCell = null;
        }
    };
    handleMouseLeave = (event)=>{
        if (this.side !== 'left') return;
        if (this.currentlyHoveredCell) {
            this.currentlyHoveredCell.isHovered = false;
            // Character remains '_' until next global update cycle changes it or it's re-hovered.
            // Or, if lastClickTime is recent, it might be something else.
            // If performance.now() - this.currentlyHoveredCell.lastClickTime <= CONFIG.CLICK_GRACE_PERIOD, it means a click just happened.
            // The character will be what the click set it to.
            // If hover was also on it, isHovered would be false now, but the char is not '_'.
            // This seems fine. The _ will re-assert if mouse moves back over it after grace period.
            this.needsRender = true;
            this.currentlyHoveredCell = null;
        }
    };
    // Click handling method
    handleGridClick = (event)=>{
        if (this.side !== 'left') return;
        // Check if the click originated from within grid.element (which is this.element)
        let currentElement = event.target;
        let clickedWithinGrid = false;
        while(currentElement && currentElement !== this.container){
            if (currentElement === this.element) {
                clickedWithinGrid = true;
                break;
            }
            currentElement = currentElement.parentElement;
        }
        if (!clickedWithinGrid) return; // Click was outside the actual grid cells
        const newRandomChar = $d5439305d9c28222$var$getRandomChar();
        const currentTime = performance.now();
        let changedCount = 0;
        for(let y = 0; y < this.rowCount; y++)for(let x = 0; x < this.columnCount; x++){
            const cell = this.cells[y]?.[x];
            if (cell && cell.char === '_') {
                cell.lastClickTime = currentTime;
                // Transition to the new char. Use the new fast click transition duration.
                cell.startTransition(newRandomChar, 1.0, (0, $2093d872f7790fd3$export$2e2bcd8739ae039).CLICK_TRANSITION_DURATION);
                changedCount++;
                this.needsRender = true;
            }
        }
        if (changedCount > 0) (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug(`[GridClick L] Changed ${changedCount} '_' to '${newRandomChar}'`);
    };
    // Handler for clicks on the right side, emits event with character
    handleRightSideCharEmitterClick = (event)=>{
        // Called when the right sideBox is clicked.
        // Determine which character was clicked.
        const rect = this.container.getBoundingClientRect();
        const mouseX = event.clientX - rect.left;
        const mouseY = event.clientY - rect.top;
        const col = Math.floor(mouseX / (0, $2093d872f7790fd3$export$2e2bcd8739ae039).CHAR_WIDTH);
        const row = Math.floor(mouseY / (0, $2093d872f7790fd3$export$2e2bcd8739ae039).CELL_HEIGHT);
        if (row >= 0 && row < this.rowCount && col >= 0 && col < this.columnCount) {
            const cell = this.cells[row]?.[col];
            if (cell && cell.char !== ' ' && cell.opacity > 0.5) {
                (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug(`[RightSideClick] Emitting char: ${cell.char}`);
                (0, $71235d8e4bbe5195$export$f6644f0f2c90144b).emit('rightSideCharacterClicked', cell.char);
            }
        }
    };
    // Handler for when a character is clicked on the right side (listened to by left grid)
    handleRightSideClick = (clickedChar)=>{
        if (this.side !== 'left') return; // Only left grid reacts
        (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug(`[Left Grid] Received rightSideCharacterClicked event with char: ${clickedChar}`);
        const currentTime = performance.now();
        let changedCount = 0;
        for(let y = 0; y < this.rowCount; y++)for(let x = 0; x < this.columnCount; x++){
            const cell = this.cells[y]?.[x];
            if (cell && cell.char === '_') {
                cell.lastClickTime = currentTime; // Update lastClickTime to manage hover grace period
                cell.startTransition(clickedChar, 1.0, (0, $2093d872f7790fd3$export$2e2bcd8739ae039).CLICK_TRANSITION_DURATION);
                changedCount++;
                this.needsRender = true;
            }
        }
        if (changedCount > 0) (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug(`[Left Grid] Changed ${changedCount} '_' to clicked char '${clickedChar}' from right side.`);
    };
}
// Main exported object
const $d5439305d9c28222$var$SimpleMatrixAnimation = {
    create () {
        const appContainer = document.getElementById('app-container');
        if (!appContainer) {
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).error('App container not found for Simple Matrix animation');
            return;
        }
        if (!terminal) {
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).error('Terminal element not found for Simple Matrix animation');
            return;
        }
        (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug('Initializing Simple Matrix Animation...');
        const createSide = (side)=>{
            const sideBox = document.createElement('div');
            sideBox.className = `simple-matrix-container terminal-side-box terminal-side-box-${side}`;
            sideBox.dataset.side = side;
            // Basic positioning (can be refined by CSS)
            // Determine initial width before adding to DOM to avoid flash resize
            let boxWidth;
            if (side === 'left') {
                const idealResponsiveWidth = Math.min((0, $2093d872f7790fd3$export$2e2bcd8739ae039).DEFAULT_WIDTH, Math.max(100, window.innerWidth * 0.15));
                const numCols = Math.floor(idealResponsiveWidth / (0, $2093d872f7790fd3$export$2e2bcd8739ae039).CHAR_WIDTH);
                boxWidth = Math.max((0, $2093d872f7790fd3$export$2e2bcd8739ae039).CHAR_WIDTH * 5, numCols * (0, $2093d872f7790fd3$export$2e2bcd8739ae039).CHAR_WIDTH); // Ensure min width
                document.documentElement.style.setProperty('--left-animation-width', `${boxWidth}px`);
            } else {
                boxWidth = (0, $2093d872f7790fd3$export$2e2bcd8739ae039).CHAR_WIDTH * (0, $2093d872f7790fd3$export$2e2bcd8739ae039).RIGHT_SIDE_COLUMNS;
                document.documentElement.style.setProperty('--right-animation-width', `${boxWidth}px`);
            }
            sideBox.style.width = `${boxWidth}px`; // Set correct width immediately
            sideBox.style.overflow = 'hidden';
            sideBox.style.backgroundColor = 'var(--color-background)'; // Use the correct theme variable
            sideBox.style.height = '100%'; // Explicitly set height
            if (side === 'left') // Prepend the left sidebar to the app container
            appContainer.prepend(sideBox);
            else // Append the right sidebar to the app container
            appContainer.appendChild(sideBox);
            const grid = new $d5439305d9c28222$var$SimpleMatrixGrid(sideBox, side);
            // Add listeners based on side
            if (side === 'left') {
                sideBox.addEventListener('mousemove', grid.handleMouseMove);
                sideBox.addEventListener('mouseleave', grid.handleMouseLeave);
                sideBox.addEventListener('click', grid.handleGridClick);
                (0, $71235d8e4bbe5195$export$f6644f0f2c90144b).on('rightSideCharacterClicked', grid.handleRightSideClick);
            } else if (side === 'right') sideBox.addEventListener('click', grid.handleRightSideCharEmitterClick);
            // Listen for key input during draw mode (only for the left grid)
            (0, $71235d8e4bbe5195$export$f6644f0f2c90144b).on('draw:keyInput', ({ char: char, shift: shift })=>{
                if (side !== 'left') return;
                if (!char || char.length !== 1) return;
                if (!(0, $2093d872f7790fd3$export$2e2bcd8739ae039).MATRIX_CHARS.includes(char)) return;
                // Ignore Shift+key global replace functionality (feature removed)
                if (shift) return;
                let changedCount = 0;
                if (shift) {
                    // Replace ALL characters with the pressed key
                    for(let y = 0; y < grid.rowCount; y++)for(let x = 0; x < grid.columnCount; x++){
                        const cell = grid.cells[y]?.[x];
                        if (!cell) continue;
                        cell.startTransition(char, 1.0, (0, $2093d872f7790fd3$export$2e2bcd8739ae039).CLICK_TRANSITION_DURATION);
                        changedCount++;
                    }
                    grid.needsRender = true;
                    if (changedCount > 0) (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug(`[DrawKey] (SHIFT) Replaced entire grid with '${char}'`);
                } else {
                    // Original behaviour: only replace underscore placeholders
                    for(let y = 0; y < grid.rowCount; y++)for(let x = 0; x < grid.columnCount; x++){
                        const cell = grid.cells[y]?.[x];
                        if (cell && cell.char === '_') {
                            cell.startTransition(char, 1.0, (0, $2093d872f7790fd3$export$2e2bcd8739ae039).CLICK_TRANSITION_DURATION);
                            changedCount++;
                            grid.needsRender = true;
                        }
                    }
                    if (changedCount > 0) (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug(`[DrawKey] Changed ${changedCount} '_' to '${char}'`);
                }
            });
            // Use ResizeObserver to reliably trigger grid redraws AFTER the container's size has changed.
            const resizeObserver = new ResizeObserver(()=>{
                grid.resize();
                grid.needsRender = true;
            });
            resizeObserver.observe(sideBox);
            grid.resizeObserver = resizeObserver; // Store for cleanup
            // Listen for the draw mode toggle
            (0, $71235d8e4bbe5195$export$f6644f0f2c90144b).on('draw:state', ({ active: active })=>{
                if (active) {
                    // Disable random changes during draw mode for the left grid
                    if (side === 'left') grid.randomEnabled = false;
                    if (side === 'left') {
                        // Prepare clip-path reveal: compute column steps and inject CSS vars
                        // Compute starting clip so original box width stays visible
                        const initialRatio = boxWidth / window.innerWidth;
                        const clipStart = Math.max(0, 100 - initialRatio * 100);
                        const colSteps = Math.max(1, Math.round(window.innerWidth / (0, $2093d872f7790fd3$export$2e2bcd8739ae039).CHAR_WIDTH));
                        sideBox.style.setProperty('--draw-col-steps', colSteps);
                        sideBox.style.setProperty('--draw-clip-start', `${clipStart}%`);
                        sideBox.style.setProperty('--draw-expand-duration', '2s');
                        // Ensure full width immediately, animation handled by clip-path
                        sideBox.style.width = '';
                        // Trigger animation
                        sideBox.classList.add('reveal-columns');
                    }
                } else {
                    // Re-enable random changes when exiting draw mode
                    if (side === 'left') {
                        grid.randomEnabled = true;
                        // Reset timers to avoid an immediate change after re-enable
                        grid.lastGlobalChangeTime = performance.now();
                        grid.nextGlobalChangeInterval = grid.getRandomChangeInterval();
                    }
                    if (side === 'left') {
                        // Add collapsing class to hide scrollbars during width transition
                        document.body.classList.add('matrix-draw-collapsing');
                        const onTransitionEnd = (e)=>{
                            if (e.propertyName === 'width') {
                                document.body.classList.remove('matrix-draw-collapsing');
                                sideBox.removeEventListener('transitionend', onTransitionEnd);
                            }
                        };
                        sideBox.addEventListener('transitionend', onTransitionEnd);
                        // Restore width based on current window size
                        handleContainerResize();
                        // Remove clip-path reveal class & vars
                        sideBox.classList.remove('reveal-columns');
                        sideBox.style.removeProperty('--draw-col-steps');
                        sideBox.style.removeProperty('--draw-expand-duration');
                        sideBox.style.removeProperty('--draw-clip-start');
                    }
                }
            // The grid's ResizeObserver will automatically trigger a resize and redraw
            // when the container's class changes and its dimensions are updated by the CSS.
            });
            // This function now ONLY handles updating the container's width on window resize.
            const handleContainerResize = ()=>{
                let boxWidth;
                if (side === 'left') {
                    const idealResponsiveWidth = Math.min((0, $2093d872f7790fd3$export$2e2bcd8739ae039).DEFAULT_WIDTH, Math.max(100, window.innerWidth * 0.15));
                    let numCols = Math.floor(idealResponsiveWidth / (0, $2093d872f7790fd3$export$2e2bcd8739ae039).CHAR_WIDTH);
                    boxWidth = Math.max((0, $2093d872f7790fd3$export$2e2bcd8739ae039).CHAR_WIDTH * 5, numCols * (0, $2093d872f7790fd3$export$2e2bcd8739ae039).CHAR_WIDTH);
                    if (boxWidth <= 0) boxWidth = (0, $2093d872f7790fd3$export$2e2bcd8739ae039).CHAR_WIDTH * 2;
                } else boxWidth = (0, $2093d872f7790fd3$export$2e2bcd8739ae039).CHAR_WIDTH * (0, $2093d872f7790fd3$export$2e2bcd8739ae039).RIGHT_SIDE_COLUMNS;
                // Set the width on the container, which the ResizeObserver will then detect.
                sideBox.style.width = `${boxWidth}px`;
                document.documentElement.style.setProperty(`--${side}-animation-width`, `${boxWidth}px`);
            };
            window.addEventListener('resize', handleContainerResize);
            // TODO: Add theme change listener if needed, e.g., eventBus.on('theme:change', () => grid.needsRender = true);
            handleContainerResize(); // Initial call to set dimensions and potentially CSS vars via debounced call
            grid.start();
        // Basic cleanup
        // window.addEventListener('unload', () => { // This might be too late or not always fire
        //     grid.stop();
        //     window.removeEventListener('resize', handleResize);
        // });
        // A more robust cleanup might be needed if these animations are dynamically added/removed multiple times.
        };
        // Create the sidebars. The function now handles adding them to the DOM.
        createSide('left');
        createSide('right');
        (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug('Simple Matrix Animation setup complete for both sides.');
    }
};
var $d5439305d9c28222$export$2e2bcd8739ae039 = $d5439305d9c28222$var$SimpleMatrixAnimation;


/**
 * Theme Switcher
 * A clean implementation for switching between light and dark themes
 * with proper support for our custom terminal implementation
 */ 


class $d8a5cd7304126fae$var$ThemeSwitcher {
    constructor(){
        this.initialized = false;
        this.terminalInstance = null;
    }
    /**
   * Initialize the theme switcher
   */ init() {
        if (this.initialized) return;
        // Set up event listeners
        this.setupEventListeners();
        // Initialize with the current theme
        this.applyCurrentTheme();
        this.initialized = true;
        (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug('[ThemeSwitcher] Initialized');
    }
    /**
   * Set up event listeners for theme switching
   */ setupEventListeners() {
        // Listen for theme toggle button clicks
        const themeToggle = document.getElementById('theme-toggle');
        if (themeToggle) themeToggle.addEventListener('click', ()=>this.toggleTheme());
        const mobileLogo = document.getElementById('mobile-logo');
        if (mobileLogo) mobileLogo.addEventListener('click', ()=>this.toggleTheme());
        // Listen for terminal creation to store the instance
        (0, $71235d8e4bbe5195$export$f6644f0f2c90144b).on('terminal:created', (terminal)=>{
            this.terminalInstance = terminal;
            this.applyThemeToTerminal((0, $9a59af7bf3cb6c08$export$2e2bcd8739ae039).getCurrentTheme());
        });
        // Listen for theme changes from other sources
        (0, $71235d8e4bbe5195$export$f6644f0f2c90144b).on('theme:changed', (themeName)=>{
            this.applyThemeToTerminal(themeName);
        });
    }
    /**
   * Toggle between themes (dark → light → custom → dark)
   */ toggleTheme() {
        const newTheme = (0, $9a59af7bf3cb6c08$export$2e2bcd8739ae039).toggleTheme();
        (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug(`[ThemeSwitcher] Toggled theme to: ${newTheme}`);
    }
    /**
   * Apply the current theme from ThemeManager
   */ applyCurrentTheme() {
        const themeName = (0, $9a59af7bf3cb6c08$export$2e2bcd8739ae039).getCurrentTheme();
        this.applyThemeToTerminal(themeName);
    }
    /**
   * Apply a theme to the terminal instance by refreshing it.
   * This is called when the theme changes to ensure the terminal view
   * correctly re-renders with the new theme's CSS variables.
   * @param {string} themeName - The name of the theme being applied
   */ applyThemeToTerminal(themeName) {
        if (!this.terminalInstance) {
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug('[ThemeSwitcher] Terminal instance not available yet for theme apply.');
            return;
        }
        // The theme styles are applied to the body by ThemeManager.
        // We just need to refresh the terminal so it can re-calculate its layout
        // and re-render with the new CSS variables.
        if (this.terminalInstance.refresh) {
            this.terminalInstance.refresh();
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).debug(`[ThemeSwitcher] Refreshed terminal to apply theme: ${themeName}`);
        }
    }
}
// Create and export singleton instance
const $d8a5cd7304126fae$var$themeSwitcher = new $d8a5cd7304126fae$var$ThemeSwitcher();
var $d8a5cd7304126fae$export$2e2bcd8739ae039 = $d8a5cd7304126fae$var$themeSwitcher;


/**
 * Theme utility functions
 * 
 * Provides theme-related utility functions and forwards to ThemeManager
 */ 



const $e4f206afeae6df26$var$ThemeUtils = {
    /**
   * Update all theme-dependent SVGs
   */ updateAllThemeSVGs () {
        const currentThemeName = (0, $9a59af7bf3cb6c08$export$2e2bcd8739ae039).getCurrentTheme();
        // Get colors from CSS variables (works for all theme types)
        const style = getComputedStyle(document.documentElement);
        const bgColor = style.getPropertyValue('--color-svg-background').trim() || (currentThemeName === 'dark' ? '#000000' : '#393a96');
        const textColor = style.getPropertyValue('--color-svg-text').trim() || (currentThemeName === 'dark' ? '#80e3c3' : '#FFB7B2');
        document.querySelectorAll('img.theme-svg').forEach((img)=>{
            // Use indices if available, else parse pair
            let indices = null;
            if (img.dataset.indices) try {
                indices = JSON.parse(img.dataset.indices);
                if (!Array.isArray(indices)) indices = null;
            } catch (e) {
                (0, $9bb4c1574855072f$export$2e2bcd8739ae039).warn('Invalid indices data:', img.dataset.indices);
            }
            try {
                // Generate new SVG with the correct theme
                const pair = (0, $64b3bad3a7873ae0$export$2e2bcd8739ae039).getRandomCharPair(indices);
                const svg = (0, $64b3bad3a7873ae0$export$2e2bcd8739ae039).generateCircleSVG(pair, {
                    bgColor: bgColor,
                    textColor: textColor
                });
                if (svg) img.src = 'data:image/svg+xml;utf8,' + encodeURIComponent(svg);
            } catch (e) {
                (0, $9bb4c1574855072f$export$2e2bcd8739ae039).error('Error generating theme SVG:', e);
            }
        });
        // Emit event that SVGs have been updated
        (0, $71235d8e4bbe5195$export$f6644f0f2c90144b).emit('theme:svgsUpdated');
    },
    /**
   * Initialize event listener for theme changes to update SVGs.
   * This should be called after ThemeManager.init().
   */ initThemeSVGUpdates () {
        (0, $71235d8e4bbe5195$export$f6644f0f2c90144b).on('theme:changed', ()=>this.updateAllThemeSVGs());
        this.updateAllThemeSVGs(); // Initial update
    }
};
var $e4f206afeae6df26$export$2e2bcd8739ae039 = $e4f206afeae6df26$var$ThemeUtils;






/**
 * Animates the text of the music player buttons with a rolling effect.
 *
 * @param {HTMLElement} playerElement - The music player container element.
 */ function $cf534b52b8af9395$export$1a3a8f28db71f20d(playerElement) {
    const buttons = playerElement.querySelectorAll('.button-group button');
    const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const stagger = 60; // ms between starts
    const rollCount = 12;
    const interval = 60; // ms per roll
    buttons.forEach((button)=>{
        const originalText = button.textContent;
        const chars = originalText.split('');
        button.textContent = ''; // Clear existing text
        const spans = chars.map((char)=>{
            const span = document.createElement('span');
            span.dataset.final = char;
            span.textContent = '';
            button.appendChild(span);
            return span;
        });
        const promises = spans.map((span, idx)=>new Promise((resolve)=>{
                setTimeout(()=>{
                    let rolls = 0;
                    const timer = setInterval(()=>{
                        if (rolls < rollCount) {
                            span.textContent = letters.charAt(Math.floor(Math.random() * letters.length));
                            rolls++;
                        } else {
                            clearInterval(timer);
                            span.textContent = span.dataset.final;
                            resolve();
                        }
                    }, interval);
                }, idx * stagger);
            }));
        Promise.all(promises).then(()=>{
        // Animation complete
        });
    });
}


let $4736bce7aab25fb0$var$soundcloudWidget;
let $4736bce7aab25fb0$var$currentVolume = 50;
const $4736bce7aab25fb0$var$playlist = [
    // --- START: EDIT YOUR PLAYLIST HERE ---
    {
        url: 'https://soundcloud.com/leather-and-lace/funami-fm',
        title: 'Funami FM',
        type: 'soundcloud'
    },
    {
        url: 'https://soundcloud.com/moskalus/premiere-alder-basalt-tripalium-corp',
        title: 'Alder - Basalt',
        startTime: 4,
        type: 'soundcloud'
    },
    {
        url: 'https://soundcloud.com/urbanstghetto/dj-freelancer-6666alxsf-remix',
        title: '6666 - ALXSF Remix',
        type: 'soundcloud'
    },
    {
        url: 'https://soundcloud.com/twoshell/everybody-worldwide-1',
        title: 'Everybody Worldwide - Two Shell',
        type: 'soundcloud'
    },
    {
        url: 'https://soundcloud.com/woodland-creatures-label/02-deadseankennedy-business-and-my-bread-2',
        title: 'Deadseankennedy - Business and my Bread',
        type: 'soundcloud'
    },
    {
        url: 'https://soundcloud.com/hypno_groove/premiere-connor-byrne-fierce-deity-kouncil-cuts',
        title: 'Fierce',
        type: 'soundcloud'
    },
    {
        url: 'https://soundcloud.com/hyperboloid/pixelord-nft-acid',
        title: 'Pixelord - NFT Acid',
        type: 'soundcloud'
    }
];
let $4736bce7aab25fb0$var$currentTrackIndex = 0;
// Helper function to update song information display
function $4736bce7aab25fb0$var$updateSongInfo(title, url) {
    const songInfo = document.getElementById('song-info');
    if (songInfo) {
        if (title) {
            songInfo.innerHTML = `<a href="${url}" target="_blank">${title}</a>`;
            songInfo.style.display = 'block';
        } else songInfo.style.display = 'none';
    }
}
// Function to stop the player
function $4736bce7aab25fb0$var$stopPlayer() {
    if ($4736bce7aab25fb0$var$soundcloudWidget && typeof $4736bce7aab25fb0$var$soundcloudWidget.pause === 'function') $4736bce7aab25fb0$var$soundcloudWidget.pause();
}
// Function to load and switch tracks
function $4736bce7aab25fb0$var$loadTrack(track, shouldPlayImmediately = true) {
    $4736bce7aab25fb0$var$stopPlayer();
    const { url: url, title: title } = track;
    $4736bce7aab25fb0$var$updateSongInfo(title, url);
    // All tracks are SoundCloud now
    const soundcloudPlayerIframe = document.getElementById('soundcloud-player');
    if (!$4736bce7aab25fb0$var$soundcloudWidget) {
        $4736bce7aab25fb0$var$soundcloudWidget = SC.Widget(soundcloudPlayerIframe);
        $4736bce7aab25fb0$var$soundcloudWidget.bind(SC.Widget.Events.ERROR, (err)=>{
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).error('SoundCloud Widget Error:', err);
            (0, $ef86cbf648d80cf0$export$2e2bcd8739ae039).write({
                text: 'Error with SoundCloud player.',
                className: "terminal-error"
            });
            (0, $4c14fafc46b0fd8d$export$2e2bcd8739ae039).createInputLine();
        });
        $4736bce7aab25fb0$var$soundcloudWidget.bind(SC.Widget.Events.READY, ()=>{
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).info('SoundCloud Widget is ready.');
            $4736bce7aab25fb0$var$soundcloudWidget.setVolume($4736bce7aab25fb0$var$currentVolume);
            $4736bce7aab25fb0$var$soundcloudWidget.load(url, {
                auto_play: shouldPlayImmediately,
                callback: ()=>{
                    if (track.startTime) $4736bce7aab25fb0$var$soundcloudWidget.seekTo(track.startTime * 1000);
                }
            });
        });
    } else $4736bce7aab25fb0$var$soundcloudWidget.load(url, {
        auto_play: shouldPlayImmediately,
        callback: ()=>{
            if (track.startTime) $4736bce7aab25fb0$var$soundcloudWidget.seekTo(track.startTime * 1000);
        }
    });
}
function $4736bce7aab25fb0$export$615f39bf0c97a0af() {
    const soundcloudPlayerIframe = document.getElementById('soundcloud-player');
    const prevBtn = document.getElementById('prev-btn');
    const playBtn = document.getElementById('play-btn');
    const stopBtn = document.getElementById('stop-btn');
    const nextBtn = document.getElementById('next-btn');
    const volumeUpBtn = document.getElementById('volume-up-btn');
    const volumeDownBtn = document.getElementById('volume-down-btn');
    if (!soundcloudPlayerIframe || !prevBtn || !playBtn || !stopBtn || !nextBtn || !volumeUpBtn || !volumeDownBtn) {
        (0, $9bb4c1574855072f$export$2e2bcd8739ae039).error('Music player UI elements not found.');
        return;
    }
    // Helper functions for playlist navigation
    function playNextTrack() {
        $4736bce7aab25fb0$var$currentTrackIndex = ($4736bce7aab25fb0$var$currentTrackIndex + 1) % $4736bce7aab25fb0$var$playlist.length;
        $4736bce7aab25fb0$var$loadTrack($4736bce7aab25fb0$var$playlist[$4736bce7aab25fb0$var$currentTrackIndex]);
    }
    function playPreviousTrack() {
        $4736bce7aab25fb0$var$currentTrackIndex = ($4736bce7aab25fb0$var$currentTrackIndex - 1 + $4736bce7aab25fb0$var$playlist.length) % $4736bce7aab25fb0$var$playlist.length;
        $4736bce7aab25fb0$var$loadTrack($4736bce7aab25fb0$var$playlist[$4736bce7aab25fb0$var$currentTrackIndex]);
    }
    // Event Listeners for player controls
    playBtn.addEventListener('click', ()=>{
        if (!(0, $acb8da174982c98b$export$2e2bcd8739ae039).isAuthenticated) {
            (0, $ef86cbf648d80cf0$export$2e2bcd8739ae039).write({
                text: "Please unlock the terminal to access Funami FM.",
                className: "terminal-error"
            });
            (0, $4c14fafc46b0fd8d$export$2e2bcd8739ae039).createInputLine();
            return;
        }
        playCurrentTrack();
    });
    stopBtn.addEventListener('click', ()=>{
        if (!(0, $acb8da174982c98b$export$2e2bcd8739ae039).isAuthenticated) return;
        $4736bce7aab25fb0$var$stopPlayer();
    });
    nextBtn.addEventListener('click', ()=>{
        if (!(0, $acb8da174982c98b$export$2e2bcd8739ae039).isAuthenticated) return;
        playNextTrack();
    });
    prevBtn.addEventListener('click', ()=>{
        if (!(0, $acb8da174982c98b$export$2e2bcd8739ae039).isAuthenticated) return;
        playPreviousTrack();
    });
    volumeUpBtn.addEventListener('click', ()=>{
        if (!(0, $acb8da174982c98b$export$2e2bcd8739ae039).isAuthenticated) {
            (0, $ef86cbf648d80cf0$export$2e2bcd8739ae039).write({
                text: "Please unlock the terminal to access Funami FM.",
                className: "terminal-error"
            });
            (0, $4c14fafc46b0fd8d$export$2e2bcd8739ae039).createInputLine();
            return;
        }
        $4736bce7aab25fb0$var$currentVolume = Math.min(100, $4736bce7aab25fb0$var$currentVolume + 10);
        if ($4736bce7aab25fb0$var$soundcloudWidget) $4736bce7aab25fb0$var$soundcloudWidget.setVolume($4736bce7aab25fb0$var$currentVolume);
    });
    volumeDownBtn.addEventListener('click', ()=>{
        if (!(0, $acb8da174982c98b$export$2e2bcd8739ae039).isAuthenticated) {
            (0, $ef86cbf648d80cf0$export$2e2bcd8739ae039).write({
                text: "Please unlock the terminal to access Funami FM.",
                className: "terminal-error"
            });
            (0, $4c14fafc46b0fd8d$export$2e2bcd8739ae039).createInputLine();
            return;
        }
        $4736bce7aab25fb0$var$currentVolume = Math.max(0, $4736bce7aab25fb0$var$currentVolume - 10);
        if ($4736bce7aab25fb0$var$soundcloudWidget) $4736bce7aab25fb0$var$soundcloudWidget.setVolume($4736bce7aab25fb0$var$currentVolume);
    });
    // Function to toggle player visibility
    function togglePlayerVisibility() {
        const playerContainer = document.getElementById('music-player-container');
        if (playerContainer) {
            const isVisible = playerContainer.style.display !== 'none';
            playerContainer.style.display = isVisible ? 'none' : 'flex';
            if (!isVisible) (0, $cf534b52b8af9395$export$1a3a8f28db71f20d)(playerContainer);
            return !isVisible;
        }
        return false;
    }
    function playCurrentTrack() {
        if (!$4736bce7aab25fb0$var$soundcloudWidget) {
            $4736bce7aab25fb0$var$loadTrack($4736bce7aab25fb0$var$playlist[$4736bce7aab25fb0$var$currentTrackIndex], true);
            return;
        }
        $4736bce7aab25fb0$var$soundcloudWidget.play();
        $4736bce7aab25fb0$var$updateSongInfo($4736bce7aab25fb0$var$playlist[$4736bce7aab25fb0$var$currentTrackIndex].title, $4736bce7aab25fb0$var$playlist[$4736bce7aab25fb0$var$currentTrackIndex].url);
    }
    function stopMusic() {
        $4736bce7aab25fb0$var$stopPlayer();
    }
    function setVolume(volume) {
        $4736bce7aab25fb0$var$currentVolume = Math.max(0, Math.min(100, volume));
        if ($4736bce7aab25fb0$var$soundcloudWidget && typeof $4736bce7aab25fb0$var$soundcloudWidget.setVolume === 'function') $4736bce7aab25fb0$var$soundcloudWidget.setVolume($4736bce7aab25fb0$var$currentVolume);
    }
    // Expose functions for external use
    window.musicPlayer = {
        loadTrack: $4736bce7aab25fb0$var$loadTrack,
        toggleVisibility: togglePlayerVisibility,
        playNextTrack: playNextTrack,
        playPreviousTrack: playPreviousTrack,
        playCurrentTrack: playCurrentTrack,
        stop: stopMusic,
        setVolume: setVolume,
        getPlaylist: ()=>$4736bce7aab25fb0$var$playlist,
        getCurrentTrackInfo: ()=>{
            const track = $4736bce7aab25fb0$var$playlist[$4736bce7aab25fb0$var$currentTrackIndex];
            // SoundCloud status is hard to get synchronously, so this is an approximation
            return {
                track: track,
                index: $4736bce7aab25fb0$var$currentTrackIndex,
                status: $4736bce7aab25fb0$var$soundcloudWidget ? 'Ready' : 'Stopped',
                volume: $4736bce7aab25fb0$var$currentVolume
            };
        }
    };
}


/**
 * Mobile Animation Utility
 * 
 * Reuses the terminal's line-by-line animation logic for mobile view
 */ class $1a30588d30d09512$var$MobileAnimation {
    constructor(){
        // Use the same timing constants as terminal
        this.LINE_ANIMATION_BASE_DELAY_MS = 40;
        this.LINE_ANIMATION_VARIATION_MS = 20;
        this.MINIMUM_LINE_DELAY_MS = 15;
        // Spinner animation (same as web3 commands)
        this.spinnerFrames = [
            "\u280B",
            "\u2819",
            "\u2839",
            "\u2838",
            "\u283C",
            "\u2834",
            "\u2826",
            "\u2827",
            "\u2807",
            "\u280F"
        ];
        this.spinnerInterval = null;
        this.spinnerFrameIndex = 0;
        // Run-control flags to avoid layout shifts on incidental resize events
        this.hasAnimated = false;
        this.lastIsMobile = null;
        // Mobile content
        this.mobileContent = [
            'techno_punks terminal v0.8.1',
            '---------------------------',
            '',
            'WELCOME, VIBE-HACKER',
            '',
            'Join the post-AGI survivor club where techno_punks coding the future:',
            'terminal frontend + web3 + AI',
            '',
            '/// GENESIS SPECS',
            '# network: Hyperliquid EVM',
            '# supply: 5,184, ERC721',
            '# format: onchain SVGs',
            '# DIY protocol: ACTIVE',
            '',
            '$ MINT: TBA',
            '$ No whitelists. No VCs. Pure rebellion.',
            '',
            '[SYSTEM_NOTICE]:',
            'Terminal access: desktop only.',
            'Switch to hack in! //',
            '',
            'follow the vibe: @squattedaccount',
            'the future is collaborative_',
            ''
        ];
    }
    /**
   * Pauses for a short, slightly randomized duration to simulate terminal typewriter effect
   * (Same logic as terminal-view.js)
   * @private
   */ _pauseBetweenLines() {
        const delay = this.LINE_ANIMATION_BASE_DELAY_MS + Math.random() * this.LINE_ANIMATION_VARIATION_MS - this.LINE_ANIMATION_VARIATION_MS / 2;
        const finalDelay = Math.max(this.MINIMUM_LINE_DELAY_MS, delay);
        return new Promise((resolve)=>setTimeout(resolve, finalDelay));
    }
    /**
   * Add a static line to the mobile container
   * @param {string} content - Line content
   * @param {HTMLElement} container - Target container
   * @private
   */ _addStaticLine(content, container) {
        const lineElement = document.createElement('div');
        lineElement.className = 'mobile-line';
        if (content === '') lineElement.innerHTML = '&nbsp;'; // Empty line with space
        else if (content.startsWith('the future is collaborative')) {
            lineElement.textContent = content.slice(0, -1) + ' ';
            const cursor = document.createElement('span');
            cursor.className = 'blinking-cursor';
            cursor.textContent = '_';
            lineElement.appendChild(cursor);
        } else lineElement.textContent = content;
        container.appendChild(lineElement);
    }
    /**
   * Animate content with spinner initialization
   * @param {HTMLElement} container - Target container
   */ async animateContent(container) {
        if (!container) return;
        // Clear any existing content
        container.innerHTML = '';
        // Step 1: Show spinner for 2 seconds
        const spinnerLine = this.startSpinner(container);
        await new Promise((resolve)=>setTimeout(resolve, 2000));
        // Step 2: Stop spinner
        this.stopSpinner();
        // Step 3: Replace spinner line with the first line of content
        spinnerLine.textContent = this.mobileContent[0];
        // Animate the rest of the lines
        for(let i = 1; i < this.mobileContent.length; i++){
            const line = this.mobileContent[i];
            this._addStaticLine(line, container);
            // Add delay between lines (except for the last line)
            if (i < this.mobileContent.length - 1) await this._pauseBetweenLines();
        }
    }
    /**
   * Start spinner animation for initialization
   * @param {HTMLElement} container - Target container
   * @param {string} message - Spinner message
   */ startSpinner(container, message = '[INITIALIZING MOBILE VIEW]') {
        const spinnerLine = document.createElement('div');
        spinnerLine.className = 'mobile-line spinner-line';
        container.appendChild(spinnerLine);
        this.spinnerInterval = setInterval(()=>{
            const frame = this.spinnerFrames[this.spinnerFrameIndex];
            this.spinnerFrameIndex = (this.spinnerFrameIndex + 1) % this.spinnerFrames.length;
            spinnerLine.textContent = `${message} ${frame}`;
        }, 80);
        return spinnerLine;
    }
    /**
   * Stop spinner animation
   */ stopSpinner() {
        if (this.spinnerInterval) {
            clearInterval(this.spinnerInterval);
            this.spinnerInterval = null;
        }
    }
    /**
   * Check if we're on a mobile device based on screen width
   */ isMobileDevice() {
        return window.innerWidth <= 768;
    }
    /**
   * Initialize mobile animation when mobile view becomes visible
   */ init() {
        const mobileAbout = document.getElementById('mobile-about');
        if (!mobileAbout) return;
        // Check if we're on mobile immediately
        this.lastIsMobile = this.isMobileDevice();
        if (this.lastIsMobile && !this.hasAnimated) // Small delay to ensure DOM is ready
        setTimeout(()=>{
            this.animateContent(mobileAbout);
            this.hasAnimated = true;
        }, 100);
        // Also listen for window resize in case user switches to mobile view
        let resizeTimeout;
        window.addEventListener('resize', ()=>{
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(()=>{
                const isMobile = this.isMobileDevice();
                // Only animate when crossing from non-mobile to mobile for the first time
                if (isMobile && this.lastIsMobile === false && !this.hasAnimated) {
                    this.animateContent(mobileAbout);
                    this.hasAnimated = true;
                }
                this.lastIsMobile = isMobile;
            }, 250);
        });
    }
}
// Create singleton instance
const $1a30588d30d09512$var$mobileAnimation = new $1a30588d30d09512$var$MobileAnimation();
var $1a30588d30d09512$export$2e2bcd8739ae039 = $1a30588d30d09512$var$mobileAnimation;


/**
 * The main application controller.
 * This class ensures a deterministic initialization sequence,
 * preventing race conditions.
 */ class $f987a40b6fa9f724$var$App {
    constructor(){
        this.isInitialized = false;
    }
    /**
   * Initializes all application systems in the correct order.
   */ async init() {
        if (this.isInitialized) {
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).warn('Application already initialized.');
            return;
        }
        (0, $9bb4c1574855072f$export$2e2bcd8739ae039).info('Application initialization sequence started.');
        try {
            // 1. Initialize i18n and wait for it to be ready.
            await (0, $7949ccdcb80a1a11$export$2e2bcd8739ae039).init();
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).info('i18n system initialized.');
            // 2. Initialize commands. They can now safely use i18n.
            (0, $0808c24ea45aa105$export$e221c030e056eb5e)();
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).info('Commands initialized.');
            // 3. Initialize the Terminal UI.
            (0, $ef86cbf648d80cf0$export$2e2bcd8739ae039).initialize();
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).info('Terminal UI initialized.');
            // 4. Initialize UI components that depend on the terminal.
            (0, $9a59af7bf3cb6c08$export$2e2bcd8739ae039).init();
            (0, $e4f206afeae6df26$export$2e2bcd8739ae039).initThemeSVGUpdates();
            (0, $d8a5cd7304126fae$export$2e2bcd8739ae039).init();
            (0, $d5439305d9c28222$export$2e2bcd8739ae039).create();
            // 5. Initialize the Music Player.
            (0, $4736bce7aab25fb0$export$615f39bf0c97a0af)();
            // 6. Initialize mobile animation.
            (0, $1a30588d30d09512$export$2e2bcd8739ae039).init();
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).info('UI components initialized.');
            this.isInitialized = true;
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).info('Application initialization sequence finished successfully.');
        } catch (error) {
            (0, $9bb4c1574855072f$export$2e2bcd8739ae039).error('CRITICAL: Application failed to initialize.', error);
            document.body.innerHTML = '<div class="critical-error-message">Critical Application Error. See console for details.</div>';
        }
    }
}
const $f987a40b6fa9f724$var$app = new $f987a40b6fa9f724$var$App();
var $f987a40b6fa9f724$export$2e2bcd8739ae039 = $f987a40b6fa9f724$var$app;


/**
 * Main entry point for the application.
 * This function is called when the DOM is ready.
 */ document.addEventListener('DOMContentLoaded', ()=>{
    (0, $f987a40b6fa9f724$export$2e2bcd8739ae039).init();
});


//# sourceMappingURL=repo.676b55e3.js.map
